const home = {
  SECTION_AFILIADO_TITLE: 'Aumente sua renda sendo um afiliado Sebraeplace.',
  SECTION_AFILIADO_ALT: 'Banner seja um afiliado Sebraeplace',
  KNOW_MORES: 'Saiba mais',
  SECTION_AFILIADO_DESC:
    'Se cadastre no programa de afiliados e ganhe dinheiro recebendo comissões de venda de produtos e soluções disponíveis no Sebraeplace. Quanto mais você vende, mais recebe. Sem riscos! Só depende de você!',
  WANTING_BEING_AFFILIATED: 'Quero ser afiliado',
  HOME_HOMOLOGADO__TITLE: 'Seja um fornecedor do Sebraeplace agora mesmo.',
  HOME_HOMOLOGADO__DESC: 'Veja as opções de serviços disponíveis.',
  HOME_HOMOLOGADO_SECTION_1__TITLE: 'Como ser um fornecedor do Sebraeplace',
  HOME_HOMOLOGADO_SECTION_1__DESC:
    'Ser um fornecedor do Sebraeplace é muito simples, veja abaixo as vantagens e como fazer parte.',
  HOME_HOMOLOGADO_SECTION_1_CARD_1__TITLE:
    'Porque se tornar um fornecedor do Sebraeplace?',
  HOME_HOMOLOGADO_SECTION_1_CARD_1__DESC_1:
    'Participe da maior plataforma digital de soluções para empresas do Brasil fomentada pelo Sebrae.',
  HOME_HOMOLOGADO_SECTION_1_CARD_1__DESC_2:
    'Amplie sua visibilidade e captação de clientes e vendas. Receba o selo Conexão Certificada Sebrae para utilizar na divulgação da sua empresa.',
  HOME_HOMOLOGADO_SECTION_1_CARD_1__DESC_3:
    'Venda de forma prática e segura em um ambiente totalmente digital.',
  HOME_HOMOLOGADO_SECTION_1_CARD_2__TITLE:
    'O que posso vender pelo Sebraeplace?',
  HOME_HOMOLOGADO_SECTION_1_CARD_2__DESC_1:
    'Depois de cadastrar sua empresa você pode prestar serviços de: ',
  HOME_HOMOLOGADO_SECTION_1_CARD_2__DESC_2:
    '• Consultoria em diversas áreas e especialidades;',
  HOME_HOMOLOGADO_SECTION_1_CARD_2__DESC_3:
    '• Ministrar cursos e palestras presenciais;',
  HOME_HOMOLOGADO_SECTION_1_CARD_2__DESC_4:
    '• Disponibilizar Soluções Inteligentes para auxiliar empresas e empreendedores em seus processos.',
  HOME_HOMOLOGADO_SECTION_1_CARD_3__TITLE:
    'Tem algum custo para ser fornecedor Sebraeplace?',
  HOME_HOMOLOGADO_SECTION_1_CARD_3__DESC_1:
    'Para ser fornecedor Sebraeplace você deve aderir a um Plano de Assinatura mensal que melhor se enquadre com sua atuação. Todos possuem um período de gratuidade. Aproveite!',
  HOME_HOMOLOGADO_SECTION_1_CARD_3__DESC_2:
    'A cada produto ou serviço vendido, o Sebraeplace é comissionado em 10%.',
  HOME_HOMOLOGADO_SECTION_2__TITLE: 'O que falam sobre nós',
  HOME_HOMOLOGADO_SECTION_2__DESC: 'Não fique de fora desse grupo',
  HOME_HOMOLOGADO_SECTION_3__TITLE: 'Quero me tornar um fornecedor Sebraeplace',
  HOME_HOMOLOGADO_SECTION_3__DESC:
    'Faça parte de uma plataforma que vai escalar seu trabalho para um outro nível.',
  HOME_HOMOLOGADO_SECTION_4__TITLE: 'Dúvidas mais frequentes',
  HOME_HOMOLOGADO_SECTION_4__DESC:
    'Está com dúvidas? Consulte aqui as dúvidas mais frequentes e faça parte!',
  HOME_HOMOLOGADO_SECTION_6__TITLE:
    'Analise o plano que melhor se encaixa em seu perfil',
  HOME_HOMOLOGADO_SECTION_6__DESC:
    'A opção de assinatura é habilitada após ao menos um produto homologado.',
  HOME_HOMOLOGADO_SECTION_7__TITLE: 'Promoção exclusiva de lançamento!',
  HOME_HOMOLOGADO_SECTION_7__DESC:
    'Você pode testar a plataforma Sebraeplace e só então aderir ao plano.',
  START_NOW: 'Comece agora',
  PRESENTIAL_COURSES: 'Cursos presenciais',
  SEBRAEPLACE: 'Sebraeplace',
  SEBRAEPLACE_HOME: 'Sebraeplace,',
  HOME_TITLE_1: ' o',
  HOME_TITLE_2: ' marketplace',
  HOME_TITLE_3: ' de soluções para o seu negócio',
  HOME_SUBTITLE:
    'As melhores soluções, o melhor preço. Contrate de forma fácil e segura com a curadoria do Sebrae',
  HOME_BANNER_ALT: 'Banner Sebraeplace',
  BANNER_ALT: 'Banner ',
  AVATAR_ALT: 'Avatar ',
  IMAGE_ALT: 'Imagem ',
  ICON_ALT: 'Ícone ',
  LOGO_ALT: 'Logo ',
  PRODUCT_IMAGE_ALT: 'Imagem do Produto ',
  ROLL_DOWN_ICON_ALT: 'Ícone role para baixo',
  ROLL_UP_ICON_ALT: 'Ícone role para cima',
  IMAGE_GALLERY_ALT: 'Galeria de Imagens - ',
  DESCRIPTIVE_LAYOUT_ALT: 'Imagem Layout Descritivo - ',
  COMPACT_LAYOUT_ALT: 'Imagem Layout Compacto - ',
  CURRENT_IMAGE_ALT: 'Imagem atual da galeria',
  SEARCH: 'Buscar',
  WANT: 'Quero',
  CONSULTANCY: 'consultoria',
  WANT_CONSULTANCY: 'Consultoria',
  UPON_COMPLETION_REGISTRATION_CONSULTANCY:
    'Ao concluir o cadastro, o anúncio passará por homologação antes de se tornar público.',
  KEEP_THE_REGISTER_CONSULTANCY: 'Continuar cadastro',
  SEE_PREVIEW_CONSULTANCY: 'Ver prévia do anúncio',
  HOME_PRODUTOS_TITLE:
    'Escolha a modalidade de produto ou serviço que deseja cadastrar',
  I_WANT_CONSULTANCY: 'Quero\nConsultoria',
  I_WANT_DIGITAL_SOLUTIONS: 'Quero\nSoluções inteligentes',
  I_WANT_ONLINE_COURSE: 'Quero\nCursos online',
  SEBRAETEC: 'Sebraetec',
  I_WANT_SEBRAETEC: 'Quero\nSebraetec',
  SOON: 'Em breve',
  TYPE_WHAT_YOU_NEED: 'O que você busca?',
  UNDERSTAND_HOW_IT_WORKS: 'Saiba como funciona em 3 passos',
  SCROLL_TO_LEARN_MORE: 'Role para saber mais',
  HOME_SECTION_2_SUBTITLE_1:
    'Sabemos que o dia a dia do empreendedor é puxado e o tempo para fazer tudo é escasso. Pensando nisso criamos o Sebraeplace, um espaço que conecta você aos melhores profissionais, cursos, capacitações, produtos e soluções para melhorar ainda mais sua empresa.',
  HOME_SECTION_2_SUBTITLE_2: 'Veja como é fácil!',
  HOME_SECTION_1_CARD_1_TITLE: 'Busque o que precisa',
  STEP_1: 'Passo 1',
  STEP_2: 'Passo 2',
  STEP_3: 'Passo 3',
  HOME_SECTION_1_CARD_1_SUBTITLE:
    'Comece escolhendo entre as opções ofertadas nos quadros acima. Ou ainda, digite o que precisa na busca que o sistema traz todas as opções disponíveis para você. Ainda não sabe muito bem o que precisa? Não tem problema, nossa equipe de atendimento está pronta pra ajudar, é só clicar no chat de atendimento e falar com a gente.',
  HOME_SECTION_1_CARD_2_TITLE:
    'Escolha a solução que melhor atende sua necessidade',
  HOME_SECTION_1_CARD_2_SUBTITLE:
    'Navegue à vontade entre as opções oferecidas. Analise, compare, converse e escolha aquela solução ou profissional que melhor atende sua necessidade. Cria sua conta e gerencie todas as suas escolhas e compras em seu painel.',
  HOME_SECTION_1_CARD_3_TITLE: 'Compre seu serviço',
  HOME_SECTION_1_CARD_3_SUBTITLE:
    'Após escolher a melhor opção para você, realize a compra aqui mesmo no Sebraeplace. Basta escolher pagar com cartão ou boleto bancário, nas opções de pagamento disponíveis em sua negociação. Depois de confirmado seu pagamento é só executar a solução e pronto.',
  SOLUTIONS_WITH_SEBRAE_CURATORSHIP:
    'Soluções com a curadoria e a chancela do Sebrae',
  SOLUTIONS_WITH_SEBRAE_CURATORSHIP_SUBTITLE:
    'O Sebrae não é o fornecedor das soluções aqui apresentadas, mas cuida de todo o processo, desde a seleção, homologação das empresas, profissionais e soluções disponibilizadas e está à sua disposição a qualquer momento para lhe atender aqui mesmo pelo Sebraeplace. É fácil, é rápido e seguro.',
  KNOW_MORE: 'Saiba mais',
  YOU_MIGHT_LIKE: 'Você pode gostar',
  HOME_SECTION_2_CARD_1_TITLE: 'Garantia de qualidade',
  HOME_SECTION_2_CARD_1_SUBTITLE_1:
    'Todas as soluções foram selecionadas e homologadas pelo ',
  HOME_SECTION_2_CARD_1_SUBTITLE_2:
    ', que também já negociou as melhores condições para você.',
  HOME_SECTION_2_CARD_2_TITLE: 'Segurança, do início ao fim',
  HOME_SECTION_2_CARD_2_SUBTITLE_1: 'Você pode acionar o ',
  HOME_SECTION_2_CARD_2_SUBTITLE_2:
    ' a qualquer momento para ter a garantia de segurança do serviço prestado.',
  HOME_SECTION_2_CARD_3_TITLE: 'Pague como preferir',
  HOME_SECTION_2_CARD_3_SUBTITLE_1:
    'Realize o pagamento sempre pelo Sebraeplace com boleto ou cartão de crédito à vista ou em até 6x.',
  HOME_SECTION_2_CARD_3_SUBTITLE_2: ' *Consulte as condições',
  HOME_SECTION_2_CARD_4_TITLE: 'Saiba como funciona o Sebraeplace',
  HOME_SECTION_2_CARD_4_SUBTITLE:
    'É muito simples! Escolha o tipo de serviço que deseja, navegue entre as opções apresentadas , analise, converse, compare e contrate. Se tiver alguma dúvida, nossa equipe está sempre à postos, é só clicar no ícone de atendimento ali embaixo.',
  HOME_SECTION_2_CARD_5_TITLE: 'Cadastre-se agora no ',
  MOST_WANTED: 'Os mais procurados',
  ENTREPRENEURSHIP: 'Empreendedorismo',
  PLANNING: 'Planejamento',
  FINANCES: 'Finanças',
  MARKET_AND_SALES: 'Mercado e vendas',
  INNOVATION: 'Inovação',
  COOPERATION: 'Cooperação',
  PEOPLE: 'Pessoas',
  ORGANIZATION: 'Organização',
  LAWS_AND_STANDARDS: 'Leis e normas',
  HOME_SECTION_3_TITLE: 'Conheça a avaliação de quem já utiliza',
  HOME_SECTION_3_SUBTITLE: 'Nossos clientes podem garantir essa experiência',
  HOME_SECTION_4_TITLE: 'Pronto para turbinar o seu negócio?',
  HOME_SECTION_4_SUBTITLE:
    'Não perca mais tempo! Aqui você acha o melhor para a sua empresa. Crie sua conta e navegue em um mundo de soluções para o seu sucesso!',
  CREATE_YOUR_ACCOUNT: 'Crie sua conta',
  RELEVANT_PROFESSIONALS: 'Profissionais em Destaque',
  HOME_SECTION_5_TITLE: 'Seja fornecedor no Sebraeplace!',
  HOME_SECTION_5_SUBTITLE:
    'Sua empresa faz consultoria, realiza capacitações ou tem uma solução fantástica para outras empresas? Faça seu cadastro e participe da maior vitrine de soluções para negócios do Brasil',
  CATEGORY_NOT_COVERED_BY_YOUR_PLAN: 'Categoria não coberta pelo seu plano',
  I_WANT_TO_BE_SUPPLIER: 'Quero ser fornecedor',
  ONLINE_COURSES_HOME_INFO:
    'Comece a vender seu curso online criando seções, aulas e atividades práticas. Basta desenvolver o tema, gravar os vídeos e cadastrar o conteúdo do curso! Você terá acesso a um painel de controle para acompanhar as vendas, alunos, promoções e muito mais!',
  CONSULTANCY_HOME_INFO:
    'Disponibilize seus serviços de consultorias, divulgue, negocie, realize propostas e feche vendas com a segurança do recebimento pelos serviços prestados. Clique aqui e seja um Consultor Sebraeplace!',
  SAAS_HOME_INFO:
    'Se sua empresa possui um produto, um serviço, um processo, um software, uma plataforma, aplicativo ou solução que ajude outras empresas a melhorarem cada vez mais seus negócios, cadastre aqui. São duas formas de participar nesse módulo: uma vitrine para captação de leads para sua empresa ou com integração de plataformas SAAS. Conheça e não perca a oportunidade de ampliar ainda mais seus canais de venda!',
  SEBRAETEC_HOME_INFO:
    'O Sebraetec é um programa desenvolvido pelo Sebrae com o objetivo garantir ao seu público-alvo o acesso a serviços tecnológicos para inovação, promovendo a melhoria de processos, produtos e serviços ou da introdução de inovações nas empresas e mercados. Em sintonia com esse propósito, abrimos uma nova porta para que você possa oferecer seus serviços através do programa Sebraetec, utilizando a plataforma do Sebraeplace. Para mais informações e para se integrar a essa iniciativa transformadora, acesse os links abaixo.',
  COURSE_PRESENCIAL_EVENTS_CARD_HOME_INFO:
    'Cadastre no Sebraeplace seus cursos, palestras, workshops, oficinas ou eventos PRESENCIAIS para a rede de Licenciados do Sebrae que contratarão seus serviços para disponibilizarem nas suas regiões. Disponibilize, receba propostas, negocie, combine e feche propostas pela plataforma e tenha a segurança de recebimento pelos serviços prestados. Clique aqui e amplie sua capacidade de vendas!',
  BE_A_SUPPLIER_HOME_INFO:
    'Sua empresa faz consultoria, realiza capacitações ou tem uma solução fantástica para outras empresas? Conheça todas as modalidades disponíveis, faça seu cadastro e participe da maior vitrine de soluções para negócios do Brasil.',
  LEARN_ABOUT_OUR_SOLUTIONS: 'Conheça nossas soluções',
  SUGGESTIONS_TO_YOU: 'Sugestões para você',
  ONLINE_COURSES_TITLE: 'Cursos online',
  COURSE_PRESENCIAL_EVENTS_CARD: 'Cursos e eventos presenciais',
  HOUR: 'hora',
  YOU_ARE_SUPPLIER: 'Você é um fornecedor',
  YOU_ARE_AFFILIATE: 'Você é um afiliado',
  YOU_ARE_CLIENT: 'Você é um cliente',
  GO_TO_ACCOUNT: 'Acessar minha conta',
  CUSTOMIZED_TECHNOLOGICAL_SOLUTINS_FOR_YOUR_BUSINESS:
    'Soluções tecnológicas personalizadas para o seu negócio'
};

const painel = {
  QUESTIONS_AND_ANSWERS: 'Perguntas & Respostas',
  TOTAL_PRODUCTS: 'Total de produtos',
  CLOSED_DEALS: 'Negócios Fechados',
  GENERAL_VIEW: 'Visão Geral',
  SEE_ALL_PLURAL: 'Ver todos',
  SEE_ALL_NEGOTIATIONS: 'Ver todas',
  FINANCIAL: 'Financeiro',
  YOUR_EVENTS: 'Seus eventos',
  YOUR_PRODUCTS: 'Seus produtos',
  LAST_NEGOTIATIONS: 'Negociações em andamento',
  YOUR_PLAN: 'Você possui o Plano',
  VALIDATE_AT: 'Válido até:',
  SELECT_A_PLAN: 'Selecionar um plano',
  PROVIDE_A_SEBRAETEC_SOLUTION: 'Atender uma Solução Sebraetec',
  NEW_PRODUCT: 'Novo Produto',
  NEW_PRODUCT_OR_SERVICE: 'Novo produto ou serviço',
  PENDENCIES: 'Pendências',
  ALL_NEGOTIATIONS: 'Todas negociações',
  YOU_DONT_HAVE_NEGOTIATIONS: 'Você ainda não possui negociações',
  YOU_DONT_HAVE_NEGOTIATIONS_DESC:
    'Aguarde seu cadastro ser aprovado para usufruir de todos os benefícios de ser um fornecedor Sebraeplace',
  WAIT_FOR_YOUR_REGISTRATION:
    'Aguarde seu cadastro ser aprovado para usufruir de todos os benefícios de ser um fornecedor Sebraeplace',
  YOU_DO_NOT_HAVE_ANY_LINKS: 'Você ainda não gerou links',
  YOU_DO_NOT_HAVE_ANY_LINKS_DESC_1:
    'Aqui você poderá acompanhar os acessos e conversões dos links divulgados.',
  YOU_DO_NOT_HAVE_ANY_LINKS_DESC_2: 'Não perca tempo, comece agora mesmo!',
  YOU_DONT_HAVE_PLANS: 'Você não possui nenhum plano',
  SEND_NEW_INVITATION: 'Enviar novo convite',
  YOU_HAVE_NO_MOVEMENTS_YET: 'Você ainda não possui movimentações',
  YOU_HAVE_NO_MOVEMENTS_YET_DESC:
    'Aqui estarão listadas as comissões sobre as vendas dos links que você gerar.',
  YOU_DO_NOT_HAVE_ANY_EVENTS_YET: 'Você ainda não possui eventos',
  YOU_DO_NOT_HAVE_ANY_PRODUCTS_YET: 'Você ainda não possui produtos',
  YOU_DO_NOT_HAVE_ANY_CHANNELS: 'Você ainda não possui canais de divulgacao',
  LAST_BUDGETS: 'Orçamentos em andamento',
  PENDING_PRODUCTS: 'Produtos pendentes',
  CONSULTING_CARRIED_OUT: 'Consultorias Executadas',
  INFORMATION_PENDING_EXECUTION:
    'Atenção: A execução desta consultoria será confirmada automaticamente após 7 dias da data final prevista.',
  MY_CART: 'Meu carrinho',
  SEE_CART: 'Ver carrinho',
  NEXT_EVENT: 'Próximo evento',
  SUPPLIER_TERM_HAVE_CHANGED: 'O termo de uso do fornecedor mudou',
  PENDING_REGISTRATION: 'Cadastro em homologação',
  SEE_TICKETS: 'Ver ingressos',
  SEARCH_EVENTS: 'Buscar eventos',
  PROFESSIONALS: 'Profisionais',
  AMOUNT_SHOWN_HERE_CUSTOMER:
    'O valor apresentado aqui refere-se ao valor cobrado do cliente.',
  AMOUNT_SUPPLIER_WILL_RECEIVE:
    'O valor que você fornecedor irá receber sobre esta transação possuirá descontos de taxas conforme descrito abaixo:',
  AMOUNT_SUPPLIER_WILL_RECEIVE_AFFILIATE:
    'O valor que você afiliado irá receber sobre esta transação possuirá descontos de taxas conforme descrito abaixo:',
  ALL_TRANSACTIONS_MADER_HAVE_BASIC_FEE:
    'Todas as transações efetuadas no Sebraeplace terão uma taxa básica por transação de R$ 0,70 mais um taxa específica do meio de pagamento (boleto ou cartão de crédito)',
  FEE_FOR_PAYMENT_BOLETO: 'Taxa para pagamento em Boleto',
  BY_BOLETO_PAID: 'Por boleto pago:',
  VALUE_BY_BOLETO_PAID: 'R$ 1,98 + R$ 0,70',
  FEE_FOR_PAYMENT_CREDIT_CARD: 'Taxa para pagamento em Cartão de Credito',
  IN_CASH: 'À Vista:',
  VALUE_IN_CASH: '2,51% + R$ 0,70',
  INSTALLMENT: 'Parcelado: ',
  INSTALLMENT_2X_6X: 'Parcelado em 2x a 6x:',
  VALUE_INSTALLMENT_2X_6X: '3,21% + R$ 0,70',
  INSTALLMENT_7X_12X: 'Parcelado em 7x a 12x:',
  VALUE_INSTALLMENT_7X_12X: '3,55% + R$ 0,70',
  SEARCH_SUPPLIERS: 'Buscar Fornecedores',
  PRODUCT_WAITING_HOMOLOGATION: 'Produto aguardando homologacao',
  PRODUCT_WAITING_HOMOLOGATION_DESC:
    'Aguarde! Em breve o produto ficará disponível no catálogo em substituição ao produto aprovado, após validação do Sebraeplace.',
  DESCRIPTION_OF_THE_TOTAL_VALUE_OF_THE_LICENSEE:
    'Este valor indica o quanto a empresa já faturou no Sebraeplace. Este valor contempla a soma do valor sacado, valor pendente e saldo disponível.',
  DESCRIPTION_OF_THE_TOTAL_PLANNED_OF_THE_LICENSEE:
    'Valor disponível para saque em conta bancária. Os saques são realizados automaticamente no 5º dia cada mês para a conta bancária empresarial cadastrada no menu Carteira. Este valor irá zerar a cada vez que for realizado o saque automático.',
  DESCRIPTION_OF_THE_PENDING_VALUE_OF_THE_LICENSEE:
    'Valor total de vendas realizadas em que os valores a receber ainda estão pendentes de liberação. A liberação pode depender da efetiva execução do serviço,  da emissão de Nota fiscal para o cliente e do prazo da operadora de pagamentos. O prazo de liberação da operadora de pagamentos é de 30 dias após a data do pagamento.',
  DESCRIPTION_OF_THE_TOTAL_WITHDRAWN_OF_THE_LICENSEE:
    'Valor total já depositado automaticamente na conta bancária da empresa.',
  INVITE: 'Convite',
  RESEND_INVITE: 'Reenviar convite',
  FILL_FIELD_NEW_PROFESSIONAL:
    'Preencha os campos a seguir com as informações solicitadas para convidar um novo profissional, logo após, clique em “Enviar”.',
  EMAIL_TO_SEND_INVITATION: 'Email para envio do convite',
  CPF_PROFESSIONAL_INVITED: 'CPF do profissional convidado',
  YOU_STILL_DONT_HAVE_TICKETS: 'Você ainda não possui ingressos',
  HERE_YOUR_TICKET_WILL_APPEAR_WHEN:
    'Aqui irá aparecer o seu ingresso quando você se inscrever em um evento',
  YOUR_INVITATION_SUCCESSFULLY_SENT: 'Seu convite foi enviado com sucesso',
  YOU_WILL_RECEIVE_NOTIFICATION_BY_EMAIL:
    'Você receberá uma notificação por e-mail assim que o convite for aceito pelo profissional ou acompanhe a atualização do convite no menu Profissionais no seu painel.',
  AMOUNT_REFERRING_TO_PROFESSIONAL:
    'O valor referente a assinatura do profissional será calculado proporcionalmente aos dias utilizados no mês vigente, a partir do momento que o convite for aceito pelo profissional e será adicionado a próxima fatura do seu cartão.',
  PROFILE_INVITE: 'Perfil',
  LAST_PURCHASE: 'Última compra',
  MESSAGE_INVITE: 'Mensagem ',
  MESSAGE_INVITE_OPTIONAL: '(Opcional)',
  SEND_MESSAGE_TO_PROFESSIONAL: 'Envie uma mensagem ao profissional',
  I_WANT_TO_MAKE_THIS_PREVIEW_COURSE:
    'Quero disponibilizar esse vídeo como prévia do curso'
};

const cadastro = {
  PENDING_SEBRAEPLACE_SERVICES:
    'Para participar dos Serviços de Marketing de Afiliados e Cupons, aceite os termos de uso',
  SERVICES_SEBRAEPLACE: 'Serviços Sebraeplace',
  MARKETING_AFFILIATE_CUPONS:
    'Marketing de Afiliados e Cupons de desconto Sebraeplace',
  MARKETING_AFFILIATE_CUPONS_P1:
    'Você como fornecedor pode optar ou não por esses serviços a mais. Eles não são obrigatórios. Você pode fazer a opção a cada produto, esse serviço pode ser ativado ou desativado a qualquer momento na tela de configurações do produto.',
  MARKETING_AFFILIATE_CUPONS_P2:
    ' Você poderá optar por contar com esse serviço para escalar suas vendas. Nossos afiliados poderão indicar o seu produto através de um link gerado pelo Sebraeplace, iremos monitorar os cliques e conversões da página divulgada. Aproveite mais esse benefício!',
  MARKETING_AFFILIATE_CUPONS_P3:
    ' Ao aceitar participar dos cupons lançados no Sebraeplace, o desconto no valor do seu produto será calculado e ativado automaticamente, estes descontos limitam-se a ',
  MARKETING_AFFILIATE_CUPONS_P4:
    'Esse serviço é comissionado, mas não se preocupe! Você pagará comissão apenas sobre vendas realizadas. Você pode ativar e desativar essa funcionalidade a qualquer momento na aba Produtos.',
  REGISTER_CAPACITATION_TITLE: 'Cadastro de capacitação presencial',
  CONSULTANCY_REGISTRATION: 'Cadastro de consultoria',
  SAAS_REGISTRATION: 'Cadastro de Solução Inteligente',
  REGISTER_START: 'Iniciar cadastro',
  WHY_BE_A_SEBRAE_SUPPLIER: 'Por que ser um fornecedor Sebraeplace?',
  WHY_BE_A_SEBRAE_SUPPLIER_REASON_01:
    'Participe da maior plataforma digital de soluções para empresas do Brasil fomentada pelo Sebrae.',
  WHY_BE_A_SEBRAE_SUPPLIER_REASON_02:
    'Exponencie sua visibilidade e captação de clientes e vendas para milhares de prospects.',
  WHY_BE_A_SEBRAE_SUPPLIER_REASON_03:
    'Receba o selo Conexão Certificada Sebrae para utilizar na divulgação da sua empresa.',
  WHY_BE_A_SEBRAE_SUPPLIER_REASON_04:
    'Venda de forma prática e segura em um ambiente totalmente digital.',
  I_WANT_TO_BE_A_SEBRAE_PLACE_SUPPLIER: 'Quero ser um fornecedor Sebraeplace',
  REGISTER_ANOTHER_PRODUCT: 'Cadastrar outro produto ou serviço',
  REGISTER_CONSULTING: 'Cadastro de consultoria',
  GO_TO_HOME: 'Seguir para página inicial',
  REGISTER_OF: 'Cadastro de',
  CONSULTING_TITLE: 'consultoria',
  REGISTER_PRODUCT_CONTINUE_MODAL:
    'Selecione o produto que você deseja continuar cadastrando',
  REGISTER_CONSULTING_CONTINUE_MODAL:
    'Selecione a consultoria que você deseja continuar cadastrando',
  REGISTER_CONSULTING_CONTINUE_:
    'Você está continuando o cadastro da consultoria:',
  PRODUCT_NAME: 'Nome do Produto:',
  CONSULTING_NAME: 'Nome da Consultoria:',
  CATEGORY: 'Categoria',
  REPROVE_PRODUCT_MODAL: 'Seu cadastro de produtos possui pendências',
  REPROVE_CONSULTING_MODAL: 'Seu cadastro de consultoria possui pendências',
  CORRECT: 'Corrigir',
  PRODUCT: 'Produto',
  EXPERIENCE: 'Experiência',
  FINISH: 'Finalizar',
  OUR_AFFILIATES_ABLE_TO_INDICATE:
    'Nossos afiliados poderão indicar o seu produto através de um link gerado pelo Sebraeplace, iremos monitorar os cliques e conversões da página divulgada.',
  AFFILIATE_SERVICE_WILL_BE_COMISSION:
    'Esse serviço é comissionado, mas não se preocupe! Você pagará comissão apenas sobre vendas realizadas. Você pode ativar e desativar essa funcionalidade a qualquer momento na aba Produtos.',
  REFERRAL_AND_COMISSION_SERVICE: 'Serviço de indicação e comissões',
  I_AGREE_PAYMENT_COMISSION_AS_WELL:
    'Estou de acordo com o pagamento das comissões, ',
  REFERRING_TO_SERVICE_FUNCTIONALITY:
    'referente a esse serviço caso opte por utilizar essa funcionalidade.',
  READ_THE_TERMS: 'Antes de iniciar leia os alertas a seguir.',
  SELECT_A_CATEGORY: 'Selecione uma categoria',
  SELECT_THE_CATEGORY_OF_YOUR_PRODUCT_THEN_CLICK_CONTINUE:
    'O cadastro é bem simples! Basta seguir os passos. Comece selecionando a categoria do seu produto ou adicione uma outra.',
  YOU_CAN_NAME_THIS_NEW_CATEGORY:
    'Você pode dar um nome para esta nova categoria do seu produto e aperte “Continuar“',
  PREVIOUS: 'Anterior',
  NEXT: 'Próximo',
  WE_ARE_ALMOST_THERE: 'Estamos quase lá!',
  GO_TO_HOME_PAGE: 'Ir para Página Inicial',
  FILL_ALL_INFORMATIONS: 'Preencha todos os dados solicitados.',
  LABEL_SEGMENTOS1: 'Escolha os ',
  LABEL_SEGMENTOS2: ' que sua capacitação presencial se destina:',
  ADD_THE_MAIN_TOPICS:
    'Adicione quais os principais tópicos ou temas que serão tratados no seu produto.',
  IF_YOU_NEED_MATERIALS:
    'Caso você precise de materiais para a realização, como bloco, canetas, crachás, targetas, etc insira aqui.',
  PRICE_YOUR_PRODUCT:
    'Precifique seu produto e lembre que deve ser um valor viável para a venda ao Licenciado Sebraeplace. Especifique também o que está incluso no valor.',
  GIVE_YOUR_PRODUCT_A_FLASHY_NAME:
    'Dê um nome bem chamativo para seu produto, adicione a carga horária e selecione o tema em que ele melhor se encaixa',
  TOTAL_HOURS_MUST_BE_THE_SAME_AS_THE_PLANNED_CLASSES:
    'A carga horária deve ser a mesma informada no Plano de aula,',
  TOTAL_HOURS_MUST_BE_THE_SAME_AS_THE_PLANNED_CLASSES_2:
    ' durante o cadastro dos produtos de capacitação quando houver o campo carga horária.',
  TELL_THE_CUSTOMER_WHAT_TO_EXPECT_FROM_YOUR_PRODUCT:
    'Conte para o cliente o que esperar do seu produto. Mas capriche, isso vai te ajudar a vender ainda mais!',
  PRODUCT_NAME__PLACEHOLDER: 'Nome comercial do seu produto',
  THEME__PLACEHOLDER: 'Selecione um tema',
  PRODUCT_TIME__PLACEHOLDER: 'Carga horária (HH:mm)',
  PRODUCT_VALUE_OFFER: 'Proposta de valor',
  PRODUCT_VALUE_OFFER__PLACEHOLDER:
    'Fale um pouco do seu produto, o que ele se propõe a resolver, como ele vai ajudar o cliente. Venda seu peixe!',
  PRODUCT_RESULT_CLIENT: 'Resultado para o cliente',
  PRODUCT_RESULT_CLIENT__PLACEHOLDER:
    'Escreva aqui quais as vantagens e resultados que o cliente terá em participar do seu produto.',
  PRODUCT_TARGET_PEOPLE: 'Público alvo',
  DEFINE_THE_CONSULTANT_INSTRUCTOR_FOR_THAT_PRODUCT:
    'Defina o consultor/instrutor para esse produto.',
  THE_SELECT_CONSULTANT_INSTRUCTOR_CANNOT_BE_MODIFIED_AFTER_COMPLETING_THE_PRODUCT_REGISTRATION:
    'O consultor/instrutor selecionado não poderá ser modificado depois de concluído o cadastrado do produto.',
  I_AM_THE_CONSULTANT_INSTRUCTOR_FOR_THIS_PRODUCT:
    'Eu sou o consultor/instrutor desse produto.',
  SELECT_ANOTHER_CONSULTANT_INSTRUCTOR_FOR_THAT_PRODUCT:
    'Selecionar outro consultor/instrutor para esse produto.',
  INSERT_A_IMAGE:
    'Insira ou escolha uma imagem que irá aparecer como capa do seu produto no momento da venda. Lembre-se que uma boa imagem ajuda muito a vender!',
  EXAMPLE_YOUR_IMAGE: 'Sua imagem será exibida como nos exemplos a seguir.',
  PRODUCT_PROFILE: 'Perfil do produto',
  PRODUCT_THUMBNAIL: 'Thumbnail do produto',
  CHOOSE_YOUR_IMAGE: 'Escolha a imagem que será exibida na venda',
  CHOOSE_YOUR_IMAGE__SUBTITLE:
    'Escolha uma imagem ou insira uma que possua licença gratuita ou que você tenha direito de uso.',
  IMAGE_MINIMUM_SIZE: 'Tamanho mínimo da imagem: 1420x670',
  LOAD_IMAGE: 'Carregar imagem',
  LOADING_IMAGE: 'Carregando imagem',
  LOAD_VIDEO: 'Carregar vídeo',
  LOADING_VIDEO: 'Carregando vídeo',
  ADD_MAIN_TOPICS: 'Adicionar tópicos principais',
  NECESSITY__PLACEHOLDER:
    'Descreva o que você vai precisa de estrutura física para a realização do seu produto.',
  ADD_MATERIAL: 'Adicionar material',
  WHAT_IS_INCLUDE: 'O que está incluso no preço?',
  UPLOAD_IMAGE_DOING: 'Realizando upload...',
  IT_MAY_STILL_TAKE_A_FEW_MINUTES: 'ainda pode demorar alguns minutos',
  RECORD_A_VIDEO:
    'Estamos quase no final! Mas antes grave um vídeo de no máximo 5 minutos com você falando sobre seu produto e adicione aqui. Esse vídeo vai ficar disponível para o cliente, então capriche! Você pode gravar do seu celular, na horizontal e fundo neutro.',
  VIDEO_MAXIMUM_SIZE: 'Envie vídeos no formato MP4 com no máximo 300MB.',
  PITCH_DESCRIPTION:
    'Pitch é uma apresentação rápida de um produto ou um negócio, com a intenção de "vender" a ideia para investidores, clientes, sócios ou parceiros. Um pitch pode servir para qualquer empresa que precise convencer algum público a acreditar no seu negócio.',
  LOCAL_PARTNER: 'Parceiro Local',
  APPEAR_IN_THE_VIDEO: 'É importante que você apareça no vídeo.',
  UPLOAD_CLICK: 'Clique para fazer upload',
  VIDEO_ON_PHONE: 'Se o vídeo estiver no celular use o QR Code',
  VIDEO_RECEIVED: 'Recebemos o seu video',
  SEND_AGAIN: 'Enviar novamente',
  CHOOSE_TARGET_PEOPLE:
    'Trabalhar com personas te ajuda a conhecer melhor o seu público! Conheça e selecione uma ou mais personas que mais combinem com o seu produto.',
  LEARN_MORE: 'Saiba Mais',
  YOU_CAN_CHOOSE_AFFILIATE_MARKETING:
    'Você poderá optar por contar com o marketing de Afiliados no Sebraeplace para escalar suas vendas. Aproveite mais esse benefício! ',
  MARKETING_AFFILIATE_SEBRAEPLACE: 'Marketing de Afiliados Sebraeplace',
  MARKETING_AFFILIATE_SEBRAEPLACE_SD:
    'Você como fornecedor pode optar ou não por esses serviços a mais. Eles não são obrigatórios. Você pode fazer a opção a cada produto, esse serviço pode ser ativado ou desativado a qualquer momento na tela de configurações do produto.',
  MARKETING_AFFILIATE_CUPOM_SD:
    'Ao aceitar participar dos cupons lançados no Sebraeplace, o desconto no valor do seu produto será calculado e ativado automaticamente, estes descontos limitam-se a ',
  ACTIVATE_AFFILIATE_MARKETING_CUPOM:
    'Quero participar das Campanhas e Cupons de desconto',
  DONT_ACTIVATE_AFFILIATE_MARKETING_CUPOM:
    'Não quero participar das Campanhas e Cupons de desconto',
  WHAT_IS_AFFILIATE_MARKETING: 'O que é marketing de Afiliados?',
  WHAT_IS_AFFILIATE_MARKETING_DESCRIPTION:
    'O marketing de afiliados é um processo no qual pessoas se afiliam em uma plataforma e ganham uma comissão por promover os produtos disponíveis para venda. Essa comissão é paga pelo fornecedor do serviço que ganha um reforço exponencial na divulgação do serviço e consequentemente nas sua vendas. Todos ganham: o fornecedor que amplia sua rede de divulgação, o afiliado que recebe comissão por utilizar sua rede e vender e a plataforma que ajuda a gerar mais vendas.',
  HOW_AFFILIATE_MARKETING_WORK:
    'Como funciona o Marketing de Afiliados no Sebraeplace?',
  SEBRAEPLACE_AFFILIATE_COUPONS: 'Cupons de desconto Sebraeplace',
  HOW_AFFILIATE_MARKETING_WORK_DESCRIPTION:
    'Você como fornecedor pode optar ou não por esse serviço a mais. Ele não é obrigatório. Você pode fazer a opção a cada produto. Nossos afiliados poderão indicar o seu produto através de um link gerado pelo Sebraeplace, iremos monitorar os cliques e conversões da página divulgada. Esse serviço é comissionado, mas não se preocupe! Você pagará comissão apenas sobre vendas realizadas. Você poderá acompanhar a movimentação na sua tela de Extratos. Optando pelo marketing de afiliados, a divulgação dos seus produtos pode ser ampliada.',
  HOW_AFFILIATE_MARKETING_WORK_DESCRIPTION_2:
    'Você como fornecedor pode optar ou não por esse serviço a mais. Ele não é obrigatório. Você pode fazer a opção a cada produto. Ao aceitar participar das promoções lançadas no Sebraeplace, o desconto sobre o valor deste curso será calculado e ativado automaticamente, sobrepondo suas campanhas de desconto ativas. O desconto incide sobre o valor que o fornecedor irá receber.',
  AFILLIATE_COMISSION: 'Comissão do Afiliado',
  AFILLIATE_COMISSION_CONSULTANCY:
    'Comissão do Afiliado nos serviços de Consultoria:',
  AFILLIATE_COMISSION_CONSULTANCY_DESCRIPTION:
    'A comissão é referente a xx% do valor do contrato entre o consultor e o cliente. Só serão contabilizadas vendas convertidas das indicações comissionadas. Havendo indicações e conversões a comissão será cobrada após a conclusão do serviço.',
  AFILLIATE_COMISSION_EVENT:
    'Comissão do Afiliado nos serviços de venda de ingressos de Evento:',
  AFILLIATE_COMISSION_EVENT_DESCRIPTION:
    'A comissão é referente a xx% do valor do ingresso. Só serão contabilizadas vendas convertidas das indicações comissionadas. Havendo indicações e conversões a comissão será cobrada após a conclusão do evento.',
  AFILLIATE_COMISSION_SOLUTION:
    'Comissão do Afiliado nos serviços de assinatura de Solução Inteligente:',
  AFILLIATE_COMISSION_SOLUTION_DESCRIPTION:
    'A comissão é referente a xx% do valor do plano assinado. Só serão contabilizadas vendas convertidas das indicações comissionadas. Havendo indicações e conversões a comissão será cobrada mensalmente enquanto a assinatura permanecer ativa.',
  ACTIVATING_AFFILIATE_MARKETING:
    'Ao ativar o Serviço de Marketing de Afiliados Sebraeplace você  aceita os',
  TERMS_AFFILIATE_MARKETING: 'Termos de uso. ',
  THIS_SERVICE_ACTIVATE_MARKETING_AFFILIATE:
    'Esse serviço pode ser ativado ou desativado a qualquer momento.',
  INDICATE_PEOPLE: 'Indique 3 pessoas que tenham experienciado sua',
  FULLNAME__PLACEHOLDER: 'Nome completo',
  COMPANY__PLACEHOLDER: 'Empresa',
  CELLPHONE: 'Telefone',
  DOWNLOAD_INTEGRATION_STEPS: 'Baixar PDF das Etapas da Integração',
  START_INTEGRATION: 'Iniciar integração',
  INTEGRATION_SAAS: 'Integração da Solução Inteligente',
  STEPS_INTEGRATION: 'Etapas da integração',
  INTEGRATION_DESCRIPTION:
    'Abaixo descrevemos como é realizada a integração da sua Solução Inteligente com o Sebraeplace.',
  INTEGRATION_TEXT_1:
    'Os eventos ocorridos no Sebraeplace gerarão uma chamada de webhook informando sua Solução Inteligente.',
  INTEGRATION_TEXT_2:
    'Está por sua vez deverá realizar as consultas de API do Sebraeplace para averiguação dos dados e confirmação para o Sebraeplace.',
  PREPARE_INTEGRATION: 'Preparar integração',
  DOCUMENTATION_API: 'Documentação da API',
  DOCUMENTATION_WEBHOOKS: 'Documentação dos Webhooks',
  FILL_OUT_SAAS_INTEGRATION:
    'Preencha o formulário para realizar a integração da sua Solução Inteligente com o Sebraeplace.',
  INTEGRATION_TWO_STEPS: 'A integração será feita em 2 etapas',
  INTEGRATION_FIRST_STEP: 'Em ambiente de homologação',
  INTEGRATION_SECOND_STEP: 'Em ambiente de produção',
  TEST_INTEGRATION: 'Testar Integração',
  KEYS: 'Chaves',
  KEYS_TO_USE_API: 'Chaves para usar na integração com a API do Sebraeplace.',
  KEY_TO_APPROVAL: 'Chave para ambiente de Homologação',
  GENERATE_KEY_TO_APPROVAL: 'Gerar chave para homologação',
  KEY_TO_PRODUCTION: 'Chave para ambiente de Produção',
  GENERATE_KEY_TO_PRODUCTION: 'Gerar chave para produção',
  KEYS_INTEGRATION_ALERT:
    'Você deve copiar a chave gerada pois essa informação não será armazenada na nossa base de dados e você precisará dessa informação posteriormente.',
  COPY_KEY: 'Copiar chave',
  COPIED_KEY: 'Chave copiada para área de transferência',
  TEST_INTEGRATION_SAAS: 'Teste da integração da Solução Inteligente',
  TEST_INTEGRATION_DESCRIPTION:
    'Faremos o teste automatizado da integração da sua Solução Inteligente com a API do Sebraeplace.',
  TEST_INTEGRATION_FIRST_STEP: 'Teste em ambiente de homologação.',
  TEST_INTEGRATION_SECOND_STEP: 'Teste em ambiente de produção.',
  INTEGRATION_TESTING: 'Teste da integração',
  INTEGRATION_TEST_SUCCESSSFULLY: 'Teste de Integração realizada com sucesso!',
  INTEGRATION_TEST_SUCCESSSFULLY_MSG:
    'As etapas de teste em ambiente de homologação e produção foram realizadas com sucesso.',
  INTEGRATION_TEST_SUCCESSSFULLY_MSG1:
    'Envie para validação do Sebraeplace e em breve você receberá um e-mail informando o próximo passo.',
  KEEP_TESTING: 'Continuar testando',
  TEST_IN_PRODUCTION: 'Testar em produção',
  SUBMIT_INTEGRATION_APPROVAL: 'Enviar integração para validação',
  INTEGRATION_TESTING_DESCRIPTION:
    'Nesta etapa será criado um cliente fictício que irá assinar um plano aleatório e todas as etapas de integração serão ativadas. Sua integração estará validada caso, ao final do processo, este usuário tenha sua assinatura cancelada com sucesso.',
  TEST_FULL_INTEGRATION: 'Testar integração completa',
  TEST_HOMOLOGATION_DESCRIPTION:
    'Realize o teste de integração em todas as etapas de integração em ambiente de homologação, após o teste ser concluído com sucesso, passe a realiza-lo no ambiente de produção.',
  TEST_PRODUCTION_DESCRIPTION:
    'Para testar as etapas em ambiente de produção é necessário finalizar com sucesso o',
  TEST_PRODUCTION_DESCRIPTION1: 'teste em ambiente de homologação.',
  TEST_HOMOLOGATION: 'Teste em homologação',
  TEST_PRODUCTION: 'Teste em produção',
  NEW_SIGNATURE: 'Nova Assinatura',
  CHANGE_PLAN: 'Mudança de Plano',
  MONTHLY_COLLECTION: 'Cobrança Mensalidade',
  CANCELLATION_RESQUEST: 'Solicitação de Cancelamento',
  WEBHOOK_NEW_SIGNATURE_INFO:
    'Avisa a solução inteligente que existe uma nova assinatura indicando o id dela.',
  GET_NEW_SIGNATURE_INFO: 'Entrega dados detalhados na assinatura.',
  GET_MONTHLY_PAYMENT_INFO:
    'Entrega dados detalhados dos pagamentos de uma assinatura.',
  SEE_DOCUMENTATION: 'Ver documentação',
  CANCEL_UPLOAD: 'Cancelar envio',
  RESET_TEST: 'Reiniciar teste',
  SENDING_WEBHOOK: 'Enviando webhook',
  WAIT_REQUEST_IS_TRIGGERED: 'Aguarde, a requisição está sendo disparada.',
  AWAITING_RETURN: 'Aguardando retorno.',
  POST_INVOICE_INFO:
    'Recebe os arquivos de Nota fiscal de um pagamento específico.',
  POST_ACCESS_DATA_INFO:
    'Recebe os dados de acesso do usuário de uma assinatura.',
  WEBHOOK_CANCELLATION_INFO:
    'Avisa a solução inteligente que uma assinatura solicitou cancelamento.',
  GET_CANCELLATION_INFO:
    'Entrega os dados detalhados da solicitação de cancelamento.',
  POST_CANCELLATION_INFO:
    'Recebe confirmação que a assinatura foi cancelada ou não na solução inteligente.',
  WEBHOOK_CHANGE_PLAN_INFO:
    'Avisa a solução inteligente que existe uma mudança de plano em uma assinatura.',
  GET_CHANGE_PLAN_INFO:
    'Entrega dados detalhados sobre o plano atual e o novo.',
  POST_CHANGE_CONFIRMS_INFO:
    'Recebe confirmação da mudança do plano na solução inteligente.',
  WEBHOOK_MONTHLY_COLLECTION_INFO:
    'Avisa a solução inteligente que foi realizada uma cobrança.',
  RESPOSTA_MONTHLY_COLLECTION_INFO:
    'Solução inteligente é avisada que foi realizada uma cobrança.',
  START_TESTING_PRODUCTION_ENVIRONMENT: 'Iniciar teste em ambiente de produção',
  AUTOMATED_INTEGRATION_TESTING: 'Teste automatizado da integração',
  AUTOMATED_INTEGRATION_TESTING_DESCRIPTION:
    'Sua integração estará validada caso, ao final do processo, este usuário tenha sua assinatura cancelada com sucesso.',
  ACCESS_DATA_SUBMITTED: 'Dados de acesso foram enviados corretamente.',
  INVOICE_SUBMITTED: 'A Nota Fiscal foi enviada corretamente.',
  DATA_SUBMITTED_SUCCESS: 'Dados enviados corretamente.',
  CANCELLATION_SUBMITTED:
    'A confirmação de cancelamento foi enviada corretamente.',
  SENDING_INVOICE: 'Envio de Nota Fiscal',
  CANCELLATION_CONFIRMATION: 'Confirmação de Cancelamento',
  ACCESS_DATA_SUBMITTED_ERRO: 'Os dados de acesso não chegaram em até',
  ACCESS_DATA_SUBMITTED_ERRO1: 'minutos após a solicitação.',
  INVOICE_SUBMITTED_ERRO: 'A Nota Fiscal não chegou em até',
  INVOICE_SUBMITTED_ERRO1: 'minutos após a solicitação.',
  CANCELLATION_SUBMITTED_ERRO:
    'A confirmação de cancelamento não chegou em até',
  CANCELLATION_SUBMITTED_ERRO1: 'minutos após a solicitação.',
  INTEGRATION_OK_UPDATE_HOMOLOGATION:
    'Todas as etapas da integração foram verificadas e validadas em seu ambiente de homologação. Atualize seu ambiente de produção e realize os testes nele.',
  INTEGRATION_OK_PRODUCTION:
    'Todas as etapas da integração foram verificadas e validadas em seu ambiente de homologação e produção.',
  INTEGRATION_OK_PRODUCTION_1:
    'Ao enviar para validação o Sebraeplace irá realizar mais 3 outros testes nas próximas horas para validar a abrangência da integração. Ao final dos testes, se todos ocorrerem com sucesso, você receberá um email informando a disponibilidade da venda do seu produto.',
  MAKE_ADJUSTMENTS_AND_RETEST:
    'Verifique a etapa de integração que não funcionou corretamente, efetue os ajustes e volte a testar.',
  ALL_STEPS_NEED_CHECKED:
    'É necessário que todas as etapas da integração sejam verificadas e validadas.',
  INTEGRATION_FAILED: 'A integração falhou.',
  TIMEOUT_RUN_PROCESS: 'Tempo limite excedido para execução do processo.',
  CORRECT_INTEGRATION: 'Corrigir integração',
  SENT_IN: 'Enviados em',
  DATA_SENT: 'Dados enviados',
  OK_I_GOT_IT: 'Ok, entendi',
  VALIDATED_INTEGRATION: 'Integração validada',
  VALIDATED_INTEGRATION_APPROVED_SEBRAEPLACE:
    'Integração validada e aprovada pelo Sebraeplace!',
  VALIDATED_INTEGRATION_SEND_SEBRAEPLACE:
    'Integração validada e enviada para validação do Sebraeplace!',
  VALIDATED_INTEGRATION_HOMOLOGATION_SUCCESS:
    'A etapa de teste em ambiente de homologação foi realizada com sucesso.',
  SEE_TEST_RESULT: 'Ver resultado do teste.',
  GO_TO_NEXT_STEP_PRODUCTION:
    'Passe para o próximo passo, teste em ambiente de produção.',
  VALIDATED_INTEGRATION_APPROVED:
    'A validação feita pelo Sebraeplace foi realizada com sucesso, por esse motivo os formulários de teste não podem mais sofrer alterações.',
  YOU_CAN_DISCLOSE_AND_SELL:
    'Você pode divulgar e vender sua Solução Inteligente.',
  VALIDATED_INTEGRATION_PRODUCTION_SUCCESS:
    'As etapas de teste em ambiente de homologação e produção foram realizadas com sucesso e enviadas para validação do Sebraeplace, por esse motivo os formulários de teste não podem mais sofrer alterações.',
  SOON_YOU_CAN_DISCLOSE_AND_SELL:
    'Em breve você poderá divulgar e vender sua Solução Inteligente. O Sebraeplace enviará um e-mail informando que seu produto está aprovado e disponível para venda.',
  GO_TO_HOMEPAGE: 'Ir para Página Inicial',
  GO_TO_MY_PRODUCTS: 'Ir para meus produtos',
  PLAN_IDENTIFIER_CODE: 'Código identificador dos planos',
  PLAN_IDENTIFIER_CODE_TEXT:
    'Estes códigos serão a forma de correlacionar os planos cadastrados no Sebraeplace com os planos existentes na sua plataforma.',
  PLAN_IDENTIFIER_CODE_INFO:
    'O código deverá ser simples e correlacionado com o plano da sua Solução Inteligente.',
  DEFINE_THE_CONSULTANT_FOR_THAT_PRODUCT:
    'Defina o consultor para esse produto',
  CODE_FOR_YOUR_IDENTIFICATION: 'Código para sua identificação',
  GRACE_PERIOD_FOR_ARREARS: 'Carência para cobranças recorrentes atrasadas',
  GRACE_PERIOD_FOR_ARREARS_TEXT:
    'Estas etapas ocorrerão periodicamente quando uma cobrança não for realizada com sucesso. O cliente será notificado por e-mail a cada tentativa de cobrança negada.',
  RECURRING_BILLING: 'Cobrança Recorrente',
  HOW_MANY_ATTEMPTS: 'Quantas tentativas de cobrança',
  RANGE_OF_DAYS_ATTEMPT:
    'Selecione o intervalo de dias para realizar a tentativa de cobrança',
  FIRST_CHARGE_ATTEMPT: 'Primeira tentativa de cobrança',
  FIRST_CHARGE_ATTEMPT_TEXT:
    'Será realizada no dia de vencimento do plano assinado.',
  SECOND_CHARGE_ATTEMPT: 'Segunda tentativa de cobrança',
  THIRD_CHARGE_ATTEMPT: 'Terceira tentativa de cobrança',
  THIRD_CHARGE_ATTEMPT_TEXT:
    'O plano assinado pelo cliente será cancelado se a tentativa de cobrança for negativa.',
  ATTEMPT_DENIED_TEXT:
    'A tentativa de cobrança negada irá cancelar a assinatura do cliente.',
  MAKE_ANOTHER_ATTEMPT: 'Realizar nova tentativa de cobrança em',
  DEADLINE_ATTEMPT_DAYS:
    'O prazo limite para uma nova tentativa de cobrança é de 3 dias.',
  REQUEST: 'Resquest',
  RESPONSE: 'Response',
  HEADER: 'Header',
  BODY: 'Body',
  DAY: 'dia',
  DAYS: 'dias',
  ATTEMPT: 'tentativa',
  ATTEMPTS: 'tentativas',
  EXTRA_SUBSCRIBER_INFORMATION: 'Informações extras do assinante',
  REQUEST_EXTRA_FIELDS: 'Caso necessite solicite campos extras ao usuário.',
  REQUEST_EXTRA_FIELDS_SUBSCRIPTION:
    'Estes campos serão solicitados ao assinante quando ele confirmar a assinatura.',
  ADD_EXTRA_FIELD: 'Adicionar campo extra',
  EXTRA_CANCELLATION_INFORMATION: 'Informações extras para cancelamento',
  EXTRA_FIELD: 'Campo extra',
  PROPERTY_NAME: 'Nome da propriedade',
  PROPERTY_NAME_INFO: 'Nome da propriedade na integração',
  PROPERTY_NAME_PLACEHOLDER: 'Nome da propriedade na integração',
  FIELD_NAME: 'Nome do campo',
  FIELD_NAME_INFO: 'Nome do campo mostrado para o usuário',
  FIELD_NAME_PLACEHOLDER: 'Nome do campo mostrado para o usuário',
  FIELD_TYPE: 'Tipo do campo',
  FIELD_TYPE_INFO: 'Tipo do campo na integração',
  FIELD_DESCRIPTION: 'Descrição do campo',
  FIELD_DESCRIPTION_INFO: 'Descrição a ser mostrada ao usuário',
  FIELD_DESCRIPTION_PLACEHOLDER: 'Descrição a ser mostrada ao usuário',
  WEBHOOKS: 'Webhooks',
  WEBHOOKS_TEXT:
    'Estes webhooks serão ativados assim que os eventos forem executados no Sebraeplace. Utilize seu ambiente de homologação antes de preencher com os dados de produção.',
  PRODUCTION: 'Produção',
  URL_NEW_SIGNATURE: 'URL para envio de Nova Assinatura',
  URL_NEW_SIGNATURE_INFO: 'URL para envio do WebHook de Nova Assinatura',
  URL_NEW_SIGNATURE_PLACEHOLDER:
    'https://suasolucaointeligente.com.br/nova-assinatura',
  URL_MONTHLY_CHARGE: 'URL para informação de cobrança de mensalidade',
  URL_MONTHLY_CHARGE_INFO:
    'URL para envio do WebHook de cobrança de mensalidade',
  URL_MONTHLY_CHARGE_PLACEHOLDER:
    'https://suasolucaointeligente.com.br/mensalidade',
  URL_CANCELLATION: 'URL para solicitação de cancelamento',
  URL_CANCELLATION_INFO:
    'URL para envio do WebHook de solicitação de cancelamento',
  URL_CANCELLATION_PLACEHOLDER:
    'https://suasolucaointeligente.com.br/cancelamento',
  URL_PLAN_CHANGE: 'URL para alteração de plano',
  URL_PLAN_CHANGE_INFO: 'URL para envio do WebHook de alteração de plano',
  URL_PLAN_CHANGE_PLACEHOLDER: 'https://suasolucaointeligente.com.br/plano',
  KEY: 'Chave',
  CODE_IDENTIFICATION_WEBHOOK:
    'Código para sua identificação de origem do webhook',
  CODE_IDENTIFICATION_WEBHOOK_INFO:
    'Código da chave para sua identificação de origem do webhook',
  CODE_IDENTIFICATION_WEBHOOK_PLACEHOLDER:
    'Código para sua identificação de origem',
  TEST_INTEGRATION_ERROR_ALERT:
    'É necessário informar todos os campos para prosseguir',
  SELECT: 'Selecione',
  EMAIL_PLACEHOLDER: 'E-mail',
  CONGRATULATIONS: 'Parabéns!',
  PRODUCT_REGISTERED:
    'Seu produto foi cadastrado, e está sob análise da equipe do Sebraeplace, em breve retornaremos.',
  SELECT_AREAS_OF: 'Selecione as áreas de',
  SELECT_A: 'Selecione a ',
  AREA: 'Área',
  AREA_OF: 'tema de',
  AFTER_CLICK: 'logo após clique em',
  YOUR: 'Sua',
  CONSULTING_CREATED:
    'foi criada com sucesso e encontra-se em status análise, aguarde a validação do time Sebraeplace, fique de olho no seu e-mail e no seu painel.',
  SELECT_THE: 'Selecione o',
  SELECT_SPECIALTIES: 'subtema da sua',
  I_WANT_REGISTER_PF: 'Quero me inscrever como Pessoa Física',
  I_WANT_REGISTER_PJ: 'Quero me inscrever como Pessoa Jurídica',
  REGISTER_CONTINUE: 'Continue seu cadastro',
  REGISTER_CONTINUE__TITLE: 'Você está continuando o cadastro:',
  REGISTER_MODAL_NAME: 'Nome: ',
  REGISTER_MODAL_CPF: 'CPF: ',
  STEP: 'Etapa',
  FILL_REGISTER_INDICATE_PEOPLE:
    'Indique três contatos que tenham contratado seus produtos ou serviços. Nossa equipe entrará em contato para as validações. Somente após isso seu cadastro será considerado homologado no Sebraeplace.',
  REFERRAL_SERVICE_AFFILIATE: 'Serviço de indicação por Afiliados Sebraeplace.',
  FILL_REGISTER_INFORMATIONS:
    'Preencha os dados solicitados e clique em “Próximo”.',
  FILL_REGISTER_INFORMATIONS_COMPANY:
    'Agora preencha os dados e anexe os documentos solicitados.',
  FILL_REGISTER_ADDRESS: 'Preencha seu endereço e clique em “Continuar”.',
  FILL_REGISTER_ADDRESS_COMPANY:
    'Preencha o endereço da empresa e aperte “Continuar”.',
  FULLNAME_REQUIRED__PLACEHOLDER: 'Nome Completo (Obrigatório)',
  CPF__PLACEHOLDER: 'CPF',
  BIRTHDAY__PLACEHOLDER: 'Data de Nascimento',
  CELLPHONE__PLACEHOLDER: 'Celular',
  I_ACCEPT: 'Aceito os',
  USE_TERMS: 'termos de uso',
  PLATAFORM: 'da plataforma.',
  I_UNDERSTAND: 'Entendo que devo emitir',
  RECEIPT: 'recibo',
  OF_PAYMENT: 'de pagamento',
  CEP__PLACEHOLDER: 'CEP',
  CITY__PLACEHOLDER: 'Cidade',
  NEIGHBORHOOD__PLACEHOLDER: 'Bairro',
  ADDRESS__PLACEHOLDER: 'Endereço',
  ADDRESS_NUMBER__PLACEHOLDER: 'Número',
  OBS_ADDRESS__PLACEHOLDER: 'Complemento',
  STATE__PLACEHOLDER: 'Estado',
  TITLE__PLACEHOLDER: 'Título',
  URL__PLACEHOLDER: 'url',
  DESCRIPTION__PLACEHOLDER: 'Descrição',
  ALTER_COVER: 'Alterar capa',
  PROFILE_EDIT: 'Edição de perfil',
  BASIC_INFORMATIONS: 'Informações básicas',
  NAME__PLACEHOLDER: 'Nome',
  OCCUPATION__PLACEHOLDER: 'Ocupação',
  ABOUT_ME__PLACEHOLDER:
    'Preenche sua ocupação de forma interessante e direta, como por exemplo: Eu sou um apaixonado por ajudar as pessoas a realizarem seus sonhos e alcançarem seus objetivos. Seja você um empreendedor procurando alavancar seu negócio ou alguém buscando encontrar mais propósito e realização na vida, eu estou aqui para ajudá-lo a traçar um caminho claro e motivador.',
  ADD_PITCH_ABOUT_PRODUCT:
    'Adicione Pitch de no máximo 5 min sobre o seu produto.',
  MAXIMUM_SIZE_200_MB: 'Tamanho máximo de 200 MB.',
  IT_IS_IMPORTANT_YOU_APPEAR_VIDEO: 'É importante que você apareça no vídeo.',
  ENTER_YOUR_WEBSITE_SOCIAL_AND_CLICK:
    'Informe seu site e redes sociais se houver e clique em',
  SITES_AND_SOCIAL_MEDIA: 'Site e Redes Sociais',
  PITCH: 'Pitch',
  COMPANY_INFORMATION: 'Informações da Empresa',
  PERSONAL_INFORMATION: 'Informações Pessoais',
  START_NEW_REGISTER: 'Iniciar novo cadastro',
  SLUG_PLACEHOLDER: 'Slug',
  LOGRADOURO__PLACEHOLDER: 'Logradouro',
  IN_WEB: 'Na web',
  LINK: 'Vincular',
  ABOUT_ME: 'Sobre o profissional',
  WORK_EXPERIENCE: 'Exper. trabalho',
  ADD_WORK_EXPERIENCE: 'Adicionar exper. de trabalho',
  WEB_REFERENCE: 'Referência na Web',
  ADD_WEB_REFERENCE: 'Adicionar Referência na Web',
  CUSTOM_SECTION: 'Seção Personalizada',
  ADD_CUSTOM_SECTION: 'Adicionar Seção Personalizada',
  ADMINISTRATOR: 'Administrador',
  RAZAO_SOCIAL__PLACEHOLDER: 'Razão Social',
  NOME_FANTASIA__PLACEHOLDER: 'Nome Fantasia',
  PHONE__PLACEHOLDER: 'Telefone ou Celular',
  CNPJ_CARD: 'Cartão CNPJ',
  ADD_CNPJ_CARD: 'Adicionar Cartão CNPJ',
  IMAGE_OR_PDF: 'Imagem ou PDF',
  CND_CERTIFICATE: 'Certidão CND',
  FEDERAL_TAX_CERTIFICATE: 'Certidão negativa de tributos federais',
  ADD_FEDERAL_TAX_CERTIFICATE:
    'Adicionar Certidão Negativa de Tributos Federais',
  FGTS_CERTIFICATE: 'Certidão de FGTS',
  FGTS_CERTIFICATE_2: 'Certidão FGTS',
  ADD_FGTS_CERTIFICATE: 'Adicionar Certidão de FGTS',
  INSS_CERTIFICATE: 'Certidão de INSS',
  INSS_CERTIFICATE_2: 'Certidão INSS',
  ADD_INSS_CERTIFICATE: 'Adicionar Certidão de INSS',
  COMPANY_PORTFOLIO: 'Portfólio da empresa',
  ADD_COMPANY_PORTFOLIO: 'Adicionar Portfólio da empresa',
  VIDEO_PITCH_DESCRIPTION:
    'Adicione Pitch de no máximo 5 min sobre o sua empresa, com tamanho máximo de 200MB.',
  ADD_PITCH: 'Adicionar Pitch',
  UPLOAD: 'Upload',
  WEBSITE: 'Site',
  SOCIAL_NETWORK: 'Rede social',
  ABOUT_MY_COMPANY: 'Sobre minha empresa',
  CERTIFICATION: 'Certificação',
  ADD_CERTIFICATION: 'Adicionar certificação',
  YEAR_DATE_MESSAGE: 'Ano término deve ser maior ou igual ao Ano Início.',
  FORMATION__PLACEHOLDER: 'Formação',
  YEAR_BEGIN__PLACEHOLDER: 'Ano início',
  YEAR_END__PLACEHOLDER: 'Ano término',
  ADD_FORMATION: 'Adicionar formação',
  REGISTER_FINISHED:
    'Você cumpriu a primeira etapa, agora cadastre seus produtos e serviços para vender no Sebraeplace.',
  REGISTER_ANOTHER_PRODUCT_REDIRECT: 'Cadastrar produtos ou serviços',
  FOLLOW_TO_PANEL: 'Seguir para o painel',
  YOU_NEED_ACCEPT_TERMS: 'Você precisa aceitar os termos de uso da plataforma',
  WEAK: 'Fraca',
  FAIR: 'Fraca',
  GOOD: 'Média',
  STRONG: 'Forte',
  VERY_STRONG: 'Muito Forte',
  TOO_SHORT: 'Fraca',
  PASSWORD_NOT_MATCH: 'Senhas não conferem',
  PASSWORD_MUST_BE_STRONG: 'A força da senha deve ser pelo menos Média',
  WELCOME_LICENSED: 'Bem-vindo licenciado!',
  CONGRATULATIONS_ACCESS_SEBRAEPLACE:
    'Parabéns pelo seu novo acesso ao Sebraeplace.',
  CONTRACT_PROVIDERS_EVENTS:
    'Por ele você poderá contratar fornecedores e gerenciar seus eventos.',
  ERROR_PASSWORD_TALK_SUPPLIER:
    'Erro ao iniciar processo para recuperar senha. Por favor, entre em contato com o fornecedor',
  SUCCESSFUL_LICENSED_REGISTRATION:
    'Cadastro de licenciado completado com sucesso!',
  LICENSED: 'Licenciado',
  HELLO_LICENSED: 'Olá Licenciado',
  UPLOAD_REQUIRED: 'Envio obrigatório',
  SEBRAE: 'Sebrae',
  CHOOSE_THE: 'Escolha os',
  THE_SEGMENTS: 'Segmentos',
  CONSULTANCY_INTENDED: 'que sua consultoria se destina:',
  FIRST_ACCESS_PLATFORM_CHOOSE_PASSWORD:
    'seja bem-vindo ao seu primeiro acesso à plataforma, escolha sua senha e confirme seu primeiro acesso.',
  CREATE_PASSWORD_ACCESS: 'Crie uma senha de acesso na plataforma',
  CLASS_PLAN_TEXT:
    'Para nos ajudar a entender seu produto, anexe 1 arquivo (pdf ou docx) com o Plano de Aula, Abaixo você encontra o modelo para baixar.',
  ADD_CLASS_PLAN: 'Adicione o seu plano de aula em formato pdf ou docx',
  PLAN_MODEL_PDF: 'Modelo de Plano de Aula.pdf',
  PLAN_MODEL_DOCX: 'Modelo de Plano de Aula.docx',
  PLEASE_COMPLETE_REGISTRATION:
    'Por favor, complete o cadastro e envie para revisão',
  REASON: 'Motivo',
  YOU_HAVE_PENDENCE_REGISTRATION:
    'Você possui cadastro pendente, clique em <0>Continuar cadastro</0> ou <0>Iniciar novo cadastro</0>',
  READ_BEFORE_CONTINUE: 'Antes de iniciar leia e aceite os itens a seguir',
  PRIVATE: 'Pessoais',
  CONSULTANCY_REGISTER: 'Consultoria',
  REGISTER_CONSULTANCY_MODAL:
    'Cadastre sua consultoria, negocie com seus clientes e comece a vender.',
  COURSE_PRESENCIAL_EVENTS_CARD: 'Cursos e eventos presenciais',
  ORGANIZE_EVENTS_CARD:
    'Organize, convide palestrantes, gerencie seus eventos e venda seus ingressos.',
  SOLUTION_CARD: 'Soluções Inteligentes',
  INTEGRATE_YOUR_SOLUTION_CARD:
    'Cadastre sua solução inteligente, crie sua landing page e comece a vender assinaturas. ',
  KNOW_MORE_CARD: 'Saiba mais.',
  START_SELLING_COURSE_CARD:
    'Comece a vender seu curso online criando seções, aulas e atividades práticas. ',
  REGISTRATION_COMPLETE: 'Cadastro Concluído!',
  REGISTER_PRODUCT_SERVICE: 'Cadastrar produto ou serviço',
  REGISTER_PRODUCT_SERVICE_DESC:
    'Cadastre sua consultoria, curso online ou Soluções Inteligentes.',
  RESPOND_SEBRAETEC_SOLUTION: 'Atender a uma Solução Sebraetec',
  RESPOND_SEBRAETEC_SOLUTION_DESC:
    'Vincule sua empresa a um ou mais serviços Sebraetec de acordo com sua área de atuação.',
  RESPOND_SEBRAETEC_SOLUTION_DESC2:
    'Cadastre sua solução Sebraetec de acordo com a área de atuação.',
  FOLLOW_TO_PANEL_DESC:
    'Conheça e acompanhe todas funcionalidades e recursos que preparamos para você.',
  MINIMUM_VALIDITY: 'Validade mínima de {{days}} dias',
  MINIMUM_VALIDITY_DOCUMENT:
    'O documento deve ter uma validade mínima de {{days}} dias',
  INVALID_DATE: 'Data inválida'
};

const alertas = {
  BUY_A_PLAN: 'Por favor, contrate um plano',
  REGISTER_PENDING_APPROVAL:
    'Seu cadastro está em análise, por favor aguarde o término para continuar',
  PENDING_APPROVAL: 'Esperando aprovação do back-office, por favor aguarde',
  UNFINISHED_REGISTER:
    'Seu cadastro  não está concluído, conclua seu cadastro ou troque seu perfil para outro fornecedor.',
  ERROR_STARTING_REGISTER:
    'Erro ao iniciar cadastro de fornecedor, tente novamente.',
  INACTIVE_REGISTER: 'Seu cadastro  está inativo.',
  DISAPPROVED_REGISTER: 'Seu cadastro foi reprovado.',
  REGISTER_PRODUCT_ATTENTION:
    'ATENÇÃO, Leia atentamente as instruções a seguir e clique no check-box se estiver de acordo',
  PRODUCTS_VALIDATION__TITLE: 'Validação de produtos',
  PRODUCTS_VALIDATION__DESC:
    'O produto a ser cadastrado deve ser EXCLUSIVO para venda e aplicação dentro desta plataforma para o Licenciado Sebrae. Não pode ser oferecido, comercializado ou aplicado no mercado ou diretamente para os clientes. Vide termos de uso.',
  PRODUCTS_REGISTER__TITLE: 'Cadastro de produtos',
  PRODUCTS_REGISTER__DESC:
    'Dedique um tempo para cadastrar seu produto. Fique tranquilo! Caso não consiga cadastrar tudo de uma vez, suas informações ficarão salvas para seu retorno por até 15 dias.',
  PRODUCTS_TIME__TITLE: 'Homologação',
  PRODUCTS_TIME__DESC:
    'Seu produto somente ficará disponível para venda após homologação realizada pela equipe de curadoria de produtos do Sebraeplace.',
  PRODUCT_UPLOAD_IMAGE: 'Somente são aceitos arquivos de vídeo.',
  UNCONFIRMED_EMAIL:
    'Para acessar essa área é necessário ter o e-mail confirmado',
  SERVER_ERROR:
    'Estamos com problemas para se comunicar com o servidor, tente novamente mais tarde.',
  YOU_ALREADY_HAD_PF: 'Você já possui pessoa física cadastrada',
  ERROR_CEP: 'Estamos com problemas com a integração do site ViaCEP.',
  ERROR_CEP_INVALID: 'CEP inválido.',
  REGISTER_IMAGE_EXTENSION:
    'As extensões permitidas para a imagem são: jpg, jpeg e png.',
  REGISTER_IMAGE_SIZE: 'O tamanho máximo permitido para imagem é 2MB.',
  PROFILE_SAVE: 'Perfil salvo.',
  USER_NOT_AVAILABLE: 'Nome de usuário não disponível. ',
  CONFIRM_EMAIL:
    'Para finalizar o seu cadastro é necessário que você confirme o seu e-mail. Favor verificar na sua caixa postal o e-mail de confirmação.',
  RESEND_EMAIL_SENT:
    'E-mail de confirmação enviado. Favor verificar na sua caixa postal.',
  RESEND_EMAIL_ERROR:
    'Erro ao enviar e-mail, favor tente novamente mais tarde.',
  SELECT_CREDIT_CARD: 'Por favor, selecione um cartão de crédito',
  PLEASE_SELECT_OPTION: 'Por favor, selecione uma opção',
  SAVE_SUCCESS: 'Salvo com sucesso',
  CONSULTING_VALIDATION__TITLE: 'Não sou MEI',
  CONSULTING_VALIDATION__DESC:
    'Tenho ciência que empresas registradas como MEI (Microemprendedor Individual) não devem prestar serviços de consultoria por seus CNAES não comportarem essa atividade.',
  CONSULTING_REGISTER__TITLE: 'Para uso do Sebraeplace',
  CONSULTING_REGISTER__DESC: 'Aceito os termos de uso do',
  PROVIDER: 'fornecedor',
  USE_TERMS_MODAL: 'Termos de uso',
  READ_AGREE_TERMS: 'Li e concordo com os termos apresentados acima.',
  ERROR_OBTAINING_TERMS: 'Erro ao obter termos de uso. Tente novamente',
  AGREE_MODAL: 'Concordo'
};

const carteira = {
  TOTAL_PROJECTED: 'Total Projetado',
  CARDS: 'Cartões',
  CARD_UTILIZED_PAYMENT: '* Esse cartão será utilizado para pagamentos',
  ADD_CREDIT_CARD: 'Adicionar Cartão De Crédito',
  BANK_ACCOUNT: 'Conta bancária',
  ADD_BANK_ACCOUNT: 'Adicionar conta bancária',
  ADD_BANK_ACCOUNT_PJ: 'Adicionar conta bancária da Pessoa Jurídica cadastrada',
  INSERT_THE_BANK_ACCOUNT_OR_YOUR_COMPANY:
    'Insira a conta bancária da sua empresa',
  BANK_ACCOUNT_UTILIZED_PAYMENT: 'Essa conta será utilizada para recebimentos',
  BANK_ACCOUNT_UTILIZED_PAYMENT_AFFILIATE:
    'Esse conta será utilizada para recebimentos referente aos serviços de Marketing de Afiliado.',
  BANK_ACCOUNT_VALIDATION:
    'A validação da sua conta pode levar até 5 dias úteis. O serviço de geração de links de afiliados será liberada após confirmação da conta.',
  THIS_ACCOUNT_WILL_BE_USED_FOR_THE_RECIEVE_OF_YOUR_SERVICES:
    'Essa conta será utilizada para recebimentos dos serviços prestados',
  MOVEMENTS: 'Movimentações',
  FUTURE_PAYMENTS: 'Pagamentos Futuros',
  FULL_EXTRACT: 'Ver extrato completo',
  CREDIT_CARD: 'Cartão de crédito',
  VALIDITY: 'Validade',
  START_OF_VALIDITY: 'Início da validade',
  END_OF_VALIDITY: 'Fim da validade',
  NAME_LASTNAME: 'NOME E SOBRENOME',
  NAME_LASTNAME_U: 'Nome e sobrenome',
  SELECT_BANK: 'Selecione um banco',
  BANK: 'Banco',
  AGENCY: 'Agência',
  ACCOUNT: 'Conta',
  ADD_ACCOUNT: 'Adicionar conta',
  ADD_CARD: 'Adicionar cartão',
  CARD_NUMBER: 'Número do cartão',
  DUE_DATE: 'Validade MM/AA',
  INVALID_NAME: 'Nome do titular inválido',
  INVALID_CARD_NUMBER: 'Número do cartão inválido',
  INVALID_MONTH_EXPIRY: 'Mês de vencimento inválido',
  INVALID_YEAR_EXPIRY: 'Ano de vencimento inválido',
  INVALID_CARD_EXPIRY: 'Vencimento do cartão inválido',
  CARD_SAVED_CURRENT_BILL:
    '* Seu cartão será salvo, pois a cobrança será recorrente',
  EXCLUDING_ACCOUNT: 'Você está excluindo esta conta',
  NEW_ACCOUNT_BANK: 'Nova conta bancária',
  OWNER_ACCOUNT: 'Titular da conta',
  CPF_ACCOUNT_HOLDER: 'CPF do titular da conta',
  KNOW_MORE_ABOUT_PLAN: 'Saber mais sobre meu plano',
  SURE_EXCLUDE: 'Você tem certeza que gostaria de excluir',
  THE_CARD: 'o cartão',
  CARD: 'cartão',
  THE_ACCOUNT: 'a conta',
  FOLLOW_NEXT: 'a seguir',
  PAYMENT_HAS_BEEN_APPROVED: 'Seu pagamento foi aprovado.',
  PAYMENT_TRIAL_PLAN:
    'A contratação do seu plano foi efetivada. Não se preocupe, não foi realizada nenhuma cobrança em seu cartão neste momento.',
  PAYMENT_HAS_NOT_BEEN_APPROVED: 'Seu pagamento não foi aprovado.',
  KEEP: 'Manter',
  DELETE: 'Excluir',
  MAKE_PAYMENT_LINE_BELOW:
    'Ou realize o pagamento utilizando a linha digitável abaixo',
  CLICK_HERE_TO: 'Clique aqui para fazer o',
  YOUR_BOLETO: 'do seu boleto',
  ACCOUNT_WITHOUT_VERIFYING_DIGIT: 'Conta',
  ACCOUNT_WITH_VERIFYING_DIGIT: 'Conta com dígito verificador',
  ACCOUNT_WITH_MANY_VERIFYING_DIGIT: 'Conta com dígitos verificadores',
  AGENCY_WITH_VERIFYING_DIGIT: 'Agência com digito verificador',
  AGENCY_WITHOUT_VERIFYING_DIGIT: 'Agência sem digito verificador',
  AGENCY_WITH_VERIFYING_DIGIT_X_OR_ZERO:
    'Agência com digito verificador. Poderá ser utilizado "X" ou "0"',
  ACCOUNT_WITH_VERIFYING_DIGIT_PLUS_OPERATION:
    'Formato: Operação + Conta + Digíto',
  ACCOUNT_WITH_VERIFYING_DIGIT_PLUS_OPERATION_PLACEHOLDER: 'XXX99999999-D',
  ACCOUNT_HOLDER_DATA_CONFIRMATION: 'Confirmação de dados do Titular da Conta',
  IDENTITY_DOCUMENT_AND_SELFIE_REQUESTED:
    'Para garantir a segurança do seu cadastro, será necessário enviar um documento de identidade pessoal, podendo ser o RG, CNH ou passaporte e uma selfie do titular da conta.',
  PERSONAL_IDENTITY_DOCUMENT: 'Documento de identidade pessoal',
  ADDRESS_PROOF: 'Comprovante de endereço',
  OPEN_CAMERA: 'Abrir Camera',
  TAKE_NEW_PICTURE: 'Tirar nova foto',
  SELFIE: 'Selfie',
  SELFIE_VERIFICATION_TIP:
    'O envio correto da selfie ajuda a validar sua identidade de forma rápida e segura.',
  FOLLOW_THE_ORIENTATIONS_BELOW: 'Siga as orientações abaixo:',
  SELFIE_FRAMING_REMINDER:
    'Certifique-se de que a foto esteja bem enquadrada e com o rosto visível por completo.',
  SELFIE_LIGHTING_REMINDER:
    'Tire a selfie em um ambiente claro e com boa iluminação.',
  SELFIE_ACESSORIES_WARNING:
    'Não utilize acessórios como óculos de sol, chapéus ou qualquer item que cubra o rosto.',
  INSERT_YOUR_COMPANY_BANK_ACCOUNT:
    'Insira a conta bancária da sua empresa. Essa conta será utilizada para recebimentos dos serviços prestados.',
  COMPANY_FINANCIAL_REPORT: 'Relatório Financeiro da Empresa',
  COMPANY_SOCIAL_CONTRACT: 'Contrato Social da Empresa',
  ACCOUNT_SUCESSFULLY_REGISTRED: 'Conta cadastrada com Sucesso!',
  YOUR_ACCOUNT_WILL_BE_VALIDATED_1:
    'Seu cadastro foi enviado para análise e será revisado pela nossa equipe.',
  YOUR_ACCOUNT_WILL_BE_VALIDATED_2:
    'O processo pode levar até 5 dias úteis para ser concluído.',
  YOUR_ACCOUNT_WILL_BE_VALIDATED_3:
    'Agradecemos pela paciência e estamos trabalhando para validar suas informações o mais rápido possível!',
  GOT_IT: 'Entendi!',
  THE_PROCESS_CAN_TAKE_UP_TO_5_DAYS: 'O processo pode levar até 5 dias úteis.'
};

const dados_cadastrais = {
  REGISTRATION_DATA: 'Dados Cadastrais',
  INFORMATION: 'Informações',
  ADD_NEW_ACCOUNT: 'Adicionar nova conta',
  VIEW_PLANS: 'Visualizar planos',
  YOU_DONT_HAVE_A_PLAN:
    'Você não possui um plano contratado, veja todas as vantagens em contratar um plano.',
  ACCOUNT_PF: 'Conta pessoa física',
  ACCOUNT_PJ: 'Conta pessoa jurídica',
  YOU_ALREADY_HAVE: 'Você já possui o ',
  PLAN_CHANGED_FROM: ' contratado. Este plano será alterado a partir de ',
  QUESTION_VIEW_PLANS: ', deseja visualizar os planos?',
  COMPANY_DATA: 'Dados Empresariais',
  PERSON_DATA: 'Dados Cadastrais',
  MY_DATA: 'Meus Dados',
  MY_DATA_AFILIATE: 'Dados de Afiliado',
  ACCOUNT_DATA: 'Dados da conta',
  CHANGE_PASSWORD: 'Alterar senha',
  CHANGE_EMAIL: 'Alterar email',
  PF_TEXT1:
    'Você poderá compartilhar e vender todos os produtos inclusos no serviço de marketing de afiliado.',
  PF_TEXT2: 'Não é necessário a emissão e envio de nota fiscal.',
  PF_TEXT3_1: 'O saque mensal possui um limite máximo de ',
  PF_TEXT3_2:
    'Não se preocupe, o valor excedente permanecerá como saldo para saques futuros.',
  PJ_TEXT1:
    'Como Pessoa Jurídica você poderá compartilhar e vender todos os produtos inclusos no serviço de marketing de afiliado.',
  PJ_TEXT2:
    ' Você precisará emitir notas fiscais e anexa-las na plataforma Sebraeplace mensalmente.',
  PJ_TEXT3:
    ' O saque mensal é ilimitado. Quanto mais você vender, mais receberá.',
  ERRO_ACCEPT_RECIEVE_SEBRAEPLACE:
    'Erro ao atualizar a permissão de promoções no Sebrae-PR',
  I_ACCEPT_TO_RECIEVE_SEBRAEPLACE_CONTENT:
    'Aceito receber conteúdos e promoções do Sebrae PR'
};

const checkout = {
  SAVED_CARDS: 'Cartões salvos',
  OTHER_WAYS: 'Outros meios',
  NEW_CREDIT_CARD: 'Novo cartão de crédito',
  PURCHASE_SUMMARY: 'Resumo da compra',
  DISCOUNT: 'Desconto',
  WITH_DISCOUNT: 'Com desconto',
  YOU_WILL_PAY: 'Você pagará',
  PAYMENT_BOLETO: 'Pagamento via boleto',
  PAYMENT_PIX: 'Pagamento via pix',
  BOLETO: 'Boleto',
  PIX: 'Pix',
  FOLLOW_STEP_BELOW: 'Siga o passo a passo abaixo:',
  PAYMENT_PIX_STEP_1:
    'Clique em Finalizar compra para gerar o Código de pagamento.',
  PAYMENT_PIX_STEP_2:
    'Depois, é só fazer um Pix no app da sua instituição financeira.',
  PAYMENT_PIX_STEP_3: 'Pronto! Só aguardar a confirmação do pagamento.',
  YOUR_QRCODE_PAYMENT: 'Seu QR Code para pagamento',
  COPIED_QRCODE: 'QRCODE copiado para área de transferência',
  OR_COPY_THE_CODE: 'Ou copie o código',
  COPY_THE_CODE: 'Copie o código',
  COPY_CODE: 'Copiar código',
  REVIEW_CONFIRM_PURCHASE: 'Revise e confirme sua compra',
  PAYMENT_DETAILS: 'Detalhes do pagamento',
  HOW_MANY_TIMES: 'Em quantas vezes?',
  COMPLETE_SECURITY_CODE: 'Complete o seu código de segurança',
  INTEREST_FREE: 'Sem juros',
  RECURRENT: 'Recorrente',
  INTEREST_FREE_PORTION_PAYMENT: 'Até $value$ vezes sem juros',
  INTEREST_FREE_PORTION_VALUE_PAYMENT:
    'Até $portion$ vezes sem juros com parcela mínima de $value$',
  CHANGE: 'Alterar',
  PERSONAL_DATA: 'Dados pessoais',
  REPRESENTATIVE: 'Representante',
  INVOICE_ADRESS: 'Endereço de fatura',
  STREET_0R_AVENUE: 'Rua ou avenida',
  COMPLEMENT_OPTIONAL: 'Complemento (opcional)',
  CONFIRM_PURCHASE: 'Confirmar a compra',
  BACK_TO_PAINEL: 'Voltar para o painel',
  PURCHASE_MADE: 'Compra Efetuada!',
  CONFIRMATION_MESSAGE_EMAIL:
    'Uma mensagem de confirmação foi enviado para seu e-mail. Importante: O ressarcimento integral é feito se o cancelamento for realizado em até 7 dias corridos da data da compra.',
  DONT_HAVE_PAYMENT_DATA: 'Não há dados',
  DONT_HAVE_PAYMENT_DATA_DESC: 'Não foram encontrados dados de pagamento',
  SAVED_CREDIT_CARD: 'Salvar cartão para compras futuras',
  ORDER_NUMBER_MODAL: 'O número do seu pedido é:',
  DISCOUNT_PLAN_INFO:
    'Desconto aplicado relativo a utilização parcial do plano. Esse valor é calculado proporcionalmente ao tempo utilizado na mensalidade referente ao plano vigente até o momento.',
  INFORMATION_FOR_JOINING_THE_DIGITAL_SOLUTION:
    'Informações para adesão da Solução Inteligente',
  FILL_OUT_BELOW_BEFORE_PROCEEDING_TO_THE_PAYMENT_STEP:
    'Preencha abaixo antes de seguir para a etapa de pagamento:',
  PAYMENT_EVENT_DESCRIPTION:
    ' O ingresso foi enviado para o seu e-mail. Caso prefira pode acessar no link abaixo',
  SEE_TICKET: 'Ver ingresso',
  PF: 'Pessoa física',
  PJ: 'Pessoa jurídica',
  PER_MONTH: '/mês',
  NO_CHARGES_WILL_BE_MADE_UNTIL_THE_END_OF_THE_TRIAL_PERIOD:
    'Nenhuma cobrança será feita até o fim do período trial',
  REMOVE_COUPON: 'Remover cupom',
  APPLY_COUPON: 'Aplicar cupom',
  REMOVE_ALL_APPLIED_COUPONS: 'Remover todos os cupons aplicados',
  DISCOUNT_COUPON: 'Cupom de desconto',
  DISCOUNT_COUPON_TOOLTIP: 'Crie cupons de desconto',
  ISSUE_INVOICE_FOR: 'Emitir Nota Fiscal para',
  ISSUE_INVOICE_AND_ORDER: 'Emitir Nota Fiscal e Boleto para',
  GENERATE_ORDER: 'Gerar Boleto',
  CHECKOUT: 'Finalizar compra',
  IN_CASH: 'À vista'
};

const checkoutSebraepay = {
  PAYMENT_METHOD: 'Forma de pagamento',
  YOU_WILL_BE_REDIRECTED_TO_SEBRAEPAY:
    'Clique em "Continuar" para ser encaminhado à página de pagamento do Sebrae, onde terá a oportunidade de selecionar a forma de pagamento que melhor atenda à sua necessidade.',
  YOUR_CART_SEBRAEPAY: 'Seu carrinho',
  GOT_A_COUPON: 'Tem um cupom de desconto?',
  ENTER_IN_THE_FOLLOWING_FIELD:
    'Insira-o no campo abaixo para usufruir do desconto em sua compra',
  CODE: 'Código',
  WAITING_PAYMENT_SEBRAEPAY:
    'Para finalizar o pagamento, por favor, <0>acesse a recém-aberta página do Sebraepay em seu navegador</0>, conclua o processo de pagamento e, assim, finalize sua compra.',
  IF_THE_WINDOW_DIDNT_OPEN:
    'Caso a janela não tenha aberto ou tenha sido fechada acidentalmente, não se preocupe; clique no botão abaixo para continuar.',
  GO_BACK_TO_CART: 'Voltar para o seu carrinho',
  OPEN_THE_PAYMENT_PAGE: 'Abrir a página de pagamento',
  PAYMENT_APPROVED_SEBRAEPAY: 'Seu pagamento foi aprovado com sucesso!',
  MORE_INFO_ON_PAYMENT:
    'Para visualizar mais informações acesse Minhas Compras',
  GO_BACK_TO_DISPLAY: 'Voltar para a vitrine',
  PAYMENT_REFUSED: 'Pagamento recusado',
  THERE_WAS_A_PROBLEM_WITH_YOUR_PAYMENT:
    'Ocorreu um problema com o seu pagamento no Sebraepay.',
  PLEASE_TRY_AGAIN:
    'Não se preocupe, você pode tentar novamente através do botão abaixo:',
  TRY_AGAIN: 'Tentar novamente',
  PAYMENT_IN_ANALYSIS: 'Pagamento em análise',
  YOUR_PAYMENT_IS_IN_ANALYSIS: 'O seu pagamento se encontra em análise.',
  YOU_CAN_NAVIGATE:
    'Você pode navegar pelo Sebraeplace normalmente, e acompanhar o status do seu pagamento em Minhas Compras.',
  I_UNDERSTAND_CUPOM: 'Entendi',
  PROMO_CODE_INSTRUCTIONS:
    'Insira seu código promocional no campo indicado antes de seguir com a finalização da compra.',
  PROMO_CODE_WARNING:
    'Atenção: Após clicar em "Continuar", não será possível aplicar ou modificar o cupom de desconto.',
  PROMO_CODE_SUPPORT:
    'Caso tenha dúvidas ou ainda não possua um cupom, entre em contato com a nossa Central de Atendimento. Será um prazer atendê-lo(a).',
  SUPPORT_CHANNELS: 'Canais de Atendimento'
};

const carrinho = {
  PAYMENT_EXCLUSION: 'Exclusão de pagamento',
  SELECTED_PROPOSAL_EXCLUSION: 'Excluir proposta escolhida',
  CANCEL: 'Cancelar',
  DISABLE: 'Desativar',
  NEW_PROPOSAL_NEW_PAYMENT:
    'Se excluir o pagamento, será necessário que uma nova proposta seja aceita antes de efetuar um novo pagamento.',
  CONFIRM_EXCLUSION:
    'Você tem certeza que deseja excluir esse item do carrinho?',
  YOUR_CART: 'Carrinho',
  GO_TO_MY_CART: 'Ir para Meu carrinho',
  MY_PRODUCTS: 'Meus produtos',
  SIGNATURE: 'Assinatura',
  YOU_DONT_HAVE_CART_ITEMS: 'Você ainda não possui itens no seu carrinho',
  CART_ITEMS_DESCRIPTION:
    'Os itens que você adicionar ao carrinho irão aparecer aqui',
  SIGN_OF: 'Sinal de ',
  MARKETED_BY: 'Comercializado por',
  I_ACCEPT_THE_TERMS_AND_POLICY:
    'Aceito os $TERMOS$ e $POLITICA$ dessa solução inteligente.',
  I_AM_AWARE_THAT_THE_SOLUTION_I_AM_BUYING_IS:
    'Estou ciente que a solução que estou comprando é',
  I_AM_AWARE_THAT_THE_SOLUTION_I_AM_BUYING_IS_AVAILABLE:
    'Estou ciente que a solução que estou comprando está',
  INFO_DELETE_ITEM_CART:
    'Você tem certeza que deseja excluir esse item do carrinho.',
  INFO_DELETE_SEBRAETEC_PAYMENT:
    'Você tem certeza que deseja cancelar o pagamento deste orçamento?',
  RESTRICTED_TO_REGIONS: 'restrita a regiões.',
  AVAILABLE_BRAZIL: 'disponível em todo o Brasil.',
  SEE_RESTRICTED_AREAS:
    'Ver as regiões atendidas por essa Solução inteligente.',
  TOTAL_AMOUNT_CART: ' do valor total:',
  CONTRACT: 'Contrato',
  PAY_CONTRACT: 'Realizar pagamento do contrato',
  MAKE_PAYMENT: 'Realizar pagamento',
  SEE_DATA_TO_PAYMENT: 'Ver dados para pagamento',
  SEE_PAYMENT: 'Acompanhar pagamento',
  PAYMENT_EXPIRED: 'Pagamento expirado',
  DELETE_SEBRAETEC_ITEM:
    'Ao excluir o pagamento de uma proposta Sebraetec, você pode escolher outra proposta, desde que as propostas ainda estejam válidas; caso contrário, será necessário solicitar um novo orçamento e esperar novas propostas.'
};

const planos = {
  UPDATE_YOUR_PLAN: 'Atualize seu plano',
  SUBTITLE_PLAN: 'Promocional de lançamento',
  AMOUNT_CHARGED_NEXT_BILL:
    '* O valor será cobrado na próxima fatura do seu cartão',
  DONT_CHANGE_PLAN: 'Não alterar meu plano',
  YES_GO_TO_PAYMENT: 'Sim, ir para o pagamento',
  CANCEL_MY_PLAN: 'Cancelar meu plano',
  DONT_CANCEL_MY_PLAN: 'Não cancelar meu plano',
  BEFORE_CONTINUE_READ: '* Antes de continuar leia atentamente.',
  CONTRACT_SELF_RENEWABLE: 'Essa contratação será auto-renovável ?',
  SURE_CHANGE_PLAN: 'Você tem certeza que deseja alterar seu plano de',
  CHANGE_TO: ' para o ',
  PLAN_SUCCESSFULLY_SIGNED: 'Plano assinado com sucesso!',
  SURE_WANT_SIGN: 'Você tem certeza que deseja assinar o ',
  SURE_REACTIVATE: 'Você tem certeza que deseja reativar o ',
  SURE_CANCEL: 'Você tem certeza que deseja cancelar seu plano ',
  CANCEL_PLAN: 'Cancelar seu plano',
  PLANS__PLAN_CHANGE: 'Alteração de plano',
  PERIOD_OF_VALIDITY_OF_THE: 'Período de vigência do',
  PLAN_CONTRACTED_IN: 'Plano contratado em',
  RENEWAL_IN: 'Renovação em',
  CHANGE_PLAN_TRIAL_INFO:
    'Ao confirmar a alteração do plano as funcionalidades serão liberadas automaticamente. O período trial permanecerá ativo até a data de renovação em',
  CHANGE_PLAN_DOWNGRADE_INFO:
    'O plano atual permanecerá vigente até o encerramento do período contratado, após esse período o plano atual será encerrado e o novo plano selecionado entrará em vigor.',
  DDESCRIPTION_OF_VALUES: 'Descritivo de valores',
  BALANCE_REFERRING_TO_THE_CURRENT_PLAN: 'Saldo referente ao plano atual',
  PLAN_TO_BE_HIRED: 'Plano a ser contratado',
  REMAINING_DEBT: 'Débito remanescente',
  CHANGE_PLAN_UPGRADE_INFO:
    'Para confirmar a alteração do plano, você será direcionado para o carrinho, após finalizar a compra o plano será atualizado. Para acompanhar as funcionalidades e período de vigência do seu plano, acesse seu painel.',
  YOU_HAVE_AN_ACTIVE_SUBSCRIPTION_ON: 'Você possui uma assinatura ativa no',
  WANT_TO_CHANGE_THE_CURRENT_PLAN_TO_THE: 'deseja alterar o plano atual para o',
  YOUR_PLAN_HAS_BEEN_SUCCESSFULLY_CHANGED: 'Seu plano foi alterado com sucesso',
  TO_FOLLOW_THE_FEATURES_AND_THE_PERIOD_OF_VALIDITY_OF_YOUR_PLAN_ACCESS_YOUR_PANEL:
    'Para acompanhar as funcionalidades e o período de vigência do seu plano acesse o seu painel.',
  CANCEL_PLAN_ACTIVATE_UNTIL:
    'Mesmo após o cancelamento, esse plano ficará ativo até ',
  CANCELLING_PLAN_WILL_CAUSE:
    'O cancelamento do plano fará com que seus consultores não estejam mais disponíveis na plataforma para contratação.'
};

const consultor = {
  ABOUT_CONSULTANT: 'Sobre o consultor',
  AVALIATION_CONSULTANT: 'Avaliação do consultor:',
  CUSTOMERS_SERVED: 'Clientes atendidos',
  PHOTO_GALLERY: 'Galeria de Fotos',
  VIDEOS_GALLERY: 'Galeria de Vídeos',
  CUSTOMER_SERVED: 'Cliente atendido',
  AREA_CONSULTANT: 'Tema de consultoria',
  AREAS_CONSULTANT: 'Temas de consultoria',
  EXPERTISE: 'Subtema',
  EXPERTISES: 'Subtemas',
  DOWNLOAD_MATERIALS: 'Materiais para download',
  MATERIALS: 'Materiais',
  BUDGET: 'ORÇAMENTO',
  ASK_BUDGET: 'Converse com o profissional',
  TELL_YOUR_DEMANDS: 'Fale um pouco sobre a sua necessidade',
  SEND_BUDGET: 'Solicitar orçamento',
  SEND_BUDGET__PLACEHOLDER:
    'Explique ao consultor a sua necessidade, quanto mais detalhes, mais assertiva será a proposta.',
  CONSULTING_TYPE_OPTION:
    'Como você prefere que seja realizada a sua consultoria?',
  REMOTELY: 'Remotamente',
  IN_PERSON: 'Presencialmente',
  BUDGET_SENT: 'Orçamento solicitado',
  PLEASE_WAITING_BUDGET:
    'Sua solicitação foi enviada! Você será avisado por e-mail e SMS assim que houver uma resposta. O consultor tem até 48h para lhe responder.',
  BACK_HOME: 'Voltar para a Página Inicial',
  INVESTMENT: 'Investimento: ',
  BUDGET_NOT_ALLOWED:
    'É necessário estar logado para a solicitação de orçamento.',
  GO_TO_LOGIN: 'Ir para o login'
};

const evento = {
  DESCRIPTION_EVENT: 'DESCRIÇÃO DO EVENTO',
  PROGRAMING: 'Programação',
  SCHEDULE_DAY: 'Programação - Dia',
  AGE_RATING: 'Classificação Etária:',
  CANCELLATION_POLICY: 'Política de Cancelamento:',
  CREATE_EVENT: 'Criar Evento',
  REGISTER_PARTICIPANT: 'Inscrever Participante',
  REGISTERED_PARTICIPANT: 'Inscrição de participante',
  REGISTER_PARTICIPANT_WARNING:
    'Ao confirmar a inscrição, o participante será notificado por email.',
  REGISTER_PARTICIPANT_WARNING_PAID_EVENT:
    'Para inscrição em evento pago enviaremos instruções sobre as formas de pagamento ao cliente.',
  SELECT_EVENT_PARTICIPANT:
    'Selecione o evento que deseja inscrever um ou mais participantes.',
  EDIT_PARTICIPANT_REGISTRATION: 'Editar Inscrição de Participante',
  EDIT_PARTICIPANT_REGISTRATION_WARNING:
    'A edição de dados do participante não é permitida para inscrições pagas.',
  ARE_YOU_SURE_DELETE_REGISTRATION:
    'Tem certeza que deseja excluir essa inscrição?',
  SITUATION: 'Situação',
  PENDING_PAYMENT: 'Pagamento Pendente',
  SENT: 'Enviado',
  SENTS: 'Enviadas',
  PENDING: 'Pendente',
  CANCELLED: 'Cancelado',
  PAID: 'Pago',
  EXPIRED: 'Expirado',
  OLDEST_INVITE: 'convite mais antigo',
  NEWEST_INVITE: 'convite mais novo',
  REGISTRATION_DATE: 'Data da inscrição',
  ORDER_NUMBER_PARTICIPANT: 'Número do pedido',
  DELETE_REGISTRATION: 'Excluir inscrição',
  SALES_CHANNEL: 'Canal de venda',
  SELECT_SALES_CHANNEL: 'Selecione o canal de venda',
  VALID: 'Valida',
  OPEN: 'Aberta',
  CANCEL_REGISTRATION: 'Cancelar inscrição',
  NO_ACTIVE_EVENTS: 'Nenhum evento ativo',
  ACTIVE_EVENTS: 'Eventos ativos',
  CANCELED_TAB: 'Cancelados',
  MY_EVENTS: 'Meus Eventos',
  HERE_YOU_FOLLOW_AND_CONFIGURE_YOUR_EVENTS_INFO:
    'Aqui você acompanha e configura as informações do seu evento',
  COMING_EVENTS: 'Próximos Eventos',
  FINISHED_EVENTS: 'Eventos Concluídos',
  OLDEST_EVENT: 'evento mais antigo',
  OLDEST: 'mais antiga',
  NEWEST_EVENT: 'evento mais novo',
  DRAFTS_OF_EVENTS: 'rascunhos de eventos',
  SEARCH_FOR_AN_EVENT_OR_PARTICIPANT: 'Busque por um evento ou participante',
  EVENT_DATA: 'Dados do evento',
  MANAGE_THIS_EVENT: 'Gerenciar este evento',
  EDIT_EVENT: 'Editar evento',
  VISIBLE_EVENT: 'Seu evento está visível no catálogo.',
  PUBLIC_EVENT: 'EVENTO PÚBLICO.',
  PUBLISH_EVENT: 'Publicar evento',
  PUBLISH_EVENT_DESC:
    'Confira atentamente as instruções antes de publicar evento.',
  SETTINGS_EVENT: 'Configurações do evento',
  PREVIEW_EVENT: 'PRÉ VISUALIZAÇÃO',
  PUBLIC_AD: 'ANÚNCIO PÚBLICO',
  FINISH_REGISTER: 'Concluir cadastro',
  COMPLETE_REGISTER_EVENT: 'Complete o cadastro do evento',
  COMPLETE_REGISTER_EVENT_DESC:
    'Antes de publicar o seu evento, você deve concluir o cadastro',
  CREATE_YOUR_EVENT: 'Crie seu evento',
  SET_UP_YOUR_EVENT: 'Configure seu evento',
  DATE_LOCATION_AND_AUDIENCE: 'Data, localização e público',
  APPEARANCE: 'Aparência',
  INSTRUCTORS_AND_PROGRAMMING: 'Instrutores e Programação',
  THEMATIC_AND_CLASSIFICATION: 'Temática e classificação',
  THERE_ARE_NO_PARTICIPANTS_YET: 'Ainda não há inscritos',
  THERE_WERE_NO_PARTICIPANTS: 'Nenhum inscrito',
  CLASSIFICATION: 'Classificação',
  EVENTS: 'Eventos',
  NO_PUBLIC_EVENTS_SECONDARY_MESSAGE:
    'Aqui você vai poder acompanhar em tempo real as informações dos eventos publicados no Sebraeplace.',
  NO_DRAFT_EVENTS_SECONDARY_MESSAGE:
    'Acesse Criar evento e usufrua todos os benefícios de ser um licenciado Sebraeplace.',
  NO_FINISHED_EVENTS_SECONDARY_MESSAGE:
    'Aqui você vai poder acompanhar as informações dos eventos realizados.',
  SEE_EVENT: 'Visualizar evento',
  CHECK_IN: 'Check in',
  SUSPEND_THE_SELL: 'Suspender a venda',
  CANCEL_THE_SELL: 'Cancelar a venda',
  FINISHED_EVENT: 'Evento concluído',
  SALES_CONVERTION: 'Conversão de vendas',
  SALES_LAST_4_WEEKS: 'Vendas das últimas 4 semanas',
  EXPENSE: 'Despesa',
  REVENUE: 'Receita',
  NO_ENROLLEDS_YET: 'Você ainda não possui inscritos nesse evento',
  SELECT_EVENT_THEMATIC: 'Selecione a temática do evento',
  SELECT_EVENT_CLASSIFICATION: 'Selecione a classificação do evento',
  ABOUT_THE_EVENT: 'Sobre o Evento',
  THEMATIC: 'Temática',
  EVENT_SETTINGS: 'Configurações do evento',
  EVENT_URL_COPIED: 'URL do evento copiada para área de transferência',
  VALUE: 'Valor',
  COST: 'Gasto',
  RECEIVED: 'Recebido',
  PROJECTED: 'Projetado',
  EVENT_SPEAKERS: 'Palestrantes do Evento',
  EVENT_INSTRUCTORS: 'Instrutores do Evento',
  MAXIMUM_CAPACITY: 'Capacidade Máxima',
  COVER_PICTURES: 'Imagens de Capa',
  DATE_TIME_AND_LOCALIZATION: 'Data, horários e localização',
  CHOOSE_EVENT_LOCATION: 'Escolha a localização do seu evento',
  NO_EVENT_IMAGE_PLACEHOLDER: 'Evento sem imagem de capa',
  NO_EVENT_TITLE_PLACEHOLDER: 'Evento sem título',
  NO_EVENT_LOCATION_PLACEHOLDER: 'Local não informado',
  NO_EVENT_DATE_PLACEHOLDER: 'Data não informada',
  NO_EVENT_VALID_DATE_PLACEHOLDER: 'Data inválida',
  EVENT_INVALID_DATE_MESSAGE:
    'Para continuar configurando esse evento escolha uma data futura.',
  NO_EVENT_INSTRUCTORS_PLACEHOLDER: 'Sem instrutores cadastrados',
  NO_EVENT_THEMATIC_OR_CLASSIFICATION:
    'Você ainda não atribuiu classificação e temática nesse evento',
  NO_EVENT_THEMATIC_PLACEHOLDER:
    'Você ainda não atribuiu uma temática para esse evento',
  NO_EVENT_CLASSIFICATION_PLACEHOLDER:
    'Você ainda não atribuiu uma classificação para esse evento',
  NO_EVENT_DATE_OR_LOCATION:
    'Você ainda não cadastrou a data e localização do evento',
  NO_EVENT_DATE_REGISTERED:
    'Você ainda não cadastrou a localização desse evento',
  NO_EVENT_CONFIG_LOCATION_PLACEHOLDER:
    'Você ainda não cadastrou a localização desse evento',
  NO_EVENT_CONFIG_DATE_PLACEHOLDER:
    'Você ainda não cadastrou a data desse evento',
  NO_EVENT_CONFIG_IMAGES_PLACEHOLDER:
    'Você ainda não cadastrou as imagens de capa desse evento',
  ONLY_CLIENT_ALLOWED: 'Apenas clientes podem realizar a compra de ingressos',
  CANCEL_EVENT_SELL: 'Cancelar venda',
  CONFIRM_EVENT_SELL_CANCELING:
    'Tem certeza que gostaria de cancelar a venda o evento?',
  SUSPEND_EVENT_SELL: 'Suspender venda',
  CONFIRM_EVENT_SELL_SUSPENDING:
    'Tem certeza que gostaria de suspender a venda o evento?',
  CONFIRM_EVENT_MODAL: 'Confirmar',
  SUSPENDED: 'Suspensos',
  SUSPENDED_EVENTS_SECONDARY_MESSAGE:
    'Aqui você vai poder acompanhar as informações dos eventos suspensos.',
  CANCELED: 'Cancelados',
  CANCELED_EVENTS_SECONDARY_MESSAGE:
    'Aqui você vai poder acompanhar as informações dos eventos cancelados.',
  COMPLETED: 'Concluídos',
  EDIT_SUSPENDED_EVENT: 'Editar evento suspenso',
  EVENT_CANCELED: 'Evento cancelado',
  EVENT_CANCELED_ALERT:
    'O evento foi cancelado e por isso não pode ser mais editado',
  EVENT_SUSPENDED: 'Evento suspenso',
  EVENT_NOT_FOUND: 'Evento não encontrado',
  RESUME_EVENT: 'Retomar Evento',
  ARE_YOU_SURE_RESUME_EVENT: 'Você tem certeza que deseja retomar evento?',
  FROM_THE_MOMENT_RETURN_EVENT:
    'A partir do momento que você retornar evento os ingressos voltarão a ser comercializados no Sebraeplace. Acompanhe o status do seu evento no painel Meus eventos.',
  BACK_TO_SETTINGS: 'Voltar para as configurações',
  EVENT_RESUMED_SUCCESSFULLY: 'Seu evento foi retomado com sucesso',
  FOLLOW_EVOLUTION_EVENT:
    'Acompanhe a evolução do seu evento no painel Meus eventos.',
  GO_TO_MY_EVENTS: 'Ir para Meus eventos',
  CREATE_NEW_EVENT: 'Criar novo evento',
  MINIMUM_AND_MAXIMUM_TICKETS:
    'Mínimo de $quantidadeMinima ingressos e máximo de $quantidadeMaxima ingressos por compra',
  LIMITED_PURCHASE_TICKETS: 'Ingressos limitados por compra',
  DELETE_EVENT: 'Excluir evento',
  CONFIRM_EVENT_DELETING: 'Tem certeza que gostaria de excluir o evento?',
  CONFIRM_EVENT_PUBLISHING: 'Tem certeza que gostaria de publicar o evento?',
  NO_SELL_CONVERTION_BANNER_TITLE: 'Você ainda não possui ingressos vendidos',
  NO_SELL_CONVERTION_BANNER_MESSAGE:
    'Aqui você poderá acompanhar o gráfico de conversão',
  NO_SELL_4_WEEKS_BANNER_MESSAGE:
    'Aqui você poderá acompanhar o gráfico de vendas.',
  DIFFERENT_DATE_OBSERVATION: 'Data informada é diferente da data negociada.',
  EVENT_NO_PARTICIPANT: 'Esse evento ainda não possui participantes'
};

const negociacao = {
  NEGOTIATIONS: 'Negociações',
  NO_FINALIZED_NEGOTIATIONS: 'Você não possui negociações finalizadas.',
  NEGOTIATIONS_M: '< Negociações',
  SEE_DETAILS_NEGOTIATION: 'Ver detalhes da negociação',
  SEE_PROPOSAL: 'Ver proposta',
  DETAILS_REQUEST: 'Detalhes da solicitação',
  SEE_DETAILS_REQUEST: 'Ver detalhes da solicitação',
  WRITE_MESSAGE: 'Escreva uma mensagem....',
  SUBMIT_PROPOSAL: 'Enviar proposta',
  NEGOTIATION_ENDED_WITH: 'Terminou sua negociação com',
  WAIT_PAYMENT_COMPLETE_NEGOTIATION:
    'Aguarde o pagamento para concluir sua negociação.',
  SEE_SUMMARY: 'Veja o resumo',
  NEGOTIATION_CONCLUDED: 'A negociação foi concluída.',
  NEGOTIATION_CANCELED: 'A negociação foi cancelada.',
  GO_TO_PAYMENT: 'Ir para pagamento',
  PROPOSAL_ACCEPTED_BY: 'Sua proposta foi aceita por',
  AND_YOUR_PAYMENT_IS_ENABLED: ' e seu pagamento está habilitado.',
  PROPOSAL_WAS_DENIED_BY: 'Sua proposta foi recusada por',
  CLICK_SEE_REASONS: 'clique para ver os motivos.',
  REPLY_PROPOSAL: 'Responder proposta',
  REPLY_PROPOSAL_FROM: 'Responda a proposta do(a)',
  INCLUDED_YOUR_PRICE: 'O que está incluso no seu preço?',
  HELLO: 'Olá',
  HOW_ARE_YOU: ', tudo bem?',
  SEE_PROFILE: 'Ver perfil',
  NEGOTIATE_BEFORE_FINALIZE: 'Negocie antes de finalizar',
  NEGOTIATION_FINALIZED: 'Negociação finalizada',
  CANNOT_CHANGED_STAGE:
    'Os itens da negociação não podem ser alteradas nessa fase.',
  YOU_AND: 'Você e',
  FINISHED_START_END_CONTRACT:
    'terminaram de negociar a data para o evento? Então informe a data de início e término da contratação.',
  FINISHED_START_END_CONTRACT_PRODUCT:
    'terminaram de negociar a data para a palestra? Então informe a data de início e término da contratação.',
  FINISHED_START_END_CONTRACT_CONSULTING:
    'terminaram de negociar a data para a consultoria? Então informe a data de início e término da contratação.',
  YOU_CANT_ATEND_CONTRACT:
    'Se você não pode mais atender este contrato, você pode ',
  YOU_DONT_NEED_CONTRACT:
    'Se você não precisa mais do presente contrato, você pode ',
  YOU_DONT_WISH_BUDGET: 'Se você não deseja continuar o orçamento, você pode ',
  CANCEL_THIS_NEGOTIATION: 'cancelar esta negociação.',
  YOU_ARE_CANCEL_NEGOTIATION: 'Você está cancelando a negociação',
  NEGOTIATION_CANCELLATION: 'Cancelamento da negociação',
  WAIT_COMPENSATE_TICKET:
    'O método de pagamento selecionado foi boleto bancário, é necessário aguardar sua compensação para cancelar o boleto e estornar o valor.',
  AUTO_NEGOTIATION_CANCELLATION_TICKET_1: 'A negociação será ',
  AUTO_NEGOTIATION_CANCELLATION_TICKET_2: 'CANCELADA AUTOMATICAMENTE',
  AUTO_NEGOTIATION_CANCELLATION_TICKET_3:
    ' após vencimento do prazo de pagamento, caso não tenha sido efetuado.',
  YOU_ARE_CANCEL_BUDGET: 'Você está cancelando o orçamento',
  CANCELING: 'cancelando',
  THIS_BUDGET: 'este orçamento.',
  CONTRACT_SIGNED_NEGOTIATION: 'este contrato firmado nesta negociação.',
  REVERSED_ALL:
    'Desta forma o valor pago referente ao sinal será estornado integralmente.',
  LICENSED_REVERSED_ALL:
    'Desta forma o valor pago pelo Licenciado, referente ao sinal, será estornado integralmente a ele.',
  SUPPLIER_DONT_REVERSED_ALL:
    'Como estamos a menos de 48h do início da agenda do presente contrato, o valor pago referente ao sinal, não será ressarcido e será pago ao fornecedor.',
  REASONS_CANCELING_SEND_TO_CONSULTANT:
    'Digite a seguir os motivos que justificam esse cancelamento, essa mensagem será enviada ao consultor.',
  REASONS_CANCELING_SEND_TO_CLIENT:
    'Digite a seguir os motivos que justificam esse cancelamento, essa mensagem será enviada ao cliente.',
  REASONS_CANCELING_SEND_TO_LICENSED:
    'Digite a seguir os motivos que justificam esse cancelamento, essa mensagem será enviada ao licenciado.',
  REASONS_CANCELING_SEND_TO_SUPPLIER:
    'Digite a seguir os motivos que justificam esse cancelamento, essa mensagem será enviada ao fornecedor.',
  ALERT_FILE_EXTENSIONS:
    'É permitido arquivos em PDF, XLS, XLSX, ZIP, TXT, DOC, DOCX, PPT, PPTX, JPG e PNG.',
  ALERT_FILE_EXTENSIONS_PDF: 'É permitido arquivo somente em PDF.',
  ALERT_FILE_SIZE: 'É permitido arquivo com o tamanho menor que',
  DOWNLOAD_ALL: 'Baixar todos',
  DOWNLOAD_ATTACHMENTS: 'Baixar anexos',
  DOWNLOAD_FILE: 'Baixar',
  YOU_CAN_SEND_FILES_DURING_THE_NEGOTIATION_WATCH_THE_SPECIFICATIONS:
    'Você pode enviar arquivos durante a negociação. Preste atenção as especificações:',
  THE_FILES_MAY_BE_OF_THE_FOLLOWING_EXTENSIONS:
    'Os arquivos poderão ser das seguintes extensões',
  THE_UPLOADED_FILE_MUST_BE_LESS_THAN: 'O arquivo enviado deve ser menor que',
  YOU_CAN_ATTACH_UP_TO_NUMBER_FILES_PER_TRADE:
    'Você pode anexar até $qtAttachments$ arquivos por negociação.',
  ADD_ATTACHMENT: 'Adicionar anexo',
  DIGITE_NAME_ATTACHMENT: 'Digite o nome do arquivo anexo',
  ATTACHMENT_LIMIT_REACHED: 'Limite de anexos atingido.',
  DELETE_ONE_OF_THE_ATTACHMENTS_TO_ADD_A_NEW_FILE:
    'Exclua um dos anexos para adicionar um novo arquivo.',
  YOU_HAVE_NOT_RECEIVED_ANY_FILES: 'Você não recebeu nenhum arquivo',
  ATTACHMENTS: 'Anexos',
  UPLOADED_FILES: 'Arquivos enviados',
  FILES_RECEIVED: 'Arquivos recebidos',
  VIEW_SENT_AND_RECEIVED_ATTACHMENTS: 'Ver anexos enviados e recebidos',
  SENT_AND_RECEIVED: 'Enviados e recebidos',
  SEE_ATTACHMENTS: 'Ver anexos',
  SEE_ATTACHMENT: 'Ver anexo',
  NOTIFY_RECEIPT: 'Informar recebimento',
  WAITING_CLIENT: 'Aguardando cliente',
  FILES_ATTACHED_ON_DELIVERY: 'Arquivo anexado na confirmação de entrega:',
  ERROR_ON_CONFIRM_DELIVERY: 'Erro ao confirmar entrega, tente novamente',
  ERROR_ON_CONFIRM_RECEIPT: 'Erro ao confirmar recebimento, tente novamente',
  NEGOTIATION_SUMMARY: 'Resumo da negociação',
  SERVICE_IS_DONE: 'O serviço foi concluído.',
  DELIVERY_CONFIRMED_ON: 'Entrega confirmada em: {{date}}',
  APPROVED_BY_CLIENT: 'Aprovada pelo cliente',
  APPROVED_AUTOMATICALLY_BY_PLATFORM:
    'Aprovada automaticamente pela plataforma',
  WORKING_DAYS_AFTER_PAYMENT:
    '<0>{{days}} dias úteis</0> após a confirmação do pagamento',
  TOTAL_VALUE_PAID: 'O valor total pago é de <0>{{value}}</0>',
  TOTAL_VALUE_RECEIVED: 'O valor total a receber é de <0>{{value}}</0>',
  DEADLINE: 'Prazo',
  DETAILS_OF_PROPOSAL: 'Esse é o detalhamento da proposta',
  DO_YOU_WANT_TO_NOTIFY_RECEIPT:
    'Deseja confirmar o recebimento total dos itens contratados?',
  ON_CONFIRMATION_PURCHASE_PROCCESS_WILL_BE_FINISHED:
    'Ao confirmar o recebimento, o processo de compra será finalizado.',
  I_GOT_A_PROBLEM_WITH_MY_ORDER: 'Tive um problema com o meu pedido',
  DESCRIBE_WHAT_HAPPENED: 'Informe o ocorrido',
  DESCRIBE_WHAT_HAPPENED_SO_WE_CAN_HELP:
    'Informe o ocorrido para que possamos oferecer a assistência mais adequada na busca por uma solução',
  DELIVERY_REFUSED_IN_DATE: 'Entrega recusada em: {{date}}',
  PROOF_THAT_PURCHASE_WAS_RECEIVED: 'Informe sobre o recebimento da compra',
  PROOF_OF_DELIVERY: 'Informe de recebimento',
  ATTACHMENT_SENT_BY_THE_SUPPLIER: 'Anexo enviado pelo fornecedor',
  WRITE_REASONS_CANCELING: 'Escreva os motivos do seu cancelamento.',
  CANCEL_BUDGET: 'Cancelar orçamento.',
  CHANGE_DATE_NEGOTIATION: 'Alterar data',
  CANCEL_NEGOTIATION: 'Cancelar negociação.',
  NEGOTIATION_CANCEL: 'Negociação cancelada',
  COMMENTS: 'Observações',
  END_DATE: 'Data de término',
  START_DATE: 'Data de início',
  YOU_OPEN_DISPUTE: 'Você abriu uma disputa',
  END_DISPUTE: 'Encerrar disputa',
  END_DISPUTE_SELLER_MESSAGE:
    'Ao encerrar a disputa o vendedor receberá uma mensagem que o problema foi resolvido. Você tem certeza que deseja encerrar a disputa listada abaixo?',
  FINISHED_DATE_BIGGER: 'Data término deve ser maior ou igual a data inicial.',
  FINISHED_DATE_SMALLER: 'Data inicial deve ser menor ou igual a data término.',
  WRITE_REASONS_REJECTION: 'Escreva os motivos da sua rejeição',
  YOU_ARE_DENYING: 'Você está negando a proposta de',
  BACK_NEGOTIATION: 'Voltar a negociação',
  SUBMIT_DECLINE: 'Enviar recusa',
  YOU_ARE: 'Você está',
  DENYING: 'NEGANDO',
  SCHEDULE: 'Agenda',
  CHANGE_DATE_AGREED: 'alterar a data acordada',
  NEW_AGENDA: 'Nova Agenda',
  SELECTED_APPLICATION_MODEL: 'Modelo de aplicação selecionada',
  BOTH: 'Ambas',
  CONFIRM_DELIVERY_COMPLETE_PROCESS:
    'Confirme a entrega para concluir o processo',
  INFORM_RECEIPT_COMPLETE_PROCESS:
    'Informe o recebimento da compra para concluir o processo',
  CONFIRM_RECEIPT: 'Confirmar recebimento',
  CONFIRM_DELIVERY: 'Confirmar entrega',
  CONFIRM_DELIVERY_DESC:
    'Ao confirmar a entrega o cliente será notificado e o chat será encerrado.',
  CONFIRM_DELIVERY_DESC_1:
    'Para concluir anexe no campo abaixo uma evidencia que comprove a entrega do edital em andamento.',
  CONFIRM_DELIVERY_DESC_2:
    'Você pode enviar evidências em formato jpg, pdf ou mp4',
  WE_WANT_YOUR_OPINION: 'Queremos saber sua opinião',
  HOW_WAS_YOUR_EXPERIENCE: 'Como foi sua experiência com essa solução?',
  NEED_CHANGE_NEGOTIATED_DATE:
    'Caso você tenha a necessidade de alterar a data negociada, sugira uma nova data e envie uma mensagem explicando o motivo, lembrando que o licenciado poderá aceitar ou rejeitar a sua nova sugestão de agenda.',
  SUGGESTION_SUCCESFULLY_SENT: 'Sua sugestão foi enviada com sucesso',
  WAIT_RESPONSE_SUGGEST_DATE:
    'Aguarde a resposta do licenciado, ele pode aceitar, sugerir uma nova data ou rejeitar a sua sugestão de agenda.',
  SUPPLIER: 'Fornecedor',
  PROFILE: 'Perfil',
  SUPPLIER_NEEDS_CHANGE_NEGOTIATED_DATE:
    'O fornecedor necessita alterar a data negociada, ele enviou a sugestão de uma nova data e uma mensagem explicando o motivo, você poderá aceitar ou rejeitar a nova sugestão de agenda.',
  SUGGEST_NEW_DATE: 'Sugerir nova data',
  YOU_ARE_REJECTING_NEW_CALENDAR:
    'Você está rejeitando a sugestão de nova agenda',
  YOU_ARE_REJECTING_THE_PROPOSAL:
    'Você está REJEITANDO a proposta, digite a seguir os motivos:',
  REJECT: 'Rejeitar',
  ENTER_MOTIVES: 'proposta, digite a seguir os motívos para que',
  SUBMIT_NEW_PROPOSAL: 'possa lhe enviar uma nova proposta.',
  PROPOSAL_SEND_SUCCESS: 'Sua proposta foi enviada com sucesso.',
  CONGRATULATIONS_ACCEPTED_PROPOSAL: 'Parabéns, você aceitou a proposta.',
  BACK_TO_NEGOTIATION: 'Voltar para negociação',
  INITIAL_PAGE: 'Página inicial',
  BE_PATIENT: 'Aguarde',
  ACCEPT_PROPOSAL_PAYMENT_RELEASE:
    'aceitar a proposta para que seu pagamento seja liberado.',
  WAIT_ACCEPT_PROPOSAL_AND_CONFIRMATION_PAYMENT:
    'aceitar a proposta e realizar o pagamento.',
  WAIT_CONFIRMATION_PAYMENT: 'Aguarde a confirmação pagamento feito por',
  YOUR_PAYMENT_IS_ENABLED: 'O seu pagamento está habilitado.',
  INSERT_PROPOSAL_VALUE: 'Insira o valor da proposta.',
  IN_PROGRESS: 'Em Andamento',
  FINISHED: 'Finalizadas',
  CANCELED: 'Canceladas',
  EVENT_WILL_BE: 'O evento será de ',
  UP_UNTIL: 'até ',
  OBSERVATION: 'Observação',
  DENIED_PROPOSAL: 'Negar Proposta',
  ACCEPT_PROPOSAL: 'Aceitar proposta',
  PROPOSAL: 'Proposta',
  VERIFY_CONTENT_NEGOTIATION:
    'Verifique se o conteúdo condiz com a negociação realizada.',
  ENABLE_PROPOSAL_FIELDS:
    'Para habilitar o aceite da proposta clique e marque os campos a seguir.',
  TOTAL_VALUE_PAYMENT: 'O valor total do pagamento será de ',
  FINAL_PRICE: 'no preço final.',
  INCLUDED: 'inclusa',
  INCLUDING: 'inclusos',
  INCLUDED_IN: 'incluso',
  IT_IS: 'está',
  THEY_ARE: 'estão',
  THIS_DETAIL_PROPOSAL: 'Esse é o detalhamento da proposta.',
  PAYMENT_ABLE_PROPOSAL_ACCEPT:
    'O seu pagamento será habilitado assim que a proposta for aceita.',
  INFORMATION_PAYMENT_ACCEPT:
    'Iremos informar quando o pagamento for realizado.',
  NEGOTIATION_SUBJECT_NOT_FOUND: 'Produto não encontrado',
  PERSON_NOT_FOUND: 'Pessoa não encontrada',
  REMOTE: 'Remoto',
  PRESENTIAL: 'Presencial',
  VALUE_MIN_IS: 'O valor mínimo é',
  VALUE_MIN: 'Valor mínimo',
  FILL_VALUE_EQUAL_HIGHER:
    'O valor está abaixo do mínimo permitido. Preencher com um valor igual ou superior a ',
  FILL_VALUE_LOWER_OR_EQUAL: 'Valor do campo deve ser menor ou igual a',
  FILL_VALUE_LOWER_OR_EQUAL_FIELD:
    'Valor do campo deve ser menor ou igual ao campo',
  FILL_VALUE_LOWER: 'Valor do campo deve ser menor a',
  FILL_VALUE_LOWER_FIELD: 'Valor do campo deve ser menor ao campo',
  SUBMIT_DISPUTE: 'Enviar disputa',
  EXPLAIN_THE_PROBLEM_TO_CONSULTANT:
    'Explique ao consultor qual o problema encontrado com a entrega do serviço.',
  OPENING_DISPUTE: 'Disputa aberta',
  OK_UNDERSTAND: 'Ok, entendi',
  OPEN_DISPUTE_MESSAGE: 'A disputa foi aberta com os motivos selecionados:',
  SEND_MESSAGE_TO_BUYER:
    'Envie mensagem para o comprador para resolver. A disputa foi aberta com os motivos selecionados:',
  SERVICE_DISPUTE: 'Disputa de serviço',
  CONFIRM_EXECUTION: 'Confirmar execução',
  WANT_TO_CONFIRM_EXECUTION:
    'Deseja realmente confirmar a execução do serviço? Ao confirmar a execução você não poderá mais abrir disputas sobre esse item.',
  START_DISPUTE: 'Iniciar disputa',
  THERE_WAS_A_PROBLEM_IN_THE_CONSULTING:
    'Houve algum problema com a entrega da consultoria ?',
  YOUR_REQUEST_HAS_BEEN_SENT:
    'Sua solicitação foi enviada. O time do Sebraeplace irá analisar e entrar em contato em breve. Você receberá o retorno através do e-mail cadastrado no sistema.',
  DISPUTE_STARTED: 'Disputa iniciada',
  DID_HE_FINISH_THE_CONSULTANCY: 'finalizou a consultoria que você comprou ?',
  CONFIRM_CONSULTING: 'Confirmar consultoria',
  WAITING_FOR_CONSULTANT_TO_SEND_AN_INVOICE:
    'Aguardando Consultor enviar a Nota Fiscal',
  OPEN_DISPUTE: 'Abrir disputa',
  CONSULTANCY_FINALIZED: 'Consultoria finalizada',
  CONSULTANCY_ENDED_BY_DUSPUTE: 'Consultoria finalizada por disputa',
  NEGOTIATION_DETAILS: 'Detalhes da negociação',
  LOCALIZATION: 'Localização',
  NATIONAL_TERRITORY: 'Território nacional',
  MANDATORY: 'Obrigatório',
  START: 'Início',
  TERMINATION: 'Saída',
  INVALID_TIME_FORMAT: 'Formato de hora inválido(HH:MM).',
  ENT_TIME_GREATER_THAN_START_TIME: 'Hora final menor que hora inicial.',
  START_TIME_GREATER_THAN_END_TIME: 'Hora inicial maior que hora fim.',
  CHOOSE_DATE_EVENT: 'Escolha a data do seu evento',
  CHOOSE_DATE_PRODUCT: 'Escolha a data da sua palestra',
  CHOOSE_DATE_CONSULTING: 'Escolha a data da sua consultoria',
  CHOOSE_TIME_EVENT_DAYS:
    'Escolha os horários de acordo com dias do seu evento',
  CHOOSE_TIME_PRODUCT_DAYS:
    'Escolha os horários de acordo com dias da sua palestra',
  CHOOSE_TIME_CONSULTING_DAYS:
    'Escolha os horários de acordo com dias da sua consultoria',
  ADD_CITY: 'Adicionar Cidade',
  SEE_DISPUTE: 'Ver Disputa',
  TALK_BUYER: 'Fale com o comprador',
  INFORM_TIMES_EVENT_WILL_TAKE_PLACE:
    'Informe os horários que ocorrerá o evento',
  MESSAGE_NEGOTIATION: 'Mensagem',
  IMPORTANT_FINISH: 'Importante:',
  DOWNLOAD_INVOICE: 'Baixar nota fiscal',
  RECEIVED_INVOICE: 'Recebidas',
  PROBLEM_PAYMENT_DISPUTE: 'Tenho problema com o pagamento',
  PROBLEM_PRODUCT_DISPUTE: 'Tenho problema com o produto',
  PROBLEM_PLAN_DISPUTE: 'Não consigo alterar meu plano',
  PROBLEM_CODE_DISPUTE: 'Recebi o código de acesso mas não funciona',
  PROBLEM_ACCESS_DATA: 'Não recebi meus dados de acesso',
  PROBLEM_CANCEL_ACCESS_DISPUTE:
    'Eu paguei a assinatura mas o vendedor cancelou meu acesso',
  PROBLEM_ACCESS_DISPUTE:
    'Não consigo acessar todas as funcionalidades do plano contratado',
  IMPORTANT_FINISH_TEXT_1:
    'Se a proposta for aceita pelo fornecedor, a contratação somente é confirmada após o pagamento de um sinal equivalente a ',
  IMPORTANT_FINISH_TEXT_2:
    ' do valor total combinado. Caso haja cancelamento pelo contratante até 48h da data de execução contratada, cancelamento ou não comparecimento por parte do fornecedor o valor é estornado para o contratante. Caso a execução seja cancelada pelo contratante com menos de 48h da data de execução, ',
  IMPORTANT_FINISH_TEXT_3:
    'esse valor fica como ressarcimento ao fornecedor, conforme regras de pagamento estabelecidas nos termos de uso e contrato. O ressarcimento de despesas, se houverem, devem ser acordadas diretamente com o fornecedor. Esse valor não é ressarcido via Sebraeplace.',
  IMPORTANT_FINISH_TEXT_ANSWER_1:
    'Ao aceitar a proposta, a confirmação da contratação se dará mediante o pagamento pelo contratante de um sinal equivalente a ',
  IMPORTANT_FINISH_TEXT_ANSWER_2:
    ' do valor total combinado. Caso haja cancelamento pelo contratante até 48h da data da execução contratada, cancelamento ou não comparecimento por parte ',
  IMPORTANT_FINISH_TEXT_ANSWER_3:
    'do fornecedor o valor é estornado para o contratante. Caso a execução seja cancelada pelo contratante com menos de 48h da data de execução, esse valor fica ',
  IMPORTANT_FINISH_TEXT_ANSWER_4:
    'como ressarcimento ao fornecedor, conforme regras de pagamento estabelecidas nos termos de uso. O ressarcimento de despesas, se houverem, devem ser acordadas diretamente com o contratante. Esse valor não é ressarcido via Sebraeplace.',
  START_PROPOSAL_NEGOTIATION: 'Negociar proposta',
  TO_NEGOTIATE: 'Negociar',
  NEGOTIATION: 'Negociação',
  INFO_PRE_NEGOTIATION:
    'Inicie uma negociação a partir de qualquer proposta de orçamento',
  NEGOTIATION_STARTED_SUCCESSFULLY: 'Negociação iniciada com sucesso',
  VIEW_NEGOTIATION: 'Acessar negociação',
  CONFIRM_START_NEGOTIATION: 'Deseja iniciar uma negociação com o fornecedor',
  INFO_NEGOCIACAO:
    'O conteúdo das conversas trocadas aqui poderá ser visualizado pelo Sebraeplace a fim de melhorar o processo, bem como resolver disputas.',
  WAITING_PIX_PAYMENT_CONFIRMATION:
    'Estamos aguardando a confirmação de pagamento do PIX.',
  WAITING_BILLET_PAYMENT_CONFIRMATION:
    'Estamos aguardando a confirmação de pagamento do Boleto.'
};

const facaParteSaas = {
  WANT_BE_SAAS_PROVIDER: 'Quero ser um fornecedor de Solução Inteligente',
  START_NOW_SAAS: 'Começar agora',
  START_NOW_SAAS_2: 'Comece agora!',
  HOW_TO_BE_SOLUTION_PROVIDER: 'Como ser um fornecedor de Solução Inteligente',
  HOW_TO_BE_SOLUTION_PROVIDER_SUBTITLE:
    'Disponibilize seu produto no Sebraeplace e amplie seus canais de venda!',
  SAAS_BUSINESS_SOLUTION: 'O que é uma Solução Inteligente',
  SAAS_BUSINESS_SOLUTION_DESCRIPTION:
    'Uma Solução Inteligente no Sebraeplace significa um produto, um serviço, um processo, um software, uma plataforma, aplicativo ou solução que resolva uma necessidade ou uma dor de outras empresas de forma rápida, prática e econômica.',
  SAAS_BUSINESS_SOLUTION_DESCRIPTION_2:
    'Vai melhorar um processo? Vai gerar economia de recursos ou financeira? Vai fazer a empresa vender mais? Seu lugar de captar clientes é aqui!',
  EXCLUSIVE_BENEFITS: 'Disponibilize vantagens exclusivas',
  EXCLUSIVE_BENEFITS_DESCRIPTION:
    'Para estar no Sebraeplace é necessário que você ofereça alguma vantagem para o cliente. Seja um desconto, uma vantagem a mais ou mesmo os dois juntos são bem-vindos.',
  EXCLUSIVE_BENEFITS_DESCRIPTION_2:
    'Crie planos vantajosos para o Sebraeplace e capte muito mais clientes!',
  CHOOSE_MODALITY: 'Escolha a Modalidade da Solução Inteligente',
  CHOOSE_MODALITY_DESCRIPTION:
    'Sebraeplace oferece duas modalidades de Solução Inteligente:',
  CHOOSE_MODALITY_DESCRIPTION_2:
    'a) Modalidade Integração - Exclusiva para plataformas SAAS com assinatura recorrente. Nesse caso você integra sua plataforma e o cliente assina no Sebraeplace.',
  CHOOSE_MODALITY_DESCRIPTION_3:
    'b) Modalidade captação de leads - nessa modalidade você capta leads quentes para você entrar em contato e realizar sua proposta de venda, sem integração.',
  DISCOVER_AVAILABLE_PLANS: 'Conheça os planos de assinatura disponíveis',
  DISCOVER_AVAILABLE_PLANS_DESCRIPTION:
    'Faça parte de uma plataforma que vai escalar seu trabalho para um outro nível.',
  SEE_HOW_TO_BE_PART: 'Veja como fazer parte!',
  SEE_HOW: 'Veja como ',
  TO_BE_PART: ' fazer parte!',
  SEE_HOW_TO_BE_PART_DESCRIPTION:
    'Entenda o passo a passo de como se tornar um fornecedor de Solução Inteligente do Sebraeplace.',
  HOW_TO_MAKE_DIGITAL_SOLUTION_AVAILABLE:
    'Como disponibilizar minha Solução Inteligente?',
  SAAS_STEP_1: '1. Realize seu cadastro e da sua empresa.',
  SAAS_STEP_1_DESCRIPTION:
    'O primeiro passo é se cadastrar como fornecedor no Sebraeplace.',
  SAAS_STEP_1_DESCRIPTION_2:
    'Esse cadastro passa por uma homologação pela equipe do Sebrae.',
  SAAS_STEP_2: '2.Escolha a modalidade',
  SAAS_STEP_2_DESCRIPTION:
    'Você tem duas opções para cadastrar sua Solução inteligente: Modalidade Lead ou Modalidade Integração. Entenda a diferença:',
  SAAS_STEP_2_INTEGRATION: 'Modalidade Integração: ',
  SAAS_STEP_2_INTEGRATION_2:
    'É necessário realizar integrações do software com o Sebraeplace através de APIs REST. A contratação do plano e o gerenciamento dos assinantes serão realizadas por você no sistema do Sebraeplace.',
  SAAS_STEP_2_LEAD: 'Modalidade Lead: ',
  SAAS_STEP_2_LEAD_2:
    'Os dados de contato dos clientes interessados (Leads) serão enviados para você para que seja realizado o contato e abordagem de venda da sua solução inteligente.',
  SAAS_STEP_3: '3. Realize o cadastro do produto e crie sua landing page',
  SAAS_STEP_3_DESCRIPTION:
    'Você irá cadastrar a sua solução inteligente com todas as informações solicitadas.',
  SAAS_STEP_3_DESCRIPTION_2:
    'Por exemplo: nome, descrição, público alvo, categoria, segmento, porte da empresa que sua solução inteligente se destina, entre outras.',
  SAAS_STEP_4: '4. Realizar integração na modalidade Integração',
  SAAS_STEP_4_DESCRIPTION:
    'Para a modalidade Integração, será necessário realizar a integração com o Sebraeplace e testes em ambientes distintos para averiguação dos dados e confirmação de execução. Confira a ',
  SAAS_STEP_4_DESCRIPTION_2: 'documentação de integração',
  REGISTER_SAAS: 'Cadastre-se',
  LEAD_PLAN_EXPLANATION:
    'Nesse plano o Sebraeplace envia para você os dados de contato das empresas interessadas na sua Solução Inteligente.',
  INTEGRATION_PLAN_EXPLANATION: 'Neste plano a Assinatura é ',
  INTEGRATION_PLAN_EXPLANATION_2: ' e você só paga ',
  INTEGRATION_PLAN_EXPLANATION_3: ' de comissão ao Sebraeplace do que vender.',
  VITRINE_PLAN_EXPLANATION:
    'Nesse plano você recebe leads e paga apenas o valor da assinatura',
  FREE: 'GRATUITA',
  FREE_2: 'Grátis',
  COMMISSION_FOR_SEBRAEPLACE: 'Comissão para o Sebraeplace',
  LEAD_PLAN_SUBEXPLANATION:
    'Você pode gerenciar a quantidade de leads que deseja receber/mês',
  INTEGRATION_PLAN_SUBEXPLANATION:
    'O Sebraeplace recebe comissão durante todo o período de assinatura do cliente na sua plataforma.',
  PER_LEAD_SENT: 'Por lead enviado',
  LEAD: 'Lead',
  LEADS: 'Leads',
  INTEGRATION: 'Integração',
  VITRINE: 'Vitrine',
  INTEGRATION_DESCRIPTION:
    'É necessário realizar integrações do software com o Sebraeplace através de APIs REST. Será necessário realizar testes em ambientes distintos para averiguação dos dados e confirmação de execução.',
  EXCLUSIVE_SAAS_SUBSCRIBER: 'Exclusivo para Assinante SaaS Recorrente',
  EXCLUSIVE_SAAS_LEAD_SUBSCRIBER: 'Exclusivo para Assinante Leads',
  EXCLUSIVE_SAAS_VITRINE_SUBSCRIBER: 'Exclusivo para Assinante Vitrine',
  SELL_ON_THE_BIGGEST: 'Venda no maior',
  MARKETPLACE_FOR_COMPANIES: ' marketplace para empresas',
  OF_BRAZIL: ' do Brasil!',
  DONT_MISS_OUT_STEP_BY_STEP: 'Não fique de fora, veja abaixo o passo a passo!',
  JOIN_BEST_BUSINESS_PLATFORM:
    'Assine e participe da maior plataforma de negócios do Brasil!',
  JOIN_BEST_BUSINESS_PLATFORM_DESCRIPTION: 'O processo é simples e rápido!'
};

const produto = {
  SERVICE_DESCRIPTION: 'DESCRIÇÃO DO SERVIÇO',
  OFFER_VALUE: 'Proposta de Valor',
  RESULT_FOR_CLIENT: 'Resultado para o Cliente',
  TARGET_PUBLIC: 'Público Alvo',
  PARTICIPANTS_NUMBER: 'Número de participantes',
  PERSONA: 'Persona',
  SEE_VIDEO_AND_MORE: 'Veja o vídeo e saiba mais',
  MATERIAIS: 'Disposições necessárias',
  TOPICOS: 'Tópicos',
  MATERIAIS_NECESSARIOS: 'Materiais necessários:',
  ESTRUTURA_FISICA: 'Estrutura física necessária:'
};

const produtos = {
  SEE_COMPANY_PRODUCTS: 'Consultar por',
  PRODUCTS: 'Produtos',
  INFO_DELETE_PRODUCT: 'Você tem certeza que deseja excluir esse produto',
  ARE_YOU_SURE_YOU_WANT_TO_EDIT_THE_PRODUCT:
    'Tem certeza que deseja editar o produto?',
  INFO_EDIT_PRODUCT:
    'A alteração em um produto vigente no catálogo Sebraeplace levará a uma nova homologação.',
  DELETE_PRODUCT: 'Excluir produto',
  DESCRIPTION_EDITING_PRODUCT_IN_PRODUCTS:
    'A alteração em um produto vigente no catálogo Sebraeplace levará a uma nova homologação. A alteração só será atualizada após a homologação do Sebraeplace. Enquanto isso o seu produto continuará sendo comercializado no catálogo sem as alterações solicitadas.',
  DESCRIPTION_EDITING_PRODUCT_IN_REGISTER_PRODUCT_PRESENTIAL:
    'A alteração no seu produto só será atualizada após a homologação do Sebraeplace. Enquanto isso o seu produto continuará sendo comercializado no catálogo sem as alterações solicitadas.',
  LOSE_PRODUCT_INFORMATION:
    'A exclusão fará com que você perca os dados configurados nesse produto',
  MANAGE_PLAN: 'Gerenciar plano',
  TOTAL_COMPANIES: 'Total de empresas',
  TOTAL_PRODUCT_ACTIVE: 'Total de produtos ativos',
  PRODUCTS_ACTIVE: 'Produtos ativos',
  SUCCESSFULLY_SUSPENDED_PRODUCT: 'Produto suspenso com sucesso.',
  CONSULTANCY_SUCESSFULLY_SUSPENDED: 'Consultoria suspensa com sucesso.',
  COURSE_SUCESSFULLY_SUSPENDED: 'Curso suspenso com sucesso.',
  SUCCESSFULLY_REACTIVATED_PRODUCT: 'Produto reativado com sucesso.',
  COURSE_REACTIVATED_PRODUCT: 'Curso reativado com sucesso.',
  CONSULTANCY_SUCESSFULLY_REACTIVATED: 'Consultoria reativada com sucesso.',
  SUCCESSFULLY_DELETED_PRODUCT: 'Produto excluído com sucesso.',
  CONSULTANCY_SUCESSFULLY_DELETED: 'Consultoria excluída com sucesso.',
  COURSE_SUCESSFULLY_DELETED: 'Curso excluído com sucesso.',
  COMPANY: 'Empresa',
  PUBLIC_PRODUCT: 'Produto público',
  EDIT_MY_PRODUCT: 'Editar meu produto',
  PRODUCT_REMAINS_IN_FORCE:
    'O seu produto permanecerá vigente no catálogo até que a versão em homologação seja aprovada.',
  PUBLIC_PRODUCT_CHANGES: 'Alterações em Produto público',
  REQUESTED_CHANGES_TO_THE_PRODUCT_BEING_REGISTERED:
    'As alterações solicitadas no produto em cadastramento, serão substituídas no catálogo após  envio para homologação e aprovação.',
  REQUESTED_CHANGES_TO_THE_PRODUCT_ARE_BEING_APPROVED:
    'As alterações solicitadas no produto estão em homologação, serão substituídas no catálogo após aprovação.',
  THE_ARE_CHANGES_IN_THE_PRODUCT_THEY_WILL_BE_REPLACED_IN_THE_CATALOG_AFTER_ITS_PUBLICATION:
    'Existem alterações no produto, serão substituídas no catálogo após sua publicação.',
  CONFIRM_PRODUCT_SELL_SUSPENDING:
    'Tem certeza que gostaria de suspender a venda do produto?',
  SUSPEND: 'Suspender',
  SUSPEND_SALE: 'Suspender a venda',
  ARE_YOU_SURE_SUSPEND_SALE:
    'Você tem certeza que deseja suspender suas vendas?',
  SUSPEND_SALE_EXPLANATION:
    'A venda será suspensa até o início do próximo mês ou alteração de limite mensal de leads',
  LIMIT_LEADS_REACHED: 'Limite de leads atingido',
  HOW_ACTIVE_LEADS_AGAIN:
    'Para ativar a venda até o próximo vencimento, você pode aumentar o limite de leads acessando o botão Lead Mensal no card do produto.',
  CHANGE_NUMBER_OF_LEADS: 'Alterar a quantidade de leads',
  REACTIVATE: 'Reativar',
  REACTIVATE_SALE: 'Reativar a venda',
  ARE_YOU_SURE_REACTIVATE_SALE:
    'Você tem certeza que deseja reativar suas vendas?',
  REACTIVATE_SALE_EXPLANATION:
    'A venda ficará ativa até que seja suspensa novamente',
  CONFIRM_PRODUCT_DELETING: 'Tem certeza que gostaria de excluir o produto?',
  PROFESSIONALS: 'Profissionais',
  VALUE_EDIT: 'Editar Valor',
  INFORM_THE_VALUE_USUALLY:
    'Informe o valor usualmente praticado fora da Plataforma Sebraeplace, esse valor será exibido no catalogo e na vitrine do seu produto.',
  MARKET_PRICE: 'Preço de mercado',
  INSERT_PRICE_SEBRAEPLACE:
    'Insira um preço vantajoso no Sebraeplace e atraia ainda mais clientes!',
  INSERT_PRICE_SEBRAEPLACE_2:
    ' Valores de ao menos 15% de desconto geralmente são mais atrativos.',
  SEBRAEPLACE_PRICE: 'Preço Sebraeplace',
  BACK_TO_PROFESSIONALS: 'Voltar para Profissionais',
  PENDING_PRODUCT: 'Produto pendente',
  ACTIVE_PRODUCT: 'Produto ativo',
  INCOMPLETE_PRODUCT: 'Cadastro incompleto',
  SUSPENDED_PRODUCT: 'Produto suspenso'
};

const consultoria = {
  COVER_IMAGE: 'Imagem de Capa',
  INVESTMENT: 'Investimento',
  TELL_YOUR_CONSULTING:
    'Fale um pouco sobre a sua consultoria. Não se esqueça de ser criativo e detalhista, os clientes irão lhe escolher com base nisso.',
  INVESTMENT_DESC_CONSULTANCY:
    'Insira seu valor por hora de serviço. A quantidade de horas totais por consultoria deverá ser negociada individualmente com o seu cliente, de acordo com as necessidades dele e sua disponibilidade.',
  REPORT_STARS: 'Denunciar',
  REPORT_COMMENT: 'Denunciar comentário',
  CLARIFY_WHY_REPORT:
    'Esclareça o motivo pelo qual acha esse comentário é impróprio',
  TYPE_THE_REASEON_REPORT: 'Escreva aqui o motivo da denuncia',
  REPORT_SENT: 'Denúncia enviada',
  PLEASE_FILL_IN_THE_ANSWER: 'Por favor, preencha a resposta',
  YOUR_REPORT_HAS_BEEN_SENT:
    'Sua denuncia foi enviada para análise do Sebraeplace, caso seja julgado inadequado ou ofensivo, o comentário será excluído da plataforma.',
  SEE_MORE_REVIEWS: 'Ver mais avaliações',
  EVALUATION: 'Avaliações',
  CONSULTANCY_SOLD: 'Consultorias vendidas',
  SALES: 'Vendas',
  CONTACTS_COUPON: 'Contatos',
  CONSULTANCY_EVALUATION: 'Avaliações do consultor'
};

const meuPlano = {
  MY_PLAN: 'MEU PLANO'
};

const shared = {
  PER: 'por',
  SEE_MORE: 'Ver mais',
  SEE_ALL: 'Ver tudo',
  SEE_THE_CONSULTANCIES: 'Veja as consultorias',
  PLAN: 'Plano',
  PLANS: 'Planos',
  SHOW_LESS: 'Mostrar menos',
  SHOW_MORE: 'Mostrar mais',
  MONTHLY_VALUE: 'Assinatura mensal',
  ANNUAL_VALUE: 'Assinatura anual',
  CONTENT_FIXED1:
    '*Todos os produtos e serviços precisam ser aprovados na homologação da equipe de curadoria do Sebraeplace para serem disponibilizados para a venda.',
  CONTENT_FIXED2:
    '*Você pode solicitar cancelamento a qualquer momento, sua mensalidade não será cobrada na fatura posterior.',
  CONTENT_FIXED3:
    '*Conheça todas as condições nos termos de uso do fornecedor.',
  TOTAL_VALUE: 'Valor Total',
  PENDING_VALUE: 'Valor Pendente',
  TOTAL_WITHDRAWN: 'Total Sacado',
  TOTAL_PLANNED: 'Saldo Disponível',
  WALLET: 'Carteira',
  BACK: 'Voltar',
  UNDO: 'Desfazer',
  VIEW: 'Visualizar',
  THANKS: 'Obrigado',
  PAYMENT_PREFERENCE: 'Como você prefere pagar?',
  REQUIRED_FIELD: 'Campo obrigatório',
  FIELD_VALUE_MUST_BE_GREATER_THAN: 'Valor do campo deve ser maior que',
  CLOSE: 'Fechar',
  NAME_ACCOUNT_HOLDER: 'Nome do titular da conta',
  ESTIMATED_INCOME_HOLDER: 'Renda estimada do titular',
  CPF_CNPJ: 'CPF/CNPJ',
  SECURITY_CODE: 'Código de segurança',
  CONTINUE: 'Continuar',
  FULL_NAME: 'Nome Completo',
  CPF: 'CPF',
  CNPJ: 'CNPJ',
  CNPJ_CADPRO: 'CNPJ/CADPRO',
  DATE_BIRTH: 'Data de Nascimento',
  EMAIL: 'Email',
  EMAIL_COLON: 'Email: ',
  SIGN_UP: 'Inscrever-se',
  CELLPHONE: 'Celular',
  ADDRESS: 'Endereço',
  CEP: 'CEP',
  STATE: 'Estado',
  CITY: 'Cidade',
  BAIRRO: 'Bairro',
  LOGRADOURO: 'Logradouro',
  NUMBER: 'Número',
  NUMBER_MAX_VALUE: 'Número deve possuir no máximo 6 caracteres',
  COMPLEMENT: 'Complemento',
  NAME: 'Nome',
  FONE: 'Fone',
  YES: 'Sim',
  OK: 'Ok',
  SIGNED_ON: 'Assinado em',
  YOU_MAY_ALSO_LIKE: 'Você também pode gostar',
  NO_NEGOTIATIONS_PROGRESS: 'Você não possui negociações em andamento.',
  NO_NEGOTIATIONS_CANCELED: 'Você não possui negociações canceladas.',
  NO_BUDGETS_SEBRAETEC: 'Você não possui orçamentos Sebraetec.',
  REASONS: 'Motivos',
  START_NEGOTIATION: 'Iniciar Negociação',
  ACCESS_COMPANY: 'Acessos',
  ACCESS_INFO:
    'Contabilização de Acessos a sua página de perfil e a página dos seus produtos.',
  ACCESS: 'Acessar',
  WEB_REFERENCES: 'Referências na Web',
  REFERENCES: 'Referências',
  YOU_DONT_HAVE_NEGOTIATIONS: 'Você não possui negociações em andamento.',
  GO_BACK: 'Voltar',
  INITIATE: 'Iniciar',
  SAVE: 'Salvar',
  SAVE_CHANGES: 'Salvar alterações',
  QUITTER: 'Desistente',
  REGISTER: 'Cadastro',
  WITHDRAWAL: 'Desistência',
  EDIT: 'Editar',
  SIGN: 'Assinar',
  DESCRIPTION_REQUIRED: 'A descrição é obrigatória',
  RESEND_EMAIL: 'Reenviar e-mail',
  DELETE: 'Excluir',
  TOTAL: 'Total',
  MONTH: '/Mês',
  NO: 'Não',
  MORE: 'Mais',
  ORDER_BY: 'Ordenar por',
  DATE: 'Data',
  DRAFT: 'Rascunho',
  YOU_DONT_HAVE: 'Você não possui',
  INSTRUCTOR: 'Instrutor',
  INSTRUCTORS: 'Instrutores',
  PARTICIPANTS: 'Participantes',
  ENROLLEDS: 'Inscritos',
  START: 'Início',
  END: 'Final',
  VERSION: 'Versão',
  OUTPUT: 'Saída',
  LATEST: 'Mais recente',
  LESS_RECENT: 'Menos recente',
  OLDER: 'Mais antigo',
  MOST_CONVERTED: 'Mais convertidas',
  STATE_REGISTRATION: 'Inscrição Estadual',
  MOST_VIEWS: 'Mais acessadas',
  DESCRIPTION_SLUG:
    'Slug é a parte de uma URL que pode ser legível tanto para humanos quanto para mecanismos de busca. Personalize sua url. Ex: ',
  TERMINATION: 'Término',
  CLASSIFICATION: 'Classificação',
  ALTER_TO: 'Alterar para',
  AS_FROM: 'A partir de',
  FOR_PRICE: 'Por',
  SEND: 'Enviar',
  TIME_TABLE: 'Horário',
  AMOUNT: 'Quantidade',
  START_TIME: 'Horário de início',
  END_TIME: 'Horário de término',
  MINIMUM_AGE: 'Idade mínima',
  AGE: 'Idade',
  YEARS: 'anos',
  MINIMUN: 'Mínima',
  MAXIMUN: 'Máximo',
  REALIZATION: 'Realização',
  SEE_RESUME: 'Ver resumo da compra',
  ERROR: 'Erro',
  SUCCESS: 'Sucesso',
  WARNING: 'Atenção',
  ALERT_REDIRECTED_UNAUTHORIZED_ACCESS:
    'Você tentou acessar uma página inacessível para seu usuário ou vínculo atual e por isso foi redirecionado.',
  CHANGE_MADE_SUCCESSFULLY: 'Alteração realizada com sucesso',
  RESUME: 'Resumo',
  UP_TO: 'Em até ',
  COLOR: 'cor',
  OPTIONAL: 'Opcional',
  CHARACTERS: 'Caracteres',
  REQUIREMENTS: 'Requisitos',
  MAXIMUM_AMOUNT_REACHED: 'quant. máxima atingida',
  PRIVACY_POLICY: 'Política de privacidade',
  KNOW_MORE: 'Conheça mais',
  WANT_TO_KNOW_MORE: 'Quer saber mais?',
  SLUG_UNAVAIBLE: 'Slug indisponível',
  SLUG_INVALID: 'Slug inválido',
  PLAN_REQUIRED: 'Plano obrigatório',
  TO: 'Para',
  DISCLOSE: 'Divulgue',
  PERCENTAGE: 'Porcentagem',
  SEBRAEPLACE_SERVICES: 'Serviços Sebraeplace',
  IN_SEBRAEPLACE: 'No Sebraeplace:',
  PREVIOUS_STEP: 'Passo anterior',
  AVAILABLE_REGION_SAAS: 'Solução inteligente disponível para as regiões',
  AVAILABLE_BRAZIL_SAAS: 'Disponível para todo o Brasil',
  TERMS_OF_USE_HAVE_CHANGED: 'Os termos de uso mudaram',
  STATUS: 'Status'
};

const perfil = {
  ABOUT: 'Sobre',
  LOAD_MORE: 'Carregar mais',
  ADD_CUSTOMER: 'Adicionar cliente',
  ADD_LOGO: 'Adicione a logo da empresa e insira o nome no campo ao lado',
  RATE_LATER: 'Avaliar depois',
  RATE_COMPLETED_CONSULTANCY: 'Avalie a consultoria concluída',
  YOU_HAVE_CONFIRMED_CONSULTANCY:
    'Você confirmou a execução de uma consultoria.',
  RATE_IS_QUICK_AND_HELP_US:
    'A avaliação é rápida e nos ajuda a manter a qualidade do serviço. Avalie!',
  RATE_NOW_MODAL: 'Avaliar',
  ADD_FILE_MATERIAL:
    'Adicionar o arquivo que irá disponibilizar no seu perfil e insira o nome no campo ao lado',
  PORTFOLIO: 'Portfólio',
  SERVICE_REGION: 'Região de atendimento'
};

const footer = {
  CONTACT: 'Contato',
  ABOUT_DESC_1:
    'O Sebraeplace é um espaço de conexão entre soluções de mercado e os empreendedores, com o objetivo de oferecer apoio técnico e conhecimento altamente qualificados de forma prática, rápida e segura. O Sebraeplace ou o Sebrae ',
  ABOUT_DESC_2: 'não é fornecedor dos produtos e serviços oferecidos',
  ABOUT_DESC_3:
    ', mas realiza a curadoria da plataforma, oferecendo um espaço para que empresas e profissionais possam negociar direta e exclusivamente entre si.',
  FAST_ACCESS: 'Acesso rápido',
  HOME: 'Home',
  CUSTOMER_TERMS_OF_USE: 'Termos de uso do cliente',
  SUPPLIER_TERMS_OF_USE: 'Termos de uso do fornecedor',
  FREQUENTLY_ASKED_QUESTIONS: 'Dúvidas frequentes',
  I_WANT_TO_BE_A_SUPPLIER: 'Quero ser fornecedor',
  OMBUDSMAN: 'Ouvidoria Sebrae',
  PHONE: '0800 570 0800',
  E_MAIL: 'sebraeplace@pr.sebrae.com.br',
  WHATSAPP_NUMBER: '41 99787-8003',
  CHAT_PAGE: 'sebraepr.com.br/sebraeplace',
  ACCOMPANY: 'Acompanhe',
  CONTACT_US: 'Fale conosco',
  STILL_HAVE_DOUBTS: 'Ficou com alguma dúvida?',
  SEND_AN_EMAIL: 'Envie um email!',
  OPENING_HOURS: 'Horário de Atendimento',
  OPENING_HOURS_CUSTOMER: 'Customer Success: 09:00 as 18:00 horas',
  OPENING_HOURS_SUPPORT: 'Suporte: 09:00 as 18:00 horas',
  MONDAY_TO_FRIDAY: 'Segunda à Sexta',
  PAYMENT_TYPES: 'Formas de pagamento',
  AMERICAN_EXPRESS: 'American Express',
  DINERS: 'Diners',
  ELO: 'Elo',
  MASTERCARD: 'Mastercard',
  VISA: 'Visa',
  BOLETO_BANCARIO: 'Boleto Bancário',
  FOOTER_DESC: 'Sebrae/PR - Todos os direitos reservados',
  DEVELOPED_BY: 'Desenvolvido por',
  WISE: 'Wise'
};

const faq = {
  FAQ__TITLE: 'Dúvidas mais frequentes',
  FAQ__DESC:
    'Está com dúvidas? Consulte aqui as dúvidas mais frequentes e faça parte!'
};

const cardPayment = {
  UP_TO_12_INTEREST_FREE: 'Até 3 vezes sem juros'
};

const cardPlan = {
  PLAN_CANCELED_MODAL:
    'O cancelamento da assinatura foi solicitado com sucesso',
  PLAN_CANCELED_DESC_MODAL:
    'Em breve você terá um retorno por e-mail sobre a sua solicitação de cancelamento. Você pode voltar a assinar essa Solução Inteligente a qualquer momento ou escolher outra que melhor atenda as suas necessidades.',
  PLAN: 'Plano',
  SEE_MORE: 'Veja Mais',
  ISSUER_ALT: 'Bandeira do Cartão',
  PLAN_CANCELED_AWAIT: 'Aguardando Cancelamento',
  SEE_PLANS: 'Ver Planos',
  YEAR: '/Ano',
  HALFYEAR: '/Semestre',
  CHANGE: 'Alterar',
  VALID_UNTIL: 'Válido Até:',
  NEXT_CHARGE_IN: 'Próxima Cobrança em:',
  REGISTERED_CARD: 'Cartão cadastrado',
  AUTOMATIC_MONTHLY_CHARGE: 'Cobrança mensal automática',
  CHANGE_CREDIT_CARD: 'Alterar cartão de crédito',
  SUBSCRIBE_PLAN: 'Assinar Plano',
  CANCEL_PLAN: 'Cancelar plano',
  REACTIVATE_PLAN: 'Reativar plano',
  NEXT_CHARGE: 'Próxima cobrança:',
  FREE_TRIAL_EXPIRES_ON: 'Avaliação gratuita expira em:',
  SIGN_THE_PLAN_TO_CONTINUE:
    'Assine o plano para continuar usufruindo todos os beneficios',
  TRY_IT_NOW: 'Teste a partir de agora',
  ALTER_PLAN: 'Alterar plano',
  FREE_DAYS: 'dias grátis'
};

const carrinhoComponent = {
  MORE_PRODUCTS_SELLER: 'Mais produtos do vendedor',
  AVAILABLE: 'disponíveis'
};

const comentarios = {
  COMMENTS: 'Comentários',
  REPLY: 'Responder',
  COMMENT: 'Comentar',
  COMMENT_THE_EVENT: 'Comente algo sobre o evento'
};

const header = {
  CLIENT: 'Cliente',
  EDIT_COMPANY_PROFILE: 'Editar perfil empresa',
  VIEW_COMPANY_PROFILE: 'Ver perfil empresa',
  MY_DASHBOARD: 'Meu Painel',
  AFFILIATE_DASHBOARD: 'Painel do Afiliado',
  EDIT_PROFILE: 'Editar perfil',
  VIEW_PROFILE: 'Ver perfil',
  ALTERAR_SENHA: 'Alterar senha',
  EXIT: 'Sair',
  NO_NEW_NOTIFICATIONS: 'Não há novas notificações',
  VIEW_ALL: 'Ver todas',
  BECOME_SUPPLIER: 'Tornar-se fornecedor',
  WANT_TO_BE_SUPPLIER: 'Quero ser Fornecedor',
  CREATE_YOUR_ACCOUNT: 'Crie sua conta',
  ENTER: 'Entre',
  SEARCH_PLACEHOLDER: 'Favor inserir um texto para a busca'
};

const inscricao = {
  SUBSCRIPTION: 'INSCRIÇÃO',
  NO_VALUE_RS: 'R$ 0,00',
  CLOSED: 'Encerrado',
  NOT_STARTED: 'Não iniciado',
  TEMPORARILY_SUSPENDED: 'Temporariamente suspenso'
};

const inscricaoDois = {};

const listAvatar = {
  VIEW_ALL_PARTICIPANTS: 'Ver todos os participantes',
  VIEW_ALL_INSTRUCTORS: 'Ver todos os instrutores'
};

const listPlans = {
  MONTHLY: 'Mensal',
  SEMIANNUAL: 'Semestral',
  SEMESTER: 'Semestral',
  YEARLY: 'Anual',
  YOU_ARE_REDUCING_YOUR_PLAN: 'Você está reduzindo o seu plano',
  SOME_FEATURES_WILL_BE_REDUCED:
    ' Alguns funcionalidades serão reduzidas, tem certeza que deseja alterar o plano atual?',
  CURRENT_PLAN: 'Plano atual',
  CHOOSE_ANOTHER_PLAN: 'Escolher outro plano',
  PLAN_SUBSCRIPTION: 'Assinatura de plano',
  PLAN_THAT_WILL_SIGN_DOES_NOT_COVER_PEODUCTS:
    'Você está assinando um plano que não cobre a publicação de um ou mais produtos cadastrados no seu perfil, tem certeza que deseja continuar?',
  IF_YOU_CHOOSE_TO_CONTINUE_WITH_THE_PLAN_SIGN:
    'Se optar em assinar o plano selecionado, um ou mais produtos cadastrados ficarão sem cobertura, a venda e anúncio permanecerão indisponíveis.',
  IF_YOU_CHOOSE_TO_CONTINUE_WITH_THE_PLAN_CHANGE:
    'Se optar em continuar com a alteração de plano, a venda e anúncio de alguns produtos ficará indisponível.',
  PLAN_CHANGE_INFORMATION: `*Todos os produtos e serviços precisam ser aprovados na homologação da equipe de curadoria do Sebraeplace para serem disponibilizados para a venda. 
    *Você pode solicitar cancelamento a qualquer momento, sua mensalidade não será cobrada na fatura posterior.
    *Conheça todas as condições nos termos de uso do fornecedor.`,
  THE_CURRENT_PLAN_DOES_INCLUDE:
    'O plano atual não contempla a venda e anuncio dessa categoria de produto'
};

const redesSociais = {
  FOLLOW: 'Seguir'
};

const catalogo = {
  TYPE_EVENT: 'Tipo de evento',
  NO_RESULTS_FOUND: 'Nenhum resultado encontrado',
  FILTER: 'Filtrar',
  ORGANIZE_ADS: 'Organizar anúncios',
  FILTER_TITLE: 'Busque a melhor solução para seu negócio',
  MOST_REVELANTS: 'Mais relevantes',
  LOWEST_PRICE: 'Menor preço',
  BIGGEST_PRICE: 'Maior preço',
  BEST_AVALIATION: 'Melhor avaliado',
  MODALITY: 'Modalidade',
  LINK_STATUS: 'Status do link',
  CLEAR_FILTER: 'Limpar Filtro',
  PERIOD: 'Período',
  ORDER_CATALOG: 'Ordenar',
  ALL: 'Todos',
  ALL_A: 'Todas',
  MODALITIES: 'Modalidades',
  PRICE: 'Preço',
  AREAS: 'Temas',
  SEBRAE_CERTIFICATE: 'Conexão Certificada Sebrae',
  CONSULTANCY_TITLE: 'Consultoria',
  COURSES_AND_EVENTS: 'Cursos e eventos presenciais',
  SAAS_TITLE: 'Soluções Inteligentes',
  OF_PRODUCT: 'do produto',
  SEARCH_PLACEHOLDER: 'Ex: consultoria em marketing',
  CATALOG_BANNER_TITLE:
    'Encontre a melhor solução para a sua empresa no maior marketplace de negócios do Brasil.',
  CATALOG_BANNER_DESC:
    'Procure, analise, compare e compre de forma fácil e segura!',
  CATALOG_BANNER_DESC_2: 'Soluções do mercado, curadoria do Sebrae.',
  CATALOG_TITLE_1: 'Aqui você encontra as',
  CATALOG_TITLE_2: ' melhores',
  CATALOG_TITLE_3: 'soluções',
  CATALOG_TITLE_4: ' para oferecer aos clientes',
  CATALOG_TITLE_5: 'da sua região.',
  CATALOG_LOCALE: 'Paraná',
  POPULAR_TALKS: 'Palestra populares',
  POPULAR_SOLUTIONS: 'Soluções mais populares',
  ALL_PROVIDERS: 'Todos os fornecedores',
  RESEARCH: 'Pesquisar',
  AVALIATIONS_CONSULTANT: 'Avaliações do consultor',
  THEMES: 'Temas',
  SUBTHEMES: 'Subtemas',
  CONSULTANCY_OF: 'Consultoria de ',
  EVENTS_TITLE: 'Cursos e eventos presenciais - mais próximos de você.',
  TICKET_STARTING_FROM: 'Ingressos a partir de',
  FROM_PRICE: 'A partir de:',
  SEBRAEPLACE_FROM_PRICE: 'No Sebraeplace a partir de:',
  SEBRAETEC_DISCOUNT_ONLY_FOR_MEI:
    'Subsidio aplicável apenas para empresas: MEI, ME e EPP localizadas no estado do Paraná. <0>Clique aqui</0> e confira se sua empresa se enquadra',
  VALUE_WITHOUT_SEBERAETEC_DISCOUNT: 'Valor sem o subsídio do Sebrae',
  SEE_CATALOG: 'Ver catálogo',
  AVALIATIONS: 'Avaliações',
  ALL_DATES: 'Todas as datas',
  THIS_WEEK: 'Esta semana',
  NEXT_WEEK: 'Próxima semana',
  THIS_MONTH: 'Este mês',
  SEE_MORE_RESULTS: 'Ver mais resultados',
  PLAN_STARTING_FROM: 'Plano a partir de',
  PLANS_STARTING_FROM: 'Planos a partir de',
  ONLINE_COURSE: 'Cursos online',
  KNOW_MORE_SAAS: 'Saiba mais',
  CHOOSE_PLAN: 'Escolha o plano',
  CHOOSE_ROLE: 'Escolha o papel',
  REQUEST_AN_ESTIMATE: 'Solicite um Orçamento',
  SEBRAE_WILL_COVER_UP_TO: 'Subsídio Sebrae de até <0>{{value}}%</0>',
  CATEGORIES: 'Categorias',
  SUBCATEGORY: 'Subcategoria',
  SEGMENTS: 'Segmentos',
  PORTES: 'Portes',
  TO_KNOW_MORE: 'Para saber mais:',
  REQUEST_CONTACT: 'Solicite contato'
};

const favoritos = {
  FAVORITES: 'Favoritos',
  ADDED_FAVORITE: 'Adicionado ao favoritos com sucesso',
  REMOVED_FAVORITE: 'Removido do favoritos com sucesso '
};

const satisfacao = {
  TITLE_SATISFACAO: 'Pesquisa de Satisfação',
  TITLE_PASSO1_1:
    'Em uma escala de 0 a 10, o quanto você indicaria esse Evento para seus amigos ou familiares?',
  TITLE_PASSO1_2: 'Diga-nos o que achou sobre a organização evento',
  TITLE_PASSO1_1_CONSULTORIA:
    'Diga-nos o que achou sobre o consultor e a consultoria',
  TITLE_PASSO1_2_CONSULTORIA: 'Diga-nos o que achou sobre a consultoria',
  TITLE_PASSO1_SAAS: 'Diga-nos o que achou sobre o atendimento do fornecedor',
  TITLE_PASSO2: 'Diga-nos o que achou sobre o instrutor e o tema',
  TITLE_PASSO2_SAAS: 'Diga-nos o que achou sobre o produto adquirido.',
  BTN_ANTERIOR: 'Anterior',
  BTN_PROXIMO: 'Próximo',
  BTN_CONCLUIR: 'Concluir',
  TXT_SATISFEITO: 'MUITO SATISFEITO',
  TXT_INSATISFEITO: 'MUITO INSATISFEITO',
  TXT_LABEL_PASSO1:
    'Em poucas palavras, descreva o que motivou sua nota. (Opcional)',
  COMMENT_DESCRIBE_EXPERIENCE:
    'Deseja descrever brevemente sua experiência com o serviço?',
  COMMENT_MAIN_SERVICE_PROVIDED:
    'Qual foi o principal serviço realizado pelo fornecedor?',
  COMMENT_OBTAINED_RESULT:
    'Descreva brevemente o resultado obtido com o serviço.',
  PL_TXTAREA: 'Escreva uma mensagem',
  TITLE_PASSOFINAL: 'Parabéns',
  TXT_SUCCESS1: 'Pesquisa enviada com sucesso.',
  TXT_SUCCESS2: 'Sua opinião é muito importante para nós!',
  BTN_HOME: 'Seguir para página inicial',
  BTN_PAINEL: 'Seguir para o painel',
  TELL_US_WHAT_YOU_THINK_SUPPLIER:
    'Diga-nos o que achou sobre o atendimento do fornecedor',
  TELL_US_WHAT_YOU_THINK_ABOUT_PRODUCT:
    'Diga-nos o que achou sobre o produto adquirido.',
  TELL_US_WHAT_YOU_THINK_ABOUT_THE_SUPPLIER:
    'Diga-nos o que achou sobre o fornecedor',
  RATE_THE_SUPPLIER: 'Avalie o fornecedor:',
  RATE_THE_SUPPLIER_INFO:
    'Deixe um depoimento público sobre a sua opinião do fornecedor. Essa mensagem será publicada na página de perfil do fornecedor. (Opcional)'
};

const cadastroEvento = {
  DATE_START: 'Data início',
  DATE_END: 'Data fim',
  CONSULTANT: 'Consultor',
  ALERT_ONLY_3_IMAGES: 'É permitido cadastrar apenas 3 imagens',
  ALERT_ONLY_N_FILES: 'É permitido cadastrar apenas $N$ arquivos',
  ALERT_IMAGES_EXTENSIONS: 'É permitido imagens em JPEG, JPG ou PNG',
  ALERT_IMAGE_SIZE: 'É permitido imagens com o tamanho menor que 2MB',
  ALERT_AVATAR_SIZE: 'É permitido imagens com o tamanho menor que 3,5MB',
  ERROR_ON_IMAGE_UPLOAD: 'Erro ao fazer upload da imagem, tente novamente',
  ALERT_FILE_SIZE: 'É permitido arquivos com o tamanho menor que ',
  ALERT_IMAGE_RESOLUTION:
    'É permitido imagens com resolução mínima de  $width$ x $height$.',
  DESCRIPTION_APPEARANCE:
    'Insira aqui até 3 imagens atrativas para o seu evento. Lembre-se de utilizar imagens a qual você tem direito de uso ou sejam de licença gratuita. Tamanho 1420 x 670 px arquivos em JPEG, JPG ou PNG.',
  IMAGE_DELETION_ALERT:
    'Antes de adicionar nova foto, exclua uma das escolhidas anteriormente.',
  CLICK_ADD_COVER_IMAGE:
    'Clique para adicionar uma foto para capa do seu evento',
  EVENT_COVER: 'Capa do evento',
  GO_TO_PANEL: 'Ir para o seu Painel',
  DESCRIPTION_CONGRATULATIONS_EVENT:
    'Você cumpriu a primeira etapa, agora cadastre seus ingressos para lançar o evento na plataforma.',
  REGISTER_TICKET_EVENT: 'Cadastro ingresso do evento',
  SEE_PREVIEW_EVENT: 'Ver prévia completa da página do evento',
  SEE_PREVIEW: 'Ver prévia',
  SEE_PAGE: 'Ver Página',
  EDIT_PAGE: 'Editar Página',
  EVENT_PREVIEW: 'Prévia do evento',
  MAXINUM_AUDIENCE_CAPACITY: 'Capacidade máxima de público',
  ENT_TIME_GREATER_THAN_START_TIME: 'Hora final menor que hora inicial.',
  START_TIME_GREATER_THAN_END_TIME: 'Hora inicial maior que hora fim.',
  INVALID_TIME_FORMAT: 'Formato de hora inválido(HH:MM).',
  CHOOSE_TIMES_ACCORDING_TO_YOUR_EVENT_DAYS:
    'Escolha os horários de acordo com dias do seu evento',
  INFORM_THE_DAYS_THAT_THE_EVENT_WILL_TAKE_PLACE:
    'Informe os dias que ocorrerá o evento',
  DESCRIPTION_DATE_EVENT:
    'Defina a data que acontecerá o evento e o horário, caso tenha mais de um dia, configure dia a dia.',
  DESCRIPTION_LOCATION_EVENT: 'Insira o endereço do evento.',
  DESCRIPTION_CAPACITY_EVENT:
    'Informe qual a capacidade máxima de público no local do evento.',
  NAME_OF_YOUR_EVENT: 'Nome do seu evento',
  DECRIPTION_TITLE_EVENT:
    'Fale um pouco sobre seu evento. Coloque um nome bem atrativo e conte para os clientes o que eles podem esperar do seu evento!',
  ADD_INSTRUCTORS: 'Adicionar Instrutores',
  SELECT_SPEAKERS_FOR_THIS_EVENT: 'Selecione os palestrantes para esse evento',
  SELECT_INSTRUCTORS_FOR_THIS_EVENT:
    'Selecione os instrutores para esse evento',
  NEGOTIATED_SCHEDULE: 'Agenda negociada',
  INCLUDE_INSTRUCTOR: 'Incluir instrutor',
  ALERT_MODAL_DAYS_SCHEDULE: 'Encontramos algo errado na programação do dia',
  ADD_ACTIVITY: 'Adicionar atividade',
  EDIT_PROGRAMMING: 'Editar programação',
  ADD_PROGRAMMING: 'Adicionar programação',
  DESCRIPTION_INSTRUCTORS_EVENT:
    'Você pode voltar e escolher mais instrutores a qualquer momento.',
  DESCRIPTION_PROGRAMMING_EVENT:
    'Organize seu evento, adicione seus instrutores de acordo com o horário e tema que vão apresentar. Não se esqueça de incluir as pausas, como coffee break e almoço, caso necessário.',
  DESCRIPTION_SELECT_INSTRUCTOR_1: ' Vamos começar a criar o seu evento!.',
  DESCRIPTION_SELECT_INSTRUCTOR_2:
    'Seu evento está relacionado diretamente com essa negociação?',
  CHOOSE_ANOTHER_NEGOTIATION: 'Escolher outra negociação',
  CHOOSE_ONE_INSTRUCTOR:
    'Vou configurar o evento a partir de uma negociação (Apenas 1 instrutor)',
  CHOOSE_MULTI_INSTRUCTORS: 'Vou configurar o Evento (Mais de 1 instrutor)',
  DESCRIPTION_THEMATIC_EVENT:
    'Selecione a temática do evento. Isso facilitará a busca dos seus clientes no catálogo de produtos.',
  DESCRIPTION_CLASSIFICATION_EVENT:
    'As classificações listadas abaixo estão vinculadas as atividades adicionadas a esse evento. Você deve selecionar a que melhor corresponde o seu evento.',
  OFFICIAL_EVENT_WEBSITE: 'Site oficial do evento',
  CREATE_EVENT_FROM_NEGOTIATION_MESSAGE:
    'Agora que a negociação está finalizada, você pode criar um evento a partir destes dados.',
  YOUR_EVENT_NAME_WILL_APPEAR_HERE: 'Aqui vai aparecer o nome do seu evento',
  YOU_HAVE_NOT_YET_ADDED_AN_IMAGE_FOR_THIS_EVENT:
    'Você ainda não adicionou uma imagem para esse evento',
  THERE_ARE_CURRENTLY_NO_INSTRUCTORS: 'No momento não há instrutores.',
  THERE_ARE_CURRENTLY_NO_SPEAKERS: 'No momento não há palestrantes.',
  EVENT_SLUG_NOT_AVAILABLE: 'Slug do evento não está disponível. ',
  HIDE_THE_START_AND_END_TIME_OF_THE_EVENT_ON_THIS_DATE:
    'Ocultar o horário de início e fim do evento nesta data.',
  EVENT_SCHEDULE: 'Programação do evento',
  ALERT_DELETE_EVENT: 'Seu evento foi excluído com sucesso.',
  ADD_NUMBER_PARTICIPANTS: 'Adicione o número de participantes',
  PARTICIPANTS: 'Participantes',
  PARTICIPANTS2: 'participantes',
  NECESSITY_lABEL:
    'Escreva as necessidades físicas para a aplicação do produto',
  NUMBER: 'Número',
  MIN: 'mínimo',
  MAX: 'máximo',
  OF: 'de',
  NO_MAX_PARTICIPANTS: 'Não possui limite máximo de participantes',
  NO_MIN_PARTICIPANTS: 'Não possui limite mínimo de participantes',
  CLASS_PLAN: 'Plano de Aula'
};

const minhasCompras = {
  NOT_AUTHORIZE: 'Sem autorização',
  SHARED: 'Compartilhar',
  SHARED_TITLE:
    'Escolha a rede social que deseja compartilhar o seu certificado',
  SHARED_TITLE_CURSO: 'Escolha a rede social que deseja compartilhar o curso',
  SHARED_TITLE_SUPPLIER:
    'Escolha a rede social que deseja compartilhar o consultor',
  OR_COPY_LINK: 'Ou copie o link',
  COPY_LINK_TXT_DESC: 'Link copiado para a área de transferência.',
  COPY_LINK_TXT: 'Copiar link',
  MY_PURCHASES: 'Minhas compras',
  SEE_MAP: 'Ver mapa',
  TICKET: 'Ingresso',
  TICKETS: 'Ingressos',
  SEE_ORDER: 'Ver pedido',
  TALK_WITH_ORGANIZER: 'Fale com o organizador',
  COUPON: 'Cupom',
  SUBTOTAL: 'Subtotal',
  CHANGE_OWNER: 'Trocar titularidade',
  EVENT: 'Evento',
  SAAS: 'Solução Inteligente',
  FORM_OF_PAYMENT: 'Forma de pagamento',
  SELLER_MESSAGE: 'Mensagem do vendedor',
  NEXT_PAYMENT_FOR: 'Próximo pagamento está programado para',
  PAYMENT: 'Pagamento',
  APPROVED_ON_DAY: 'aprovado no dia',
  NUMBER_TICKET: 'Número do ingresso',
  ORDER: 'Pedido',
  WAITING_FOR_ACCESS_DATA: 'Aguardando dados de acesso',
  AWAITING_PAYMENT: 'Aguardando pagamento',
  FOLLOW_YOUR_PLAN_IS_SEE_PLAN_DETAILS:
    'Acompanhe seu plano em Ver detalhe do plano',
  EFFECTIVE_PLAN_FROM: 'Plano vigente a partir de',
  PLAN_IN_EFFECT_UNTIL: 'Plano vigente até',
  CONTRACT_PLAN_IN: 'Plano contrato em',
  YOU_CANNOT_OPEN_A_DISPUTE_BECAUSE_THE_PLAN_HAS_BEEN_CANCELED:
    'Você não consegue abrir uma disputa pois o plano foi cancelado',
  YOUR_PLAN_WILL_BE_ACTIVATED_AS_SOON_AS_THE_CURRENT_CONTRACT_HAS_ENDED:
    'Seu plano será ativado assim que o contrato atual foi encerrado',
  CANCEL_ORDER: 'Cancelar compra',
  YOU_INITIATING_DISPUTE: 'Você está iniciando uma disputa',
  HOW_CAN_HELP_YOU: 'Como podemos te ajudar?',
  BACK_TO_CONVERSARIONS: 'Voltar para Conversas',
  MEDIATION_SEBRAE: 'Solicitar mediação do Sebraeplace',
  SURE_MEDIATION_SEBRAE:
    'Você tem certeza que deseja solicitar mediação do Sebraeplace?',
  SURE_MEDIATION_SEBRAE_TEXT:
    'O Sebraeplace receberá os motivos que foram selecionados ao abrir a disputa e entrará em contato com o vendedor para resolver a disputa que está em andamento.',
  SURE_MEDIATION_SEBRAE_TEXT_1:
    'Você receberá a resposta do Sebraeplace por e-mail.',
  REQUEST_SEND_SUCCESS: 'Sua solicitação foi enviada com sucesso',
  THE_DISPUTE: 'A disputa',
  OPEN_IN: 'aberta em',
  WAS_CLOSED: 'foi encerrada',
  DISPUTE_CLOSED: 'Disputa encerrada',
  HAVE_PROGRESS_DISPUTE: 'Você possui uma disputa em andamento.',
  PROGRESS_DISPUTE: 'Disputa em Andamento',
  DISPUTE_OPEN_IN: 'Disputa aberta em',
  DISPUTE: 'Disputa',
  REACTIVATE_SUBSCRIPTION: 'Reativar a assinatura',
  TOOLTIP_CHANGE_ORDER:
    'A troca de titularidade pode ser realizada apenas pelo titular da compra e poderá ser feita até 24 horas antes do início do evento. Para mais informações acesse nossa Central de Ajuda.',
  TOOLTIP_CHANGE_ORDER_BLOCK:
    'O prazo para fazer a troca de titularidade neste ingresso já está encerrada! Para mais informações consulte nossa central de ajuda!',
  TOOLTIP_CANCEL_ORDER:
    'O cancelamento da compra pode ser realizado no prazo de até 7 dias antes do evento.',
  NEXT_PAYMENT_TO: 'Próximo pagamento está programado para',
  DOWNLOAD_TICKET: 'Download do ingresso',
  WRITE_MESSAGE_MODAL: 'Escreva uma mensagem',
  ANOTHER_MOTIVE: 'Outro motivo',
  WRITE_THE_MOTIVE: 'Escreva aqui o motivo',
  SUBTITLE_TALK_WITH_ORGANIZER:
    'Preencha os campos a seguir com as informações solicitadas para enviar uma mensagem ao organizador do evento, logo após, clique em “Enviar”.',
  SUBTITLE_CHAT_WITH_SELLER_SAAS:
    'Preencha o campo abaixo para enviar uma mensagem ao vendedor da solução inteligente, logo após, clique em “Enviar”.',
  NUMBER_REQUEST: 'Número do pedido:',
  SAVE_CHANGES_CHANGE_OWNER: 'Salvar alteração',
  NAME_PARTICIPANT_PLACEHOLDER: 'Nome do participante',
  EMAIL_PARTICIPANT_PLACEHOLDER: 'E-mail do participante',
  SENT_AT_CHANGE_OWNER: 'Enviado às',
  IN_CHANGE_OWNER: 'de',
  THE_CHANGE_OWNER: 'a:',
  STATUS_CHANGE_OWNER: 'Status:',
  PAST_EVENTS: 'Eventos Passados',
  CERTIFICATE: 'Certificado',
  CERTIFICATES: 'Certificados',
  FULL: 'Lotação máxima:',
  REASON: 'Motivo',
  DESCRIBE_REASON: 'Descreva o motivo do cancelamento',
  CANCEL_SUBSCRIPTION: 'Cancelar Assinatura',
  CANCEL_CONTACT: 'Cancelar Contato',
  ARE_YOU_SURE_CANCEL_CONTACT:
    'Você tem certeza que deseja cancelar esta solicitação de contato?',
  REACTIVATE_SOLICITATION: 'Reativar solicitação',
  REQUEST_CANCELLATION_SUBSCRIPTION: 'Solicitar cancelamento de Assinatura',
  ARE_YOU_SURE_CANCEL_SUBSCRIPTION:
    'Você tem certeza que deseja cancelar essa assinatura?',
  SEE_THE_TERMS: 'Consulte a',
  AWARE_CANCELLATION_RULES:
    'desse produto e fique ciente das regras de cancelamento.',
  MESSAGE_SENT_SUCCESSFULLY: 'Sua mensagem foi enviada com sucesso',
  TOOLTIP_TEXT_CANCEL_SUBSCRIPTION:
    'O ressarcimento integral é feito se o cancelamento for realizado em até 7 dias corridos da data da compra.',
  WAIT_THE_ANSWER:
    'A resposta será enviada em breve, fique atento ao seu e-mail.',
  GO_TO_MY_PURCHASES: 'Voltar para minhas compras',
  GO_BACK_TO_ORDER: 'Voltar para o pedido',
  CONFIRM_CANCEL_ORDER: 'Você tem certeza que deseja cancelar essa compra?',
  CONFIRM_CANCEL_ORDER_DESC:
    'Todos os ingressos vinculados a essa compra serão cancelados. O estorno do valor será efetuado no cartão de crédito usado na compra. No caso de boleto bancário será estornado na conta cadastrada no sistema. O ressarcimento integral é feito se o cancelamento for realizado em até 7 dias corridos da data da compra. Após esse prazo o ressarcimento será de 80% do valor total da compra.',
  ORDER_CANCELED: 'Compra cancelada',
  ORDER_CANCELED_DESC:
    'Sua solicitação de cancelamento foi enviada. Um e-mail foi enviado para você explicando como funcionará o estorno.',
  REIMBURSEMENT_FULL_SEVEN_DAYS_1:
    'O ressarcimento integral é feito se o cancelamento for realizado em até 7 dias corridos da data da compra. Por favor informe seus dados bancários para o ressarcimento de valores já efetivados.',
  REIMBURSEMENT_FULL_SEVEN_DAYS_2:
    'Após esse prazo não será possível solicitar o ressarcimento do valor da compra.',
  RATE_SUPPLIER: 'Avalie o fornecedor',
  WAITING_EXECUTION: 'Aguardando execução',
  ESTIMATE_REQUESTED_IN: 'Orçamento solicitado em:',
  BOUGHT_IN: 'Compra realizada em:',
  CANCELLATION_HAS_BEEN_REQUESTED: 'O cancelamento foi solicitado',
  CANCELLATION_SUCCESS_DESC:
    'Em breve você terá um retorno por e-mail sobre o estorno referente ao valor da compra Sebraetec.',
  CANCELLATION_REQUESTED_DESC:
    'A solicitação de cancelamento será avaliada pelo fornecedor e pela equipe do Sebrae, fique atento ao seu e-mail para novidades.',
  RETURN_REQUESTED: 'Devolução Solicitada',
  FIXES_REQUESTED_BY_BACKOFFICE:
    'O Sebrae solicitou ajustes no serviço para poder finalizá-lo',
  SEE_FIXES: 'Visualizar ajustes',
  FIXES: 'Ajustes',
  RETURN_REQUESTED_NOTIFICATION:
    'Devolução solicitada, em análise pelo fornecedor e equipe do Sebrae',
  RETURN_REQUESTED_NOTIFICATION_SUPPLIER:
    'O cliente solicitou a devolução da compra, revise a solicitação',
  REVIEW_THE_REQUEST: 'Revisar solicitação',
  WAITING_REVIEW_FROM_THE_SEBRAE_TEAM:
    'Aguardando a equipe do Sebrae analisar o pedido de devolução',
  VIEW_CHAT: 'Ver conversa'
};

const minhasVendas = {
  MY_SALES: 'Minhas vendas',
  SUB_CATEGORY: 'Sub-Categoria',
  FILTERS: 'Filtros',
  ORDERS_RECEIVED: 'Pedidos recebidos',
  REQUESTS: 'pedidos',
  MADE_IN: 'efetuados em',
  LAST_30_DAYS: 'Últimos 30 dias',
  LAST_3_MONTHS: 'Últimos 3 meses',
  LAST_6_MONTHS: 'Últimos 6 meses',
  LAST_12_MONTHS: 'Últimos 12 meses',
  FROM_THE_BEGINNING: 'Desde o início',
  YOU_HAVE_NO_SALES_YET: 'Você ainda não possui vendas',
  PURCHASE_MADE: 'Compra realizada',
  BUYER_INFORMATION: 'Informações do comprador',
  CHARGEBACK_COMPLETED: 'Estorno concluído',
  VIEW_BILLING_HISTORY: 'Ver histórico de faturamento',
  INVOICE_PENDING_DELIVERY: 'Nota fiscal pendente de envio',
  INVOICE_EMISSION_DATE: 'Data de emissão da nota fiscal',
  INVOICE_NUMBER: 'Número da nota',
  SEBRAEPAY: 'SebraePay',
  SEE_PRODUCT: 'Ver produto',
  SEE_NEGOTIATION: 'Ver negociação',
  SOLUTION: 'Solução',
  SIZE: 'Porte',
  CLEAR_FILTERS: 'Limpar filtros'
};

const participantes = {
  ORDER_NUMBER: 'Nº Pedido',
  SUBSCRIPTION_NUMBER: 'Nº Inscrição',
  USER: 'Usuário',
  ALT_PHONE: 'Telefone Alternativo',
  SEARCH_PARTICIPANT_PLACEHOLDER: 'Nome do evento ou número do ingresso',
  DOWNLOAD: 'Download',
  EXTENSION_TYPE: 'Em formato',
  LINKED_TICKETS: 'Ingressos vinculados',
  BUYER: 'Comprador',
  PARTICIPANT: 'Participante',
  SUBSCRIBERS: 'inscritos'
};

const dadosIngressos = {
  BACK_TO_CATALOG: 'Voltar para o catálogo',
  GO_TO_CART: 'Seguir para o carrinho',
  GO_TO_THE_CART: 'Ir para o carrinho'
};

const ingresso = {
  CREATE_TICKET: 'Criar Ingresso',
  EDIT_TICKET: 'Editar Ingresso',
  TOTAL_TICKETS: 'Total de ingressos',
  SOLD: 'Vendidos',
  UNITARY_VALUE: 'Valor unitário',
  PROJECTED_VALUE: 'Valor projetado',
  ALERT_END_DATE_IN_EVENT:
    'Por favor insira uma data de término em seu evento.',
  ALERT_END_DATE_GREATER_THAN_END_DATE_EVENT_1: 'Data de término da venda',
  ALERT_END_DATE_GREATER_THAN_END_DATE_EVENT_2:
    'obrigatóriamente deverá ser menor ou igual a data de término do evento',
  ALERT_START_DATE_GREATER_THAN_END_DATE_1: 'Data de início da venda',
  ALERT_START_DATE_GREATER_THAN_END_DATE_2:
    'obrigatóriamente deverá ser menor ou igual a data de término da venda',
  MINIMUM_QUANTITY_OWED_LESS_THAN_MAXIMUM:
    'Quantidade mínima deve ser menor ou igual a quantidade máxima.',
  MAXIMUM_QUANTITY_OWED_LESS_THAN_AVAILABLE:
    'Quantidade máxima deve ser menor ou igual a quantidade dísponivel.',
  TICKET_TO_THE_EVENT: 'Ingresso para o evento',
  TICKET_INFORMATION: 'Informações do ingresso',
  TICKET_NAME: 'Nome do ingresso',
  TOTAL_NUMBER_OF_TICKETS: 'Nº total de ingressos',
  SALES_PERIOD_FOR_THIS_TICKET: 'Período das vendas deste ingresso',
  SALES_START_DATE: 'Data de início das vendas',
  SALES_END_DATE: 'Data de término das vendas',
  QUANTITY_ALLOWED_PER_PURCHASE: 'Quantidade permitida por compra',
  VIEW_TICKET: 'Visualizar ingresso',
  GENERATE_TICKET: 'Gerar Ingresso',
  PLEASE_REVIEW_YOUR_TICKET: 'Por favor revise seu ingresso.',
  PLEASE_ADD_AUDIENCE: 'Por favor insira capacidade de público em seu evento.',
  ALERT_SUM_LOTS_EXCEEDS:
    'A soma de seus lotes de ingressos ultrapassa a capacidade de público do seu evento.',
  INFO_DELETE_TICKET_LOT:
    'Você tem certeza que deseja excluir esse lote de ingressos',
  DELETE_TICKET_LOT: 'Excluir lote de ingressos',
  RATE_EVENT: 'Avalie o evento',
  DOWNLOAD_TICKET_ERROR: 'Erro ao baixar o ingresso',
  DOWNLOAD_CERTIFICATE_ERROR: 'Erro ao baixar o certificado',
  DISCOUNT_APPLIED: 'Desconto aplicado',
  APPLIED: 'Aplicados',
  TOTAL_COUPONS: 'Total de cupons',
  CREATE_COUPON: 'Criar cupom',
  EDIT_COUPON: 'Editar cupom',
  CREATE_DISCOUNT_COUPON: 'Criar cupom de desconto',
  PERIOD_OF_VALITY: 'Periodo de vigência',
  SALES_AMOUNT: 'Total de vendas',
  PROJECTED_TOTAL: 'Total Projetado',
  EXPORT_FILE_ERROR: 'Erro ao exportar arquivo'
};

const perguntasRespostas = {
  SEE_MORE_QUESTIONS: 'Ver mais perguntas',
  LAST_QUESTIONS: 'Últimas perguntas',
  ASK: 'Pergunte ao vendedor',
  COMMENT: 'Comentar',
  NO_DATA: 'Não foi encontrado nenhuma pergunta'
};

const cupom = {
  ALL_TICKETS: 'Todos os ingressos',
  TICKETS_INCLUDED: 'Ingressos vinculados ao cupom de desconto',
  TICKETS_REGISTERED: 'Ingressos cadastrados',
  COUPON_INFO: 'Informações do cupom de desconto',
  COUPON_CODE: 'Código do Cupom',
  COUPON_CODE_PLACEHOLDER: 'Digite o código sem espaços e caracteres especiais',
  COUPON_DISCOUNT: 'Desconto por cupom',
  COUPON_DURATION: 'Período de vigência desse cupom de desconto',
  COUPON_GENERATE: 'Gerar cupom',
  COUPON_WILL_REMAIN: 'O cupom permanecerá vigente até que eu o desative.',
  COUPON_DELETE: 'Excluir cupom de ingresso',
  INFO_COUPON_DELETE: 'Você tem certeza que deseja excluir esse cupom'
};

const afiliados = {
  ENTITY: 'Entidade',
  AFFILIATE: 'Afiliado',
  AFFILIATE_LINK_DESC:
    'Filtre os produtos que precisa e gere o link de afiliado, ele será gravado na sua área de transferência.',
  SEBRAEPLACE_AFFLIATE_MARKETING_SERVICE:
    'Serviço de Marketing de Afiliados Sebraeplace',
  ACTIVATE_AFFILIATE_MARKETING:
    'Quero ativar o Serviço de Marketing de Afiliados Sebraeplace.',
  I_DONT_WANT_ACTIVATE_AFFILIATE_MARKETING:
    'Não quero ativar o Serviço de Marketing de Afiliados Sebraeplace.',
  DONT_ACTIVATE_AFFILIATE_MARKETING:
    'Quero desativar o Serviço de Marketing de Afiliados Sebraeplace.',
  AFFILIATE_PRODUCT_LINK_DESC:
    'Gere o link desse produto, ele será gravado na sua área de transferência.',
  SEE_THE_STEP_BY_STEP: 'Veja o passo a passo',
  SEARCH_TUTORIAL: 'Busque',
  SEARCH_FOR_A_PRODUCT_CATEGORY_OR_TYPE_THE_NAME_OF_THE_SOLUTION_YOU_WANT_TO_SEARCH_FOR:
    'Busque por uma categoria de produto ou digite o nome da solução que deseja buscar',
  LACK_A_LITTLE: 'Falta pouco',
  CHOICE_TUTORIAL: 'Escolha',
  OTHERS: 'Outros',
  CHOOSE_THE_SOLUTION_THAT_BEST_SUITS_THE_PROFILE_OF_THE_ENTERPRISE_OR_SMALL_BUSINESS_TO_WHOM_IT_WILL_OFFER:
    'Escolha a solução que melhor se adeque ao perfil do empreender ou pequena empresa a quem irá ofertar.',
  THIS_IS_IMPORTANT: 'Isso é importante',
  GENERATE_A_LINK: 'Gere um link',
  DO_NOT_FORGET_TO_GENERATE_A_LINK_VIA_THE_NOTIFICATION_BAR_INFO:
    'Não se esqueça de gerar um link através da barra de notificação. Isso é importante para que o Sebraeplace monitore a conversão da venda para que você possa receber a sua comissão!',
  SEBRAEPLACE_AFFILIATE_TUTORIAL: 'Tutorial do Afiliado Sebraeplace',
  ADVERTISE_ON_YOUR_SOCIAL_NETWORKS_THE_MORE_YOU_ADVERTISE_THE_MORE_CHANCE:
    'Divulgue em suas redes sociais, quanto mais você divulgar mais chance terá de vender e receber comissão por essa conversão.',
  SOCIAL_NETWORKS: 'Redes Sociais',
  WEB_REFERENCES: 'Referências da web',
  HOURLY_VALUE_FROM: 'Valor hora a partir de',
  WORK_EXPERIENCE: 'Experiência de trabalho',
  BIOGRAPHY: 'Biografia',
  PHOTO_GALLERY: 'Galeria de fotos',
  VIDEO_GALLERY: 'Galeria de videos',
  RECEIVE_SALES_COMMISSION: 'Receba comissão de venda',
  INSERT_LINK_TITLE: 'Inserir título do link',
  INSERT_URL: 'Inserir URL',
  FOLLOW_ALL_THE_MOVEMENT_OF_THE_COMMISSIONS_GENERATED_ON_YOUR_PANEL_IN_THE_STATEMENT_TAB:
    'Acompanhe toda a movimentação das comissões geradas no seu painel na aba de Extrato. Receba mensalmente de forma automática, sem complicações!',
  STREET: 'Rua',
  ENTER_YOUR_ADDRESS_IN_THE_FIELDS:
    'Informe o seu endereço preenchendo os campos abaixo.',
  ACCOUNT_WILL_BE_USED_COMMISSIONS:
    'Essa conta será utilizada para recebimentos das comissões referente aos serviços prestados.',
  BANK_DATA: 'Dados Bancários',
  SUCCESSFUL_REGISTRATION: 'Cadastro realizado com sucesso',
  AFFILIATE_CHANNELS: 'Canais de divulgação',
  SELECT_CHANNELS:
    'Queremos saber um pouco mais de como você irá divulgar os produtos Sebraeplace. Conte-nos quais canais de divulgação você pretender utilizar.',
  SELECT_CHANNEL: 'Selecione o canal de divulgação',
  SELECT_REACH: 'Selecione o alcance',
  ESTIMATED_REACH: 'Alcance estimado',
  SALE: 'Venda',
  COMISSION_RECEIVED: 'Comissão recebida',
  COMISSION_GENERATED: 'Comissão Gerada',
  COMISSION_WITHDRAWED: 'Comissão Sacada',
  REINBURSEMENT_COMISSION:
    'Reembolso da comissão. O produto ou serviço foi cancelado.',
  REVERSAL_OF_THE_COMISSION:
    'Estorno da comissão. O produto ou serviço foi cancelado.',
  TRANSFER_RECEIVED: 'Transferência recebida',
  TRANSFER_FINISHED: 'Transferência efetuada',
  VALUE_WITHDRAWED: 'Valor sacado',
  PENDING_WITHDRAWAL: 'Saque pendente',
  PROCESSING_WITHDRAWAL: 'Processando saque',
  WITHDRAWAL_FINISHED: 'Saque efetuado',
  AFFILIATE_TERM_HAVE_CHANGED: 'O termo de uso do afiliado mudou',
  ADD_CHANNELS:
    'Para te conhecermos melhor, coloque aqui os links para seus canais. Fique tranquilo, isso é opcional e não irá ter influência alguma em seu comissionamento.',
  WELCOME_SEBRAEPLACE_LETS_START:
    'Bem vindo a equipe Sebraeplace! Vamos começar?',
  WELCOME_SEBRAEPLACE_LETS_START_DESCRIPTION:
    'Quanto mais empreendedores e empresas você ajudar, divulgando e enviando links de produtos e serviços mais você irá receber!',
  I_WANT_TO_BE_AFFILIATE: 'Quero ser um Afiliado Sebraeplace',
  BE_AFFILIATE: 'Seja um Afiliado',
  BECOME_A: 'Torne-se um',
  AFFILIATE_SEBRAEPLACE: 'Afiliado Sebraeplace',
  COMISSION_OF: 'Comissão de',
  IT_IS: 'é',
  AND: 'e',
  OR: 'ou',
  AFFILIATE_MARKETING: 'Marketing de afiliados',
  AFFILIATE_MARKETING_SEBRAEPLACE: 'Marketing de Afiliados Sebraeplace',
  AFFILIATE_MARKETING_SEBRAEPLACE_AND_CUPONS_1: 'Marketing de Afiliados e',
  AFFILIATE_MARKETING_SEBRAEPLACE_AND_CUPONS_2:
    'Cupons de desconto Sebraeplace',
  PRODUCT_SELECTION: 'Seleção por produto',
  ACTIVE_SERVICE: 'Serviço ativo',
  INACTIVE_SERVICE: 'Serviço inativo',
  AFFILIATE_MARKETING_CUPOM_INTRODUCTION:
    'Você como fornecedor pode optar ou não por esses serviços a mais. Eles não são obrigatórios. Você pode fazer a opção a cada produto, esse serviço pode ser ativado ou desativado a qualquer momento na tela de configurações do produto.',
  AFFILIATE_MARKETING_CUPOM_SUBTITLE:
    'Você poderá optar por contar com esse serviço para escalar suas vendas. Aproveite mais esse benefício!',
  AFFILIATE_MARKETING_POP_UP_ACTIVE:
    'Ative ou desative o serviço de marketing de afiliados.',
  AFFILIATE_MARKETING_POP_UP_ACTIVE_CUPONS:
    'Ative ou desative o serviço de cupons de desconto do Sebraeplace.',
  AFFILIATE_MARKETING_POP_UP_ACTIVE_CAMPANHA:
    'Ative ou desative o serviço de campanha de desconto do Sebraeplace.',
  AFFILIATE_MARKETING_POP_UP_INACTIVE:
    'O produto está sendo editado e suas alterações deverão passar por nova homologação do Sebraeplace',
  WHAT_AFFILIATE_MARKETING: 'O que é marketing de Afiliados?',
  WHAT_AFFILIATE_MARKETING_DESCRIPTION_1:
    'O marketing de afiliados é um processo no qual pessoas se afiliam em uma plataforma e ganham uma comissão por promover os produtos disponíveis para venda.',
  WHAT_AFFILIATE_MARKETING_DESCRIPTION_2:
    'Essa comissão é paga pelo fornecedor do serviço que ganha um reforço exponencial na divulgação do serviço e consequentemente nas sua vendas.',
  WHAT_AFFILIATE_MARKETING_DESCRIPTION_3:
    'Todos ganham: o fornecedor que amplia sua rede de divulgação, o afiliado que recebe comissão por utilizar sua rede e vender e a plataforma que ajuda a gerar mais vendas.',
  HOW_IT_WORKS: 'Como funciona o Marketing de Afiliados no Sebraeplace?',
  HOW_IT_WORKS_DESCRIPTION_1:
    'Você como fornecedor pode optar ou não por esse serviço a mais. Ele não é obrigatório.',
  HOW_IT_WORKS_DESCRIPTION_2: 'Você pode fazer a opção a cada produto.',
  HOW_IT_WORKS_DESCRIPTION_3:
    'Nossos afiliados poderão indicar o seu produto através de um link gerado pelo Sebraeplace, iremos monitorar os cliques e conversões da página divulgada.',
  HOW_IT_WORKS_DESCRIPTION_4:
    'Esse serviço é comissionado, mas não se preocupe! Você pagará comissão apenas sobre vendas realizadas. Você poderá acompanhar a movimentação na sua tela de Extratos. Optando pelo marketing de afiliados, a divulgação dos seus produtos pode ser ampliada.',
  AFFILIATES_COMMISSION_COURSE:
    'Comissão do Afiliado nos serviços de Curso online',
  AFFILIATES_COMMISSION: 'Comissão do Afiliado',
  AFFILIATES_COMMISSION_COURSE_DESCRIPTION_1: 'A comissão é referente a ',
  AFFILIATES_COMMISSION_COURSE_DESCRIPTION_2:
    ' do valor do curso. Só serão contabilizadas vendas convertidas das indicações comissionadas. Havendo indicações e conversões a comissão será cobrada mensalmente enquanto a assinatura permanecer ativa.',
  AFFILIATES_COMMISSION_CONSULTANCY:
    'Comissão do Afiliado nos serviços de Consultoria:',
  AFFILIATES_COMMISSION_CONSULTANCY_DESCRIPTION_1: 'A comissão é referente a ',
  AFFILIATES_COMMISSION_CONSULTANCY_DESCRIPTION_2:
    ' do valor do contrato entre o consultor e o cliente. Só serão contabilizadas vendas convertidas das indicações comissionadas. Havendo indicações e conversões a comissão será cobrada mensalmente enquanto a assinatura permanecer ativa.',
  AFFILIATES_COMMISSION_EVENT:
    'Comissão do Afiliado nos serviços de venda de ingressos de Evento:',
  AFFILIATES_COMMISSION_EVENT_DESCRIPTION_1: 'A comissão é referente a ',
  AFFILIATES_COMMISSION_EVENT_DESCRIPTION_2:
    ' do valor do ingresso. Só serão contabilizadas vendas convertidas das indicações comissionadas. Havendo indicações e conversões a comissão será cobrada mensalmente enquanto a assinatura permanecer ativa.',
  AFFILIATES_COMMISSION_COURSES:
    'Comissão do Afiliado nos serviços de venda de Curso online:',
  AFFILIATES_COMMISSION_COURSES_DESCRIPTION_1: 'A comissão é referente a ',
  AFFILIATES_COMMISSION_COURSES_DESCRIPTION_2:
    ' do curso online. Só serão contabilizadas vendas convertidas das indicações comissionadas. Havendo indicações e conversões a comissão será cobrada mensalmente enquanto a assinatura permanecer ativa.',
  AFFILIATES_COMMISSION_SAAS:
    'Comissão do Afiliado nos serviços de assinatura de Solução Inteligente:',
  AFFILIATES_COMMISSION_SAAS_DESCRIPTION_1_1: 'A comissão é referente a ',
  AFFILIATES_COMMISSION_SAAS_DESCRIPTION_1_2:
    ' do valor do plano assinado. Só serão contabilizadas vendas convertidas das indicações comissionadas. Havendo indicações e conversões a comissão será cobrada mensalmente enquanto a assinatura permanecer ativa.',
  AFFILIATES_COMMISSION_SAAS_DESCRIPTION_2:
    'Ao ativar o Serviço de Marketing de Afiliados Sebraeplace você aceita os',
  AFFILIATES_COMMISSION_SAAS_DESCRIPTION_3:
    'Esse serviço pode ser ativado ou desativado a qualquer momento.',
  WANT_ACTIVATE_AFFILIATE_MARKETING:
    'Quero ativar o Serviço de Marketing de Afiliados Sebraeplace.',
  I_WANT_ACTIVATE_AFFILIATE_MARKETING: 'Quero ativar o serviço',
  WANT_DISABLE_AFFILIATE_MARKETING:
    'Quero desativar o Serviço de Marketing de Afiliados Sebraeplace.',
  FILL_THE_FIELDS_BELOW: 'Preencha os campos abaixo',
  DEFINE_WHETHER_AFFILIATE_MARKETING:
    'Defina se o serviço de Marketing de Afiliado Sebraeplace será prestado através de Pessoa Física ou Pessoa Jurídica. Você poderá alterar a qualquer momento no menu Meus dados. Entenda a diferença:',
  YOU_CAN_SHARE_AND_SELL_PRODUCTS:
    'Você poderá compartilhar e vender todos os produtos inclusos no serviço de marketing de afiliado.',
  NOT_NECESSARY_SEND_INVOICE:
    'Não é necessário a emissão e envio de nota fiscal.',
  THE_MONTHLY_MAXIMUM_WITHDRAWAL:
    'O saque mensal possui um limite máximo de R$1.900,00. Não se preocupe, o valor excedente permanecerá como saldo para saques futuros.',
  LEGAL_ENTITY_WILL_BE_ABLE:
    'Como Pessoa Jurídica você poderá compartilhar e vender todos os produtos inclusos no serviço de marketing de afiliado.',
  YOU_WILL_NEED_ISSUES_INVOICES:
    'Você precisará emitir notas fiscais e anexa-las na plataforma Sebraeplace mensalmente.',
  THE_MONTHLY_WITHDRAWAL_UNLIMITED:
    'O saque mensal é ilimitado. Quanto mais você vender, mais receberá.',
  I_WANT_DISABLE_AFFILIATE_MARKETING: 'Quero desativar o serviço',

  TOTALLY_FREE: 'totalmente grátis',
  AFFILIATE_MARKETING_TITLE: 'Marketing de Afiliado',
  BEFORE_START_ACCEPT_FOLLOWING_ALERTS:
    'Antes de iniciar leia e aceite os alertas a seguir.',
  FOR_PLATFORM_USE: 'Para uso da plataforma',
  FOR_THE_PAYMENT: 'Para o pagamento',
  AFFILIATED_REGISTRATION_ALERT_1_1: 'Concordo com os',
  AFFILIATED_REGISTRATION_ALERT_2_1:
    'Entendo que devo cadastrar uma conta bancária para recebimento da comissão gerada através das minhas vendas.',
  PLEASE_FINISH_THE_TUTORIAL_TO_CONTINUE:
    'Por favor finalize o tutorial para continuar.',
  NEXT_STEP: 'Próximo passo',
  LET_IS_START: 'Vamos começar',
  LINK_CLIPBOARDED: 'Link criado e gravado na sua área de transferência.',
  GENERATE_AFFILIATE_LINK: 'Gerar link de afiliado',
  MY_GENERATE_LINKS: 'Meus links gerados',
  SEARCH_PRODUCTS_OR_SERVICES: 'Buscar produto ou serviços',
  SEE_FIRST_STEEP_TUTORIAL: 'Ver tutorial de primeiro passos',
  ACCESS_AND_CONVERSIONS: 'Acessos e conversões',
  APPLY: 'Aplicar',
  GENERATE_LINKS: 'Links gerados',
  ACTIVE_LINKS: 'Links ativos',
  INACTIVE_LINKS: 'Links inativos',
  MOVEMENT: 'Movimentação',
  CONVERSION: 'Conversão',
  ACCESS_LINK: 'Acesso',
  COPY_LINK: 'Link gravado na sua área de transferência.',
  LINK_GENERATED_AT: 'Link gerado em',
  DESCRIPTION_OF_THE_TOTAL_VALUE_OF_THE_AFFILIATE:
    'Este valor indica o quanto o afiliado já faturou no Sebraeplace. Este valor contempla a soma do valor sacado, valor pendente e saldo disponível.',
  DESCRIPTION_OF_THE_TOTAL_PLANNED_OF_THE_AFFILIATE:
    'Valor disponível para saque em conta bancária. Os saques são realizados automaticamente no 5º dia cada mês para a conta bancária do afiliado cadastrada no menu Carteira. Este valor irá zerar a cada vez que for realizado o saque automático.',
  DESCRIPTION_OF_THE_PENDING_VALUE_OF_THE_AFFILIATE:
    'Valor total de vendas realizadas em que os valores a receber ainda estão pendentes de liberação. A liberação pode depender da efetiva execução do serviço,  da emissão de Nota fiscal para o cliente e do prazo da operadora de pagamentos. O prazo de liberação da operadora de pagamentos é de 30 dias após a data do pagamento.',
  DESCRIPTION_OF_THE_TOTAL_WITHDRAWN_OF_THE_AFFILIATE:
    'Valor total já depositado automaticamente na conta bancária do afiliado.',
  SEBRAEPLACE_AFFLIATE_MARKETING_ALL_ACTIVATED_PRODDUCTS:
    'Todos os meus produtos',
  SERVICE_SEBRAEPLACE_CUPONS_FOR:
    'Serviço de Cupons de desconto Sebraeplace para:',
  SEBRAEPLACE_AFFLIATE_MARKETING_SERVICE_FOR:
    'Serviço de Marketing de Afiliados Sebraeplace para:'
};

const extrato = {
  EXTRACT: 'Extrato',
  ANOTHER: 'Outro',
  OTHERS: 'Outros',
  MONTHLY_PAYMENT: 'Mensalidade',
  SELECT_RANGE_TO_SERCH:
    'Selecione o período de início e fim da movimentação que deseja consultar.',
  LAST_DAYS: 'últimos dias',
  PERIOD_TO_SEARCH:
    'Período máximo de consulta de 24 meses anteriores ao mês atual.'
};

const cadastroSaas = {
  PROPERTY_OF_THE_SOLUTION: 'Propriedade da solução',
  PUBLIC_SEGMENTATION: 'Segmentação de Público',
  ABOUT_THE_ADVERTISEMENT: 'Sobre o anúncio',
  TERM_OF_USE: 'Termo de uso',
  SAAS_REGISTER_ALERT_0:
    'Tenho ciência que uma Solução Inteligente pode ser um produto, um serviço, um processo, um software, uma plataforma, aplicativo ou solução que resolva uma necessidade ou uma dor das empresas de forma rápida, prática e econômica.',
  SAAS_REGISTER_ALERT_1:
    'Tenho ciência que minha solução passará por processo de homologação, seguindo critérios pré estabelecidos, podendo ser aprovada ou não para estar no Sebraeplace.',
  SAAS_REGISTER_ALERT_2:
    'Tenho ciência que devo escolher entre duas modalidades desse módulo sendo elas: Modalidade Integração ou Modalidade Lead, seguindo regras específicas para cada tipo.',
  SAAS_REGISTER_ALERT_3:
    'Tenho ciência que o plano ofertado no Sebraeplace deve ter condições vantajosas para o cliente, podendo ser desconto, quantidade maior de itens, ou outro que fique clara a vantagem de aderir via Sebraeplace e que isso é periodicamente monitorado pela equipe Sebraeplace.',
  SAAS_REGISTER_ALERT_4:
    'Tenho ciência que ao optar pela modalidade integração, devo integrar meu software SAAS com o Sebraeplace através de APIs REST.',
  SAAS_REGISTER_ALERT_5_1: 'Tenho total ciência dos',
  SAAS_REGISTER_ALERT_5_2: 'do fornecedor Sebraeplace.',
  WRITE_THE_NAME_OF_YOUR_SAAS: 'Escreva o nome do seu produto',
  MY_BUSINESS_IS_THE_OWNER_OF_THE_SOLUTION:
    'Minha empresa é detentora da solução inteligente (Produto / Serviço / Processo / Software / Plataforma / Aplicativo / Solução)',
  MY_BUSINESS_HAS_A_LICENSE_FOR_THE_SOLUTION:
    'Minha empresa possui licença para comercializar a solução inteligente (Produto / Serviço / Processo / Software / Plataforma / Aplicativo / Solução)',
  I_WANT_TO_CHANGE_PLANS: 'Quero trocar de plano',
  SEE_WHICH_MODALITY_IS_BETTER_FOR_YOU:
    'Confira abaixo e escolha a que melhor se encaixa na sua solução.',
  MODALITY_INTEGRATION: 'Modalidade Integrada: ',
  MODALITY_INTEGRATION_DESCRIPTION:
    'Modalidade exclusiva para plataformas ou softwares SAAS com assinatura recorrente. Necessária integração com o Sebraeplace por API REST. Vide condições no Plano de Assinatura.',
  MODALITY_VITRINE: 'Modalidade Vitrine: ',
  MODALITY_VITRINE_DESCRIPTION:
    'Aproveite a conveniência de receber solicitações de contato de clientes interessados em sua solução. Ao aceitar, você autoriza a cobrança mensal de R$ {{valor}}. Oferecemos a flexibilidade de pagamento via cartão, boleto ou pix.',
  MODALITY_LEAD: 'Modalidade Lead: ',
  MODALITY_LEAD_DESCRIPTION:
    'Você capta leads pelo Sebraeplace e realiza seu processo de abordagem e venda independente. Vide condições no Plano de Assinatura.',
  LEAD_MONTHLY_LIMIT: 'Limite mensal de lead',
  LEAD_MONTHLY_LIMIT_DESCRIPTION:
    'Indique aqui até quantos leads sua empresa quer receber por mês.',
  MAX_LEADS_REQUIRED: 'O número máximo de leads é obrigatório',
  MINIMUM_LEADS_REQUIRED: 'O número mínimo de leads é: ',
  LEAD_MONTHLY_LIMIT_DESCRIPTION_2: 'O valor de cada lead é de R$ ',
  LEAD_MONTHLY_LIMIT_IS_FOR_EACH_SOLUTION_REGISTERED:
    'O limite mensal é referente a cada Solução Inteligente cadastrada.',
  REGISTER_SAAS_CONTINUE_MODAL:
    'Selecione a Solução Inteligente que você deseja continuar cadastrando',
  REGISTER_NEW_SAAS: 'Cadastrar uma nova Solução Inteligente',
  FOR_EACH: 'A cada ',
  FOR_A_PRICE_OF: ' cliente encaminhado um valor de ',
  YOU_WILL_BE_NOTIFIED_AND_CAN_CHANGE_THE_LEADS_LIMIT:
    ' será adicionado ao valor da sua mensalidade Sebraeplace. Ao chegar no limite estipulado por você, iremos notificar por email e remover temporariamente, até o vencimento da mensalidade, a sua solução inteligente na vitrine. Não se preocupe, você pode limitar esse valor no momento do cadastro da sua Solução Inteligente e alterar sempre que precisar.',
  LICENSOR_INFO: 'Dados do licenciante',
  LICENSOR_LINK: 'Vínculo',
  SELECT_A_PITCH_VIDEO:
    'Insira um arquivo em formato MP4 do Vídeo Pitch do seu produto',
  CHOOSE_BETWEEN_MODALITIES:
    'Para participar desse módulo você deve escolher entre duas modalidades.',
  CHOOSE_THE_CATEGORIES_OF_YOUR_SOFTWARE:
    'Escolha as categorias que sua solução se destina',
  CHOOSE_THE_SEGMENTS_OF_YOUR_SOFTWARE:
    'Escolha os segmentos que sua solução se destina',
  CHOOSE_THE_PORT_OF_YOUR_SOFTWARE:
    'Escolha para que porte de empresa sua solução se destina',
  INFORM_IF_YOUR_ADVERTISEMENT_HAS_A_LIMITED_TIME:
    'Informe se seu anúncio é por tempo limitado ou sem prazo específico',
  SELECT_STATES_OR_CITIES_FOR_YOUR_SOFTWARE:
    'Marque os estados e/ou cidades que o produto estará disponível',
  UPLOAD_YOUR_TERMS_OF_USE:
    'Faça o upload de um arquivo em formato pdf do Termo de uso do produto',
  UPLOAD_YOUR_PRIVACY_POLICY:
    'Faça o upload de um arquivo em formato pdf da Política de privacidade do produto',
  THE_PRODUCT_WILL_BE_AVAILABLE_TO_BRAZIL:
    'O produto estará disponível para todo o Brasil',
  I_WANT_LIMIT_THE_RANGE_OF_MY_PRODUCT:
    'Quero restringir o alcance do meu produto',
  PITCH_VIDEO_EXPLANATION:
    'Queremos conhecer a sua solução. Grave um vídeo, pode ser do seu celular mesmo, nos contando o que é sua solução, qual a vantagem para os clientes e porque ela deve estar disponível no Sebraeplace como uma solução inteligente. Esse vídeo não é apresentado para os clientes, ele será de uso interno para homologação da sua solução. Capriche!',
  PITCH_VIDEO_UPLOAD: 'Upload do Vídeo Pitch',
  PITCH_VIDEO: 'Vídeo Pitch',
  PITCH_VIDEO_EXCEED_SIZE: 'O vídeo deve possuir menos que 300MB.',
  CITY_OR_STATE: 'Cidade ou Estado',
  URL_OF_THE_TERM_OF_USE_SAAS: 'URL do Termo de uso do software',
  URL_OF_THE_PRIVACY_POLICY_SAAS: 'URL da política de privacidade do software',
  FOLLOW_UP_ON_THE_PANEL: 'Seguir para o painel',
  NOW_CREATE_THE_LANDING_PAGE: 'Agora crie a página do seu produto',
  YOU_NEED_TO_CONFIGURE_THE_LANDING_PAGE:
    'Você precisa configurar a página do seu produto. Ele só será avaliado pelo Sebraeplace depois de concluído.',
  CREATE_THE_LANDING_PAGE: 'Criar página do produto',
  AD_VALIDITY: 'Vigência do anúncio',
  NAME_OF_THE_SAAS: 'Nome do produto inteligente',
  SOFTWARE_SYSTEM_PROGRAM_APPLICATION:
    '(Produto / Serviço / Processo / Software / Plataforma / Aplicativo / Solução)',
  I_DONT_WANT_ESTIPULATE_TIME_FOR_MY_AD:
    'Não quero estipular prazo para vigência do anúncio',
  BY_CITY_SLASH_STATE: 'Por cidade/estado',
  UPLOAD_0F_TERM_OF_USE: 'Upload do termo de uso',
  TERMO_OF_USE_OF_THE_SOFTWARE: 'Termo de uso do produto',
  UPLOAD_OF_PRIVACY_POLICY: 'Upload da política de privacidade',
  PRIVACY_POLICY_OF_THE_SOFTWARE: 'Política de privacidade do produto'
};
const saas = {
  VIEW_AD: 'Visualizar produto',
  VIEW_PAGE: 'Visualizar página',
  EDIT_AD: 'Editar produto',
  EDIT_PAGE: 'Editar página',
  CANCEL_AD: 'Cancelar produto',
  DELETE_PAGE: 'Excluir página',
  SEGMENT: 'Segmento',
  SCALE_COMPANIES: 'Porte das empresas',
  CHOOSE_CATEGORY_SOFTWARE: 'Escolha a categoria que seu software se encaixa:',
  CHOOSE_SEGMENT_SOFTWARE: 'Escolha a qual segmento seu software se encaixa:',
  CHOOSE_SOFTWARE: 'Escolha a quem seu software se destina:',
  CATEGORY_SAAS: 'CATEGORIA',
  SEGMENT_SAAS: 'SEGMENTO',
  CHOOSE_SEGMENTS_PRODUCTS_SERVICES_1: 'Escolha os',
  CHOOSE_SEGMENTS_PRODUCTS_SERVICES_2: 'segmentos',
  CHOOSE_SEGMENTS_PRODUCTS_SERVICES_3: 'que seu produto ou serviço se destina:',
  SUCCESSFULLY_SEGMENTS: 'Segmentos atualizados com sucesso!',
  SCALE_COMPANIES_SAAS: 'PORTE DAS EMPRESAS',
  RATINGS: 'Avaliações',
  SELLER_RATING: 'Avaliações do vendedor',
  PRODUCT_RATING: 'Avaliações do produto',
  SELF_RENEWABLE: 'Renovação automatica.',
  SELF_RENEWABLE_SAAS_DESCRIPTION:
    'Garante o seu acesso a essa solução inteligente, ative a renovação automatica do plano contratado.',
  I_WANT_SELF_RENEWABLE_SAAS:
    'Eu quero renovar automaticamente esse plano ao final do prazo de vigência.',
  SEE_MORE_SAAS: 'Ver mais',
  SUBSCRIBERS: 'Assinantes',
  SOLICITATIONS: 'Solicitações',
  REQUESTER: 'Solicitante',
  AWAITING_CONTACT: 'Aguardando contato',
  CONTACT_CANCELLED: 'Contato Cancelado',
  CONTACT_MADE: 'Contato realizado',
  CONTACT_REQUESTED: 'Contato solicitado',
  CONTACT_DATA: 'Dados do Contato Solicitado',
  SUPPLIER_DATA: 'Dados do Fornecedor',
  CONTACT_WAS_SUCCESSFULLY_CANCELLED:
    'O cancelamento da solicitação de contato foi realizado com sucesso',
  REQUESTED_ON: 'Solicitado em',
  SEND_MSG: 'Enviar mensagem',
  ACCESS_DATA: 'Dados de acesso',
  BILLING_HISTORY: 'Histórico de faturamento',
  DIGITAL_SOLUTIONS: 'Soluções inteligentes',
  RATE_PRODUCT_SAAS: 'Avalie a Solução Inteligente',
  PLAN_CANCELED: 'Plano cancelado',
  DISASSOCIATE_MY_PROFILE: 'Desassociar o meu perfil',
  DISASSOCIATE_MY_COMPANY_PROFILE: 'Desassociar meu perfil da empresa',
  DISASSOCIATE_PROFILE_CONSEQUENCES:
    'Ao desassociar o seu perfil de uma empresa, os produto vinculados serão inativos, impossibilitando a divulgação e comercialização..',
  DISASSOCIATE_PROFILE_CONSEQUENCES_PROFESSIONAL:
    'Você ainda pode ser um fornecedor Sebraeplace e continuar fazendo parte da maior plataforma de soluções para pequenos negócios do Brasil, basta aderir a um plano e cadastrar novos produtos e serviços para deixar seu portfólio mais atrativo.',
  YOU_SURE_DISASSOCIATE_MY_PROFILE:
    'A empresa será notificado por e-mail sobre essa ação. Tem certeza que deseja desassociar o seu perfil da empresa listada abaixo?',
  DISASSOCIATE_PROFILE: 'Desassociar perfil',
  DISASSOCIATE_PROFILE_SUCCESS: 'O perfil foi desassociado com sucesso',
  DISASSOCIATE_PROFILE_SUCCESS_MESSAGE:
    'Você ainda pode fazer parte da maior plataforma de soluções para pequenos negócios do Brasil, basta aderir a um plano e cadastrar novos produtos e serviços para deixar seu portfólio mais atrativo.',
  BILLS_HISTORY: 'Histórico de faturas e cobranças',
  AUTOMATICALLY_RENEW: 'Renova automaticamente em: ',
  SEE_PLAN_DETAIL: 'Ver detalhe do plano',
  CHAT_WITH_SELLER: 'Fale com o vendedor',
  RESEND_INVOICE: 'Reenviar nota fiscal',
  SEND_INVOICE: 'Enviar nota fiscal',
  VIEW_INVOICE: 'Visualizar nota fiscal',
  SEE_INVOICE: 'Ver Nota Fiscal',
  UPDATE_INVOICE: 'Alterar nota fiscal',
  WAITING_INVOICE: 'Aguardando nota fiscal',
  VIEW_DISPUTE: 'Ver disputa',
  THE_PRODUCT: 'O produto',
  RECEIVED_A_QUESTION: 'recebeu uma pergunta',
  QUESTION: 'Pergunta',
  ANSWER: 'Resposta',
  VIEW_USER_DATA: 'Ver dados do usuário',
  IS_A_DIGITAL_SOLUTION_DEVELOPED_BY:
    'é uma solução inteligente desenvolvido por',
  CUSTOMER_REQUESTED_CONTACT_CONVERSION:
    'Conversão de contato solicitado pelo cliente',
  CONTACT_CONVERSION: 'Conversão de contato solicitado',
  MONTHLY_LEADS_LIMIT: 'Limite mensal de lead: ',
  MONTHLY_LEADS_LIMIT_2: 'Limite mensal de lead',
  SELECTED_LEADS_LIMIT: 'Limite selecionado',
  CONTACTS: ' contatos',
  WRITE_YOUR_ANSWER: 'Escreva aqui a sua resposta',
  PRIVACY_POLICY_NOT_INFORMED: 'Política de Privacidade não informado',
  TERM_OF_USE_NOT_INFORMED: 'Termo de uso não informado',
  TERMS_OF_USE_AND_PRIVACY_POLICY: 'Termo de uso e política de privacidade',
  INSERT_A_FILE_IN_PDF_FORMAT_OF_THE_SOFTWARE_TERMS_OF_USE_AND_PRIVACY_POLICY:
    'Insira um arquivo em formato pdf do Termo de uso e da Política de privacidade do software.',
  UPLOAD_OF_THE_SOFTWARE_TERMS_OF_USE: 'Upload do Termo de uso do software',
  UPLOAD_THE_SOFTWARE_PRIVACY_POLICY:
    'Upload da Política de privacidade do software',
  IT_IS_MANDATORY_TO_SAVE_TERMS_OF_USE_AND_PRIVACY_POLICY:
    'É obrigatório salvar Termo de uso e Política de Privacidade',
  POST_CHANGES: 'Publicar alterações',
  ARE_YOU_SURE_YOU_WANT_TO_REMOVE_THIS_PLAN:
    'Você tem certeza que deseja remover esse plano?',
  ARE_YOU_SURE_YOU_WANT_TO_DISABLE_THIS_PLAN:
    'Você tem certeza que deseja desativar esse plano?',
  REMOVE_THE_PLAN_INFO_MODAL:
    'Ao remover o plano não será possível recuperar as informações adicionadas nele. Você poderá adicionar novos planos com as mesmas configurações a qualquer momento.',
  DISABLE_THE_PLAN_INFO_MODAL:
    'Ao desativar o plano ele não será mais comercializado e você não poderá reativar. Clientes que já adquiriram essa assinatura permanecerão usufruindo dos benefícios do plano até o tempo final de vigência do contrato.',
  REMOVE_PLAN: 'Remover plano',
  DISABLE_PLAN: 'Desativar plano',
  AD_TERM: 'Período de Vigência do anúncio',
  NOT_STIPULATED_PERIOD: 'Período não estipulado',
  CODE_FOR_ORIGIN_IDENTIFICATION: 'Código para identificação de origem',
  INTEGRATION_CODE: 'Código de integração',
  USE_THE_SAME_EXPLANATORY_TEXT_APPLIED_IN_THE_INTEGRATION_REGISTRATION:
    'Usar o mesmo texto explicativo aplicado no cadastro da integração',
  VIEW_CURRENT_PAGE: 'Ver página atual',
  YOU_DONT_HAVE_SUBSCRIBERS: 'Você ainda não possui assinantes',
  YOU_DONT_HAVE_SUBSCRIBERS_DESC:
    'Aqui você poderá acompanhar a lista e informações dos assinantes da sua solução inteligente',
  YOUR_PRODUCT_IS_NOT_ACTIVATED: 'Seu produto ainda não está no ar.',
  YOUR_PRODUCT_IS_NOT_ACTIVATED_DESC:
    'Depois de realizar os testes de integração da sua solução inteligente, o Sebraeplace irá homologar o seu produto. Em breve você poderá acompanhar todas as informações aqui.',
  ALERTS_SAAS_PRODUCTS: 'Alertas',
  ONE_OR_MORE_SOLUTIONS_PROBLEM_INTEGRATION:
    'Uma ou mais assinaturas apresentam problema com a integração.',
  CLICK_REDO_INTEGRATION_SHOTS:
    'Clique aqui para refazer os disparos de integração.',
  PROBLEM_INTEGRATION: 'Problema na integração.',
  CLICK_TO_INTEGRATION_SHOT: ' Clique para refazer o disparo da integração',
  VIEW_WEBOOK_LOG: 'Ver log do webhook',
  THE_CANCELLATION_INTEGRATION_DID_NOT_RESPOND_WITH_SUCCESS:
    'A integração de Cancelamento não respondeu com sucesso',
  THE_SIGNATURE_INTEGRATION_DID_NOT_RESPOND_WITH_SUCCESS:
    'A integração de Assinatura não respondeu com sucesso',
  BILLING_INTEGRATION_DID_NOT_RESPOND_WITH_SUCCESS:
    'A integração de Cobrança não respondeu com sucesso',
  THE_CHANGE_INTEGRATION_DID_NOT_RESPOND_WITH_SUCCESS:
    'A integração de Mudança de Plano não respondeu com sucesso',
  TRIGGER_INTEGRATION: 'Disparar integração',
  INTEGRATION_SHOTS: 'Disparos de integração',
  ONE_OR_MORE_SIGNATURES_PROBLEM_INTEGRATION:
    'Uma ou mais assinaturas apresentam problema com a integração. Refaça os disparos de integração. Caso o problema persistam entre em contato com o Sebraeplace.',
  SUBSCRIPTION_INTEGRATION_PROBLEM: 'Assinaturas com problema de integração:',
  SIGNATURES_MODAL_REDO_PLURAL: 'assinaturas',
  SIGNATURES_MODAL_REDO_SINGULAR: 'assinatura',
  REDO_ALL_INTEGRATION_SHOTS: 'Refazer todos os disparos de integração',
  INTEGRATION_FIRE_SENT: 'Disparo de integração enviado',
  WAIT_FEW_MINUTES_TO_VERIFY_INTEGRATION:
    'Aguarde alguns minutos para verificar se a integração foi realizada.',
  EDIT_PRODUCT: 'Editar produto',
  RELEASE_ACCESS_TO_THE_PRODUCT: 'Liberação de acesso ao produto',
  SUBMIT_NEW_DATA: 'Enviar novos dados',
  DATA_SENT_IN: 'Dados enviados em',
  ACCESS_DATA_HAS_BEEN_SUCCESSFULLY_SENT:
    'Os dados de acesso foram enviados com sucesso',
  FALLOW_THE_EVOLUTION_ACCESS_DATA: `Acompanhe a evolução do seu evento
    no painel Meus eventos.`,
  FORM_ACCESS_DATA:
    'Preencha os dados necessários para que o comprador tenha acesso ao plano que adquiriu. A liberação de acesso é de sua responsabilidade, essas informações serão enviadas ao comprador por e-mail.',
  YOU_HAVE_NOT_EYET_SENT_ACCESS_DATA: 'Você ainda não enviou dados de acesso.',
  PRODUCT_NAME_PLACEHOLDER: 'Nome do produto',
  SEARCH_PARTICIPANT_PLACEHOLDER: 'Participante ou número do pedido',
  SEND_DATA: 'Enviar dados',
  RESOLVE_DISPUTE: 'Resolver disputa',
  SEND_DATA_TO_BUYER: 'Envie os dados pendentes para o comprador.',
  YOU_DONT_HAVE_INVOICE_SAAS: 'Você ainda não possui faturamentos',
  SAAS_SOLD: 'Soluções vendidas',
  YOU_DONT_HAVE_INVOICE_SAAS_DESC:
    'Aqui você poderá acompanhar a lista e informações de faturamento',
  SEND_FISCAL_BILLING:
    'Envie as notas fiscais e consulte o histórico de faturamento mensal',
  FISCAL_DATA: 'Dados fiscais',
  BILLING_ADDRESS: 'Endereço de cobrança',
  MODALITY_LEAD_SAAS: 'Modalidade Lead',
  MODALITY_SHOWCASE: 'Modalidade Vitrine',
  MODALITY_INTEGRATION_SAAS: 'Modalidade Integrada',
  MODALITY_INTEGRATION_SAAS_2: 'Modalidade Integração',
  CONTACT_REQUESTED_IN: 'Contato solicitado em: ',
  CONTACT_MADE_IN: 'Contato realizado em: ',
  THIS_LEAD_HAS_BEEN_ALREADY_PAID_FOR:
    'Este lead já teve a sua cobrança realizada, e não é mais possível alterar a sua situação.',
  YOU_DONT_HAVE_BUYED_SIGNATURES:
    'Você ainda não possui assinaturas contratadas'
};

const saasLanding = {
  CHOOSE_A_CORE_PALETTE_FOR_THIS_PAGE:
    'Escolha uma paleta de cores para essa página',
  STANDARD_PALETTE: 'Paleta padrão',
  CUSTOM_PALETTE: 'Paleta personalizada',
  CUSTOMIZE_PALETTE: 'Personalizar paleta',
  WRITE_A_TITLE: 'Escreva um título',
  COMPLEMENT_IT_WITH_A_DESCRIPTIVE_PHRASE:
    'Complemente a com uma frase descritiva. Seja objetivo e criativo.',
  CLICK_HERE_TO_ADD_A_COVER_IMAGE_FOR_YOUR_SOLUTION: `Clique aqui para adicionar uma imagem 
  de capa para sua solução.
  Dimensão ideal: 545px x 511px`,
  WRITE_A_SUBTITLE: 'Escreva um subtítulo',
  HERE_IS_THE_TIME_TO_GO_INTO_MORE_DETAIL: `Aqui é a hora de entrar em mais detalhes. 
  Especifique a área de atuação da sua solução inteligente.`,
  LOGO_OF_YOUR_PRODUCT_OR_COMPANY: 'Logo do seu produto ou empresa',
  CLICK_HERE_TO_ADD_YOUR_SOLUTION_LOGO: `Clique aqui para adicionar a 
   logo da sua solução. 
   Dimensão ideal: 348px x 216px`,
  WRITE_A_CAPITON: 'Escreva uma legenda',
  CHOOSE_FROM_ONE_OF_THE_WAYS_TO_PRESENT_YOUR_PRODUCT:
    'Escolha entre uma das formas de apresentar o seu produto',
  DESCRIPTIVE_LAYOUT: 'Layout descritivo',
  COMPACT_LAYOUT: 'Layout compacto',
  SELECTED_LAYOUT: 'Layout selecionado',
  CLICK_HERE_TO_ADD_A_PHOTO: 'Clique aqui para adicionar uma foto.',
  WRITE_HERE_A_PRODUCT_FUNCTIONALITY: `Escreva aqui uma funcionalidade do produto`,
  USE_THIS_SPACE_TO_DESCRIBE_THE_FUNCTIONALITY:
    'Use esse espaço para descrever a funcionalidade e mostrar o quanto isso ajudará o seu cliente.',
  SEND_FOR_APPROVAL: 'Enviar para homologação',
  SEND_FOR_VALIDATION: 'Enviar para validação',
  CHOOSE_BETWEEN_LITTLE_MORE_PRODUCT: `Escolha entre uma das formas de mostrar
  um pouco mais sobre o seu produto`,
  VIDEO_LAYOUT: 'Layout vídeo',
  CAROUSEL_LAYOUT_OF_IMAGES: 'Layout carrossel de imagens',
  WRITE_HERE_ABOUT_YOUR_PRODUCT: `Escreva aqui sobre 
  seu produto`,
  PASTE_HERE_THE_URL_OF_YOUR_VIDEO_PUBLISHED_ON_YOUTUBE:
    'Cole aqui a URL do seu vídeo publicado no Youtube',
  REGISTER_PLANS: ' Cadastre os planos disponíveis para o seu produto',
  ADD_ITEM: 'Adicionar item',
  ADD_RESOURCE: 'Adicionar recurso',
  PLAN_CHANGING: 'Alteração de plano',
  PLAN_CHANGE: 'Alterar plano',
  REGISTER_RESOURCES:
    'Cadastre as funcionalidades do seu produto, disponíveis para cada plano',
  WRITE_YOUR_PRODUCT_LINK:
    'Escreva aqui o link do seu produto para seus clientes consultarem informações',
  ADD_YOUR_PRODUCT_URL: 'Adicione a URL do seu produto',
  WRITE_THE_NAME_OF_YOUR_PRODUCT_URL: 'escreva-o-nome-do-seu-produto',
  PROMOTIONAL_PLAN_PRICE: `Valor promocional 
  exclusivo no Sebraeplace!`,
  BEST_PLAN_OFFER: 'Aqui no Sebraeplace você sempre tem o melhor preço!',
  BEST_PLAN_OFFER_DESCRIPTION_LEAD:
    'Verifique o plano que melhor atende sua necessidade, clique no botão solicitar contato, que a empresa entrará em contato com você para finalizar a contratação.',
  FIND_YOUR_IDEAL_PLAN: 'Encontre o plano ideal para você',
  SIGN_NOW: 'Assine agora',
  REQUEST_CONTACT: 'Solicite contato',
  CHANGE_PLAN_INFO_NEW_PLAN:
    'Você possui uma assinatura ativa no $CURRENT$ , deseja alterar o plano atual para o $NEW$ ?',
  CHANGE_PLAN_SUCCESS: 'Seu plano foi alterado com sucesso.',
  TO_FOLLOW_THE_FEATURES_AND_THE_TERM_OF_YOUR_PLAN:
    'Para acompanhar as funcionalidades e o período de vigência do seu plano acesse o seu painel.',
  THE_CURRENT_PLAN_WILL_REMAIN_IN_EFFECT_UNTIL_THE_END_OF_THE_CONTRACTED_PERIOD:
    'O plano atual permanecerá vigente até o encerramento do período contratado, após esse período o plano atual será encerrado e o novo plano selecionado entrará em vigor.',
  RESOURCE_SECTION_TITLE: 'Compare todos os recursos disponíveis',
  SECTION_START: 'Início da seção',
  PRODUCT_PRICE_ON_MY_PLATFORM: 'Preço do produto na minha plataforma',
  PRODUCT_PRICE_AT_SEBRAEPLACE: 'Preço do produto no Sebraeplace',
  PLAN_VALUES_ERROR:
    'É necessário preencher todos os campos e o preço Sebraeplace não deve ser maior ou igual da plataforma',
  PLAN_VALUES_ERROR_GENERIC: 'Ocorreu um erro ao tentar alterar esse plano',
  PLAN_VALUES_VALIDATION: 'Valor não deve ser maior ou igual da plataforma',
  PLAN_VALUES_VALIDATION_MIN:
    'Valor não deve ser menor ou igual do Sebraeplace',
  PARCEL_PRICE: 'Parcela',
  PARCELS_PRICE: 'Parcelas',
  INSTALLMENT_PRICE: 'Parcelamento',
  MAXIMUN_AMOUNT_PARCELS:
    'Defina o limite máximo de parcelas disponíveis para o cliente adquirir o seu produto.',
  NUMBER_OF_PARCELS: 'Número de parcelas',
  MONTLY_PLAN: 'Plano mensal',
  HALF_YEARLY_PLAN: 'Plano semestral',
  ANNUAL_PLAN: 'Plano anual',
  PLAN_NAME: 'Nome do plano',
  FEATURE_OF_THIS_PLAN: 'Característica desse plano',
  WRITE_A_FEATURE: 'Escreva uma característica',
  ADD_FEATURE: 'Adicionar característica',
  PERIODICITY: 'Periodicidade',
  CREATE_PLAN: 'Criar plano',
  UPDATE_SLUG: 'Atualizar Slug',
  YOU_MUST_CHOOSE_AT_LEAST_1_PLAN_BEFORE_SAVING:
    'É necessário escolher ao menos 1 plano antes de salvar.',
  YOU_MUST_ADD_A_MINIMUM_OF_1_FEATURE_BEFORE_SAVING:
    'É necessário adicionar o mínimo de 1 característica antes de salvar.',
  SORT_PLAN: 'Ordenar plano',
  TYPE_THE_NAME_OF_THE_PLAN: 'Escreva o nome do plano',
  BACK_TO_SETTING: 'Voltar para configurações',
  WANT_TO_SEND_THE_PRODUCT_FOR_APPROVAL:
    'Você tem certeza que deseja enviar o produto para homologação do Sebraeplace?',
  WANT_POST_CHANGES_PRODUCT:
    'Você tem certeza que deseja publicar as alterações no produto?',
  WANT_TO_SEND_THE_CHANGES_PRODUCT_FOR_APPROVAL:
    'Você tem certeza que deseja enviar as alterações no produto para homologação do Sebraeplace',
  WANT_TO_SEND_THE_PRODUCT_FOR_APPROVAL_WARNING:
    'A partir do momento que você enviar o seu produto. Ele passará por uma análise do Sebraeplace antes de ser adicionado ao seu catálogo. Acompanhe o status da sua solução no seu painel.',
  SEND_PRODUCT_FOR_APPROVAL: 'Enviar produto para homologação',
  CHECK_THE_INFORMATION_CAREFULLY_BEFORE_SUBMITTING_FOR_REVIEW:
    'Confira atentamente as informações antes de Enviar para análise.',
  CHECK_THE_INFORMATION_CAREFULLY_BEFORE_POST_CHANGES:
    'Confira atentamente as informações antes de Publicar as alterações.',
  MANDATORY_SECTION_SELECT_ONE_OPTIONS:
    'Seção obrigatória. Selecione uma das opções e continue a edição.',
  MANDATORY_SECTION_CREATE_ONE_PLAN:
    'Seção obrigatória. Cadastre um plano e continue a edição.',
  MANDATORY_SECTION_CREATE_ONE_RESOURCE:
    'Seção obrigatória. Cadastre um recurso e continue a edição.',
  GO_TO_MY_PANEL: 'Ir para meu painel',
  AVAILABLE_SOON: 'Disponível em breve',
  SEE_MY_PRODUCTS: 'Ver meus produtos',
  FOLLOW_THE_APPROVAL_OF_YOUR_SOLUTION_ON_YOUR_PANEL:
    'Acompanhe a homologação da sua solução no seu painel.',
  FOLLOW_ALL_THE_NEWS_ON_YOUR_PANEL:
    'Acompanhe todas as novidades em seu painel.',
  YOUR_PRODUCT_HAS_BEEN_SUCCESSFULLY_SENT:
    'Seu produto foi enviado com sucesso',
  YOUR_PRODUCT_HAS_BEEN_SUCCESSFULLY_POST:
    'Seu produto foi publicado com sucesso',
  PRODUCT_IN_ANALYSIS: 'Produto em análise',
  WAIT_WILL_APPROVE_YOUR_PRODUCT:
    'Aguarde, o Sebraeplace irá homologar o seu produto.',
  PRODUCT_WAITING_INTEGRATION: 'Produto aguardando integração',
  PRODUCT_WAITING_INTEGRATION_DESC:
    'Finalize a integração para poder alterar os dados desta página.',
  START_INTEGRATION: 'Iniciar integração',
  SAAS_INTEGRATION: 'Integração da Solução Inteligente',
  EDIT_REGISTRATION: 'Editar cadastro',
  EDIT_AD: 'Editar anúncio',
  FINISH_EDITING: 'Concluir edição',
  REVIEW_THE_PLAN: 'Revisar o plano',
  ADD_NEW_PLAN: 'Adicionar novo plano',
  EDIT_PLAN: 'Editar plano',
  YOU_CAN_MOVE_ENLARGE_REDUCE_AND_CROP_THE_THE_SELECTED_IMAGE:
    'Você pode mover, ampliar, reduzir e recortar a imagem selecionada',
  RATINGS_SAAS: 'Avaliações :',
  OPERATING_SEGMENT: 'Segmento de atuação',
  MODALITY_LEAD_LANDING: 'Modalidade Vitrine',
  MODALITY_INTEGRATION_LANDING: 'Modalidade Integração',
  CONTACT_SOLICITATION: 'Solicitação de Contato',
  CONFIRM_YOUR_INFO: 'Informe seus dados para que a empresa ',
  CONFIRM_YOUR_INFO_2:
    ' possa entrar em contato com você o mais breve possível. Caso possua um cupom insira para garantir o seu desconto.',
  STAY_TUNED_ON_YOUR_CELLPHONE_AND_EMAIL:
    'Fique atento ao seu e-mail e telefone.',
  YOUR_SOLICITATION_WAS_SENT_SUCCESSFULLY:
    'Sua solicitação foi enviada com sucesso!',
  DATE_SOLICITATION: 'Data solicitação',
  COUPON_LABEL: 'Cupom',
  COUPON_PLACEHOLDER: 'Digite o código',
  ACCEPT_SHARING_DATA:
    'Estou ciente de que os dados informados serão coletados pela empresa ',
  ACCEPT_SHARING_DATA_2: ' para que possam entrar em contato comigo',
  ACCESS_WEBSITE_PRIVACY_POLICY_TERM: `Acesse o site do detentor/licenciado da solução inteligente, \npolítica de privacidade e termo de uso da solução inteligente :`,
  INVALID_PLAN_NAME: 'nome do plano inválido',
  INVALID_IDENTIFIER: 'identificador único inválido',
  INVALID_USERS_QTY: 'quantidade de usuários inválida',
  INVALID_ANNUAL_VALUE: 'valor anual inválido',
  INVALID_SEMIANNUAL_VALUE: 'valor semestral inválido',
  INVALID_MONTHLY_VALUE: 'valor mensal inválido',
  PLAN_VALUE_IS_LOWER_THAN_LIMIT: 'valor deve ser maior que ',
  PLAN_VALUE_MUST_BE_LOWER_IN_SEBRAEPLACE:
    'valor deve ser menor no Sebraeplace',
  INVALID_FEATURES: 'deve haver pelo menos uma característica',
  CHOOSE_PRODUCT_PRICE_TYPE:
    'Escolha como deseja informar o preço da sua Solução Inteligente',
  PRODUCT_PRICE_OPTIONS:
    'Ao apresentar seu plano na vitrine, você tem a flexibilidade de escolher entre dois formatos para divulgar o valor.',
  MIN_PLAN_PRICE: 'Preço mínimo do plano',
  REGISTER_MIN_VALUE: 'Cadastrar um valor mínimo para a Solução Inteligente.',
  REGISTER_MIN_VALUE_DESC:
    'Ao selecionar esta opção, você terá a oportunidade de conversar com o cliente para compreender suas necessidades e apresentar um orçamento personalizado, assegurando que o valor seja sempre igual ou superior ao mínimo inicialmente informado.',
  REGISTER_PLAN: 'Cadastrar Planos com vantagens exclusivas.',
  REGISTER_PLAN_DESC:
    'Ao selecionar esta opção, você terá a flexibilidade de cadastrar planos conforme a sua preferência, incluindo modalidades mensais, semestrais ou anuais. Uma área especifica estará disponível para detalhar as funcionalidades e vantagens exclusivas associadas a cada plano.',
  INFORM_MIN_PLAN_VALUE:
    '<0>Importante:</0> Você deve informar o valor mínimo do plano',
  MAX_PRICE_FLAG: '<0>Importante:</0> O valor máximo é'
};

const homeAfiliado = {
  BECOME_AFILIATE_SEBRAEPLACE: 'Seja um afiliado do Sebraeplace agora mesmo.',
  INCREASE_INCOME_BING_AFFILIATE:
    'Aumente sua renda sendo um afiliado Sebraeplace.',
  HOW_TO_BE_AFILIATE: 'Como ser um afiliado do Sebraeplace',
  BEING_AFILIATE_IS_VERY_SIMPLE:
    'Ser um afiliado do Sebraeplace é muito simples, veja abaixo as vantagens e como fazer parte!',
  WANT_TO_BE_AFFILIATE: 'Quero ser um Afiliado Sebraeplace',
  WHY_BECOME_SEBRAEPLACE_AFILIATE:
    'Porque se tornar um afiliado do Sebraeplace?',
  PARTICIPATE_LARGEST_PLATFORM_AFILIATE:
    'Participe da maior plataforma digital de soluções para empresas do Brasil fomentada pelo Sebrae. Você terá flexibilidade de horário, variedade de produtos para divulgar, receberá comissão por venda realizada e muito mais. Venda de forma prática e segura em um ambiente totalmente digital.',
  WHAT_CAN_I_SELL_AFFILIATE:
    'O que posso vender sendo um afiliado Sebraeplace?',
  DOES_IT_COST_AFFILIATE: 'Tem algum custo para ser afiliado Sebraeplace?',
  AFFILIATE_SEBRAEPLACE_COMISSIONED:
    'Para ser afiliado Sebraeplace, você deve se cadastrar na plataforma preenchendo todos os dados solicitados. O serviço é completamente gratuito. Aproveite! A cada produto ou serviço vendido, você será comissionado em 10%.',
  HOW_TO_BE_AFFILIATE: 'Como se tornar um Afiliado',
  WHAT_IS_AFFILIATE: 'O que é um ',
  WHAT_IS_AFFILIATE1: 'afiliado Sebraeplace?',
  WHAT_IS_AFFILIATE_DESC:
    'Afiliado é uma Pessoa Física ou Pessoa Jurídica que se cadastra no programa de afiliados do Sebraeplace e recebe comissões de venda de produtos e soluções, disponíveis no Sebraeplace, divulgadas e vendidas por meio do seu link personalizado de indicações.',
  WHAT_ADVANTAGE_AFFILIATE:
    'Qual a vantagem de se tornar um afiliado Sebraeplace?',
  WHAT_ADVANTAGE_AFFILIATE_DESC:
    'Você pode aumentar suas possibilidades de rendimentos participando da maior plataforma digital de soluções para empresas do Brasil fomentada pelo Sebrae. Você terá flexibilidade de horário, variedade de produtos para divulgar, receberá comissão por venda realizada e muito mais! Quanto mais você vende, mais recebe, sem riscos. Só depende de você!',
  HAVE_ANY_COST: 'Tem algum custo?',
  HOW_MUCH_WILL_RECEIVE: 'Quanto vou receber?',
  HOW_MUCH_WILL_RECEIVE_DESC:
    'Você não paga nada para ser um afiliado, basta se cadastrar e a cada produto ou solução vendida por meio do seu link personalizado você receberá x% de comissão. É muito importante que você leia com atenção os Termos de uso do Afiliado para conhecer as regras. Vamos começar?',
  START_NOW_BE_AFFILIATE:
    'Comece agora a aumentar seus ganhos na maior plataforma de soluções para empresas do Brasil!',
  DONT_MISS_OUT_STEP_BY_STEP: 'Não fique de fora, veja abaixo o passo a passo!',
  MAKE_YOUR_REGISTRATION_AFFILIATE: 'Realize o seu cadastro',
  YOU_WILL_REGISTRATION_INFORMATION:
    'Você irá realizar o seu cadastro preenchendo as informações solicitadas. Você terá acesso a um painel personalizado com todos os dados e informações que você irá precisar. O processo é simples e rápido.',
  SEARCH_FOR_SOLUTIONS_AFFILIATE: 'Busque por soluções',
  WE_OFFER_SEVERAL_SOLUTIONS_AFFILIATE:
    'Disponibilizamos diversas soluções para atender empreendedores e pequenas empresas. Basta acessar a página do produto e gerar um link, esse link será vinculado ao seu perfil.',
  SEND_TO_YOUR_CONTACTS_AFFILIATE: 'Envie para seus contatos',
  SEND_THE_GENERATED_LINKS_AFFILIATE:
    'Envie os links gerados para empreendedores e pequenas empresas que buscam soluções para capacitar e desenvolver. Acompanhe e gerencie os links em um painel. Você pode divulgar o quanto quiser! Os links enviados convertidos em vendas serão comissionados.',
  I_WANT_TO_BECOME_AFFILIATE: 'Quero me tornar um afiliado do Sebraeplace',
  BE_PART_PLATFORM_AFFILIATE:
    'Faça parte de uma plataforma que vai escalar seu trabalho para um outro nível.',
  UNDERSTAND_RESOURCES_AFFILIATE_1:
    'Entenda o passo a passo e os recursos disponíveis para um afiliado do Sebraeplace.',
  UNDERSTAND_RESOURCES_AFFILIATE_2: ' Consulte os',
  TERMS_USE_AFFILIATE: 'Termos de uso do Afiliado',
  CLARIFY_YOUR_DOUBTS:
    'e esclareça suas dúvidas. Estaremos sempre prontos para lhe atender no que for necessário.',
  BENNEFITS_SEBRAEPLACE_AFFILIATE:
    'Veja os benefícios de se cadastrar para ser um Afiliado Sebraeplace:',
  BENNEFITS_SEBRAEPLACE_AFFILIATE_1:
    '• Receber comissão por divulgação convertida em venda de Consultorias;',
  BENNEFITS_SEBRAEPLACE_AFFILIATE_2:
    '• Receber comissão por divulgação convertida em venda de Cursos e Eventos presenciais;',
  BENNEFITS_SEBRAEPLACE_AFFILIATE_3:
    '• Receber comissão por divulgação convertida em venda de Soluções Inteligentes.'
};

const homeCursos = {
  OFFER_ONLINE_COURSES:
    'Ofereça cursos online para desenvolvimento de habilidades empresariais.',
  UNDERSTAND_HOW_IT_WORKS_COURSES_ONLINE:
    'Entenda como funciona a modalidade de cursos online do Sebraeplace',
  ATTENTION_COURSES_ONLINE:
    'Atenção! Os cursos devem ser exclusivamente em temas de interesse empresarial.',
  RECORD_VIDEOS_COURSES:
    'Grave vídeos exclusivos com conteúdo relevante para empreendedores.',
  RECORD_VIDEOS_COURSES_SUB_TITLE:
    'Planeje seu curso cuidadosamente. Essa reflexão prévia ajuda a organizar os conteúdos e a criar uma trilha clara e que faça sentido para os participantes. Além disso, um bom planejamento irá ajudar na gravação dos vídeos. Procure pensar nos detalhes de cada aula, desde as habilidades que serão trabalhadas, passando pelo roteiro e duração do vídeo, até as atividades que serão inseridas.',
  REGISTER_YOUR_CURRICULUM:
    'Cadastre sua grade curricular e crie quantos cursos desejar',
  REGISTER_YOUR_CURRICULUM_SUB_TITLE:
    'Disponibilize diversos níveis de conteúdo para atender várias categorias de alunos, desde iniciantes até níveis avançados, isso tornará seu portfólio mais completo e atrativo.',
  INTERACT_WITH_YOUR_STUDENTS:
    'Interaja com seus alunos e aumente seu reconhecimento',
  INTERACT_WITH_YOUR_STUDENTS_SUB_TITLE:
    'Ajude os alunos a se sentirem conectados com você. Envie mensagem de boas vindas, esclarecer as dúvidas através de um chat e parabenize seus alunos na conclusão do curso.',
  IF_YOU_ARE_ALREADY_SUPPLIER_SEBRAEPLACE:
    'Se você já é um fornecedor Sebraeplace, basta desenvolver o conteúdo, gravar os vídeos e cadastrar a grade currícular!',
  UNDERSTAND_RESOURCES_COURSES_1: 'Consulte os ',
  UNDERSTAND_RESOURCES_COURSES_2: 'e esclareça suas dúvidas.',
  WE_WILL_ALWAYS_BE_READY_TO_ASSIST:
    ' Estaremos sempre prontos para lhe atender no que for necessário.',
  READY_TO_TAKE_YOUR_ONLINE_COURSE: 'Pronto para ter seu',
  READY_TO_TAKE_YOUR_ONLINE_COURSE_ON_SEBRAEPLACE:
    ' curso online no Sebraeplace?',
  READY_TO_TAKE_YOUR_ONLINE_COURSE_2:
    'Aproveite todos os recursos que o Sebraeplace oferece para você e faça parte dessa modalidade! Prepare aulas online e divulgue para sua rede, amplie o seu reconhecimento de forma fácil e rápida.',
  TERMS_OF_USE_COURSES: 'Termos de uso.',
  START_NOW_COURSES: 'Começar agora'
};

const homeSebraetec = {
  BE_SEBRAETEC_SUPPLIER_AREAS:
    'Seja um Fornecedor Sebraetec nas áreas de tecnologia e inovação.',
  HOW_TO_BE_SEBRAETEC_SUPPLIER: 'Como ser um fornecedor<br/>do Sebraetec',
  YOUR_SERVICE_AVAILABLE_ON_SEBRAEPLACE:
    'Disponibilize seu serviço no Sebraeplace e amplie seus canais de venda!',
  WHAT_IS_SEBRAETEC: 'O que é o<br/><0>Sebraetec</0>',
  WHAT_IS_SEBRAETEC_DESC:
    'É um programa do Sebrae com o objetivo de promover a competitividade e o desenvolvimento das empresas por meio do acesso a serviços tecnológicos e de inovação. Oferecendo subsídios para que as empresas possam contratar serviços tecnológicos e de inovação.',
  REGISTER_AS_SUPPLIER: 'Faça o seu <0>cadastro</0><br/>como fornecedor',
  REGISTER_AS_SUPPLIER_DESC:
    'Sua empresa precisa estar cadastrada no Sebraeplace como um fornecedor de serviços tecnológicos do Sebraetec. Esses serviços podem incluir consultorias, diagnósticos, desenvolvimento de produtos, processos e soluções inovadoras, entre outros.',
  RECEIVE_REQUESTS_AND_DONT_WASTE_TIME:
    'Receba <0>solicitações de</0><br/><0>orçamento</0> e não perca tempo!',
  RECEIVE_REQUESTS_AND_DONT_WASTE_TIME_DESC:
    'Os clientes que desejarem utilizar os serviços da modalidade Sebraetec irão selecionar, em uma lista disponibilizada pelo Sebraeplace, a ficha técnica que melhor atende às suas necessidades. Se sua instituição ou empresa estiver vinculada à ficha técnica escolhida, você receberá uma solicitação de orçamento.',
  SEBRAETEC_MAIN_OBJECTIVES_INCUDE:
    'Os principais objetivos do Sebraetec incluem',
  TECHNOLOGICAL_AND_INNOVATION_SUPPORT: 'Apoio Tecnológico e de Inovação',
  TECHNOLOGICAL_AND_INNOVATION_SUPPORT_DESC:
    'O programa oferece suporte financeiro para que as micro e pequenas empresas possam contratar serviços tecnológicos e de inovação de instituições especializadas.',
  IMPROVING_COMPETITIVENESS: 'Melhoria da Competitividade',
  IMPROVING_COMPETITIVENESS_DESC:
    'Ao acessar serviços de alta qualidade, as empresas podem aprimorar seus produtos, processos e estratégias de negócios, tornando-se mais competitivas e preparadas para enfrentar desafios no mercado.',
  ENCOURAGING_INNOVATION: 'Incentivo à Inovação',
  ENCOURAGING_INNOVATION_DESC:
    'O SEBRAETEC estimula a adoção de práticas inovadoras nas empresas, fomentando a cultura da inovação e do desenvolvimento constante.',
  SEBRAETEC_IS_INNOVATION_CONSULTANCY:
    'O Sebraetec é uma<br/>consultoria de <0>inovação</0>',
  SEBRAETEC_IS_INNOVATION_CONSULTANCY_DESC:
    'Seus clientes podem ter um investimento para realização do projeto subsidiado em até <strong>{{value}}% do valor total pelo Sebrae</strong>.<br/>É a sua oportunidade de ampliar mercado e atrair mais clientes.',
  WHAT_CAN_YOUR_BUSINESS_OFFER: 'O que seu negócio pode oferecer?',
  DISCOVER_AREAS_IN_WHICH_SOLUTIONS_OPERATE:
    'Conheça as áreas de atuação das soluções:',
  DESIGN: 'Design',
  DESIGN_TITLE_SEBRAETEC: 'Comunique o que você quer e precisa.',
  DESIGN_DESCRIPTION_SEBRAETEC:
    'Os serviços de design oferecidos através do programa Sebraetec têm como propósito aprimorar tanto a qualidade estética quanto funcional de produtos, embalagens, identidade visual e comunicação geral das empresas.',
  TECHNOLOGICAL_DEVELOPMENT: 'Desenvolvimento tecnológico',
  TECHNOLOGICAL_DEVELOPMENT_TITLE_SEBRAETEC:
    'Inovação, tecnologia e desenvolvimento.',
  TECHNOLOGICAL_DEVELOPMENT_DESCRIPTION_SEBRAETEC:
    'Os serviços de Desenvolvimento Tecnológico oferecidos através do Programa Sebraetec visam aumentar a competitividade das empresas por meio da incorporação de soluções tecnológicas e práticas inovadoras em suas operações.',
  PRODUCTION_AND_QUALITY: 'Produção & Qualidade',
  PRODUCTION_AND_QUALITY_TITLE_SEBRAETEC:
    'Aprimore seus processos, gestão e treinamento.',
  PRODUCTION_AND_QUALITY_DESCRIPTION_SEBRAETEC:
    'Os serviços de Produção & Qualidade oferecidos através do programa Sebraetec têm como objetivo adequar empresas às normas e regulamentações, além de desenvolver estratégias que abrangem desde o recebimento da matéria-prima até a disponibilização do produto ou serviço para o cliente final.',
  SUSTAINABILITY: 'Sustentabilidade',
  SUSTAINABILITY_DESCRIPTION_SEBRAETEC:
    'Os serviços de Sustentabilidade oferecidos através do programa Sebraetec auxiliam as empresas na otimização de recursos, na construção da imagem da marca por meio de uma gestão sustentável e em ações que promovem o cuidado com a natureza e o bem-estar das pessoas. Possibilita agregar valor aos produtos e fortalecer o relacionamento com a sociedade.',
  SEBRAETEC_GOES_MUCH_FURTHER: 'O Sebraetec vai <0>muito além</0>',
  TECHNICAL_DESC: 'Ficha Técnica',
  BE_PART_NETWORK_SERVICE_PROVIDERS_ACCORDING_YOUR_AREA:
    'Faça parte de uma rede de prestadores de serviços de acordo com a sua área de atuação. Promovemos o acesso a soluções inovadoras, tudo de forma customizada e personalizada para que alcance seu público-alvo!',
  REACH_YOUR_TARGET_AUDIENCE: 'Conquistar seu público-alvo',
  GREATER_VISIBILITY: 'Maior visibilidade',
  EXPANSION_POTENTIAL: 'Potencial de expansão',
  SECURITY_ALL_STAGES: 'Seguranças em todas as etapas',
  READY_HAVE_YOUR_PRODUCT_OR_SERVICE_ON_SEBRAEPLACE:
    'Pronto para ter seu<br/>serviço no Sebraeplace?',
  READY_HAVE_YOUR_PRODUCT_OR_SERVICE_ON_SEBRAEPLACE_DESC:
    'Aproveite todos os recursos que o Sebraeplace oferece para você e faça parte dessa modalidade! Cadastre seu produto ou serviço de acordo com a sua área de atuação, amplie o seu reconhecimento de forma fácil e rápida.'
};

const profissionais = {
  DESC_PROFESSIONALS_1:
    'Você ainda não possui profissionais vinculados a sua empresa.',
  DESC_PROFESSIONALS_2:
    'Convide profissionais para ser um fornecedor Sebraeplace e amplie sua rede.',
  INVITE: 'Convite',
  RECEIVED_INVITATION_COMPANY: 'Você recebeu um convite da empresa',
  REPLY_INVITATION: 'Responder convite',
  INVITATION_DESCRIPTION:
    'Você recebeu um convite para integrar uma equipe, veja as informações abaixo',
  COMPANY_DATA: 'Dados da empresa',
  ADMINISTRATOR: 'Administrador',
  INVITATION_DATA: 'Dados do Convite',
  INVITATION_TO_OFFICE: 'Convite para o cargo',
  ACCEPTING_THIS_INVITATION_MEMBER_COMPANY:
    'Ao aceitar este convite você será membro da empresa acima e deverá estar concordante com os ',
  MESSAGE: 'Mensagem',
  ACCEPT: 'Aceitar',
  REFUSE: 'Recusar',
  ACCEPTED_INVITATION: 'Você aceitou o convite',
  DECLINED_INVITATION: 'Você recusou o convite',
  ADMINISTRATOR_NOTIFIED_RESPONSE:
    'O administrador será notificado sobre a sua resposta.',
  LINKED_YOUR_PROFILE:
    'A partir de agora produtos podem ser cadastrados e vinculados ao seu perfil.',
  CHOOSE_PLAN: 'Escolher um plano',
  SELECT_A_PLAN_PROFESSIONALS: 'Selecione um plano',
  PROFESSIONAL_CONSULTOR: 'Profissional - Consultor/Instrutor',
  SENT_ANY_INVITATIONS: 'Você ainda não enviou nenhum convite',
  YOU_MUST_HAVE_PLAN_INVITE_PROFESSIONALS:
    'Você deve possuir um plano contratado para realizar o convite aos profissionais',
  INVITE_PROFESSIONALS_SEBRAEPLACE:
    'Convide profissionais para ser um fornecedor Sebraeplace',
  CONSULTOR_INSTRUCTOR_PROFESSIONALS: 'Consultor/Instrutor',
  INVITE_PROFESSIONAL: 'Convidar profissional',
  DISCONNECT_PROFESSIONAL: 'Desassociar profissional',
  DISCONNECT_PROFILE: 'Desassociar perfil',
  THE_PROFESSIONAL_WILL_BE_NOTIFIED_BY_EMAIL_ABOUT_THE_CHANGE:
    'O profissional será notificado por e-mail sobre a alteração.',
  CHANGE_PLAN_UPGRADE_INFO_MODAL_PROFESSIONAL:
    'Ao confirmar a alteração você já poderá aproveitar todas as vantagens que o plano disponibiliza. O valor do seu novo plano será atualizado somente na próxima mensalidade. Para acompanhar as funcionalidades e período de vigência do seu plano, acesse seu painel.',
  WHEN_DISASSOCIATING_A_PROFILE_FROM_A_COMPANY:
    'Ao desassociar um perfil de uma empresa, os produto vinculados a esse profissional permanecem no seu portfólio, porém, inativos.',
  HAS_SURE_YOU_WANT_TO_DISCONNECT_FROM_YOUR_COMPANY_THE_PROFILE_BELOW:
    'O profissional será notificado por e-mail sobre essa ação. Tem certeza que deseja desassociar da sua empresa o perfil abaixo?',
  THE_PLAN_HAS_BEEN_SUCCESSFULLY_CHANGED: 'O plano foi alterado com sucesso',
  THE_CHANGE_IN_THE_PLAN_OF_THE_PROFESSIONAL_WAS_SUCCESSFULLY_CHANGED_INFO:
    'A alteração no plano do profissional foi alterado com sucesso, o valor referente a diferença será calculado proporcionalmente aos dias utilizados no mês vigente e será atualizado a partir da próxima fatura do seu cartão.',
  THE_PROFESSIONAL_WILL_BE_NOTIFIED_OF_THE_PLAN_CHANGE:
    'O profissional será notificado sobre a alteração de plano.',
  PROFILE_HAS_BEEN_SUCCESSFULLY_DISFELLOWSHIPPED:
    'O perfil foi desassociado com sucesso',
  PROFESSIONALS_NEW_PRODUCT_MORE_ATTRACTIVE:
    'Você ainda pode convidar profissionais e cadastrar novos produtos e serviços para deixar seu portfólio mais atrativo',
  INFO_CHANGE_PLAN_PROFESSIONAL:
    'Ao alterar o plano, o valor referente a diferença será calculado proporcionalmente aos dias utilizados no mês vigente e será atualizado a partir da próxima fatura do seu cartão.',
  THE_CHANGE_WAS_SUCCESSFUL: 'A alteração foi realizada com sucesso',
  INFOR_CHANGE_ROLE_PROFESSIONAL:
    'A alteração no perfil do profissional foi realziada com sucesso. O profissional será notificado sobre a alteração de plano.',
  TO_CHANGE_PLAN: 'Alterar Plano',
  I_DECLARE_THAT_THIS_PROFESSIONAL_IS_LINKED_TO_MY_COMPANY:
    'Declaro que este profissional possui vínculo com minha empresa e que ele representa ela como profissional. Estou ciente de que as mensalidades do plano de fornecedor deste profissional serão debitadas do cartão de crédito do administrador. Estou ciente também de que os recebimentos dos serviços dos profissionais desta empresa serão repassados à empresa e esta deverá proceder seus procedimentos internos para remuneração destes profissionais.',
  PROFESSIONAL: 'Profissional',
  INVITATION_SENT: 'Convite enviado: ',
  INVITATION_EXPIRED: 'Convite expirado: ',
  INVITATION_DECLINED: 'Convite recusado: ',
  NEWEST_PROFESSIONAL: 'mais recente',
  OLDEST_PROFESSIONAL: 'mais antigo',
  DATA_FROM_PROFESSIONAL: 'Dados do profissional',
  DATA_FROM_PRODUCT: 'Produtos do profissional'
};

const cursos = {
  MANAGE_POSTS: 'Gerenciar posts',
  AVALIATIONS_AND_TESTIMONIALS: 'Avaliações & Depoimentos',
  AVALIATIONS_AND_TESTIMONIALS_TITLE: 'Avaliações e Depoimentos',
  ONLINE_COURSE_SATISFACTION_SURVEY: 'Pesquisa de satisfação do curso online',
  TELL_US_WHAT_YOU_THINK_ABOUT_THE_COURSE: 'Diga-nos o que achou sobre o curso',
  LET_US_KNOW_YOU_THINK_ABOUT_THE_INSTRUCTOR:
    'Diga-nos o que achou sobre o instrutor',
  RATE_THE_INSTRUCTOR: 'Avalie o instrutor',
  INSTRUCTOR_ASSESSMENT_RATE_INFO:
    'Em poucas palavras, descreva o que motivou sua nota. Essa mensagem será enviada apenas para o instrutor e para o Sebraeplace (Opcional)',
  COURSE_ASSESSMENT_RATE_INFO:
    'Deixe um depoimento público sobre a sua opinião do curso. Essa mensagem será publicada na página de perfil do curso. (Opcional)',
  EVALUATION_COMPLETED_INFO: `Pesquisa enviada com sucesso. 
  Sua opinião é muito importante para nós!`,
  REGISTRATION_SUCCESSFUL: 'Inscrição realizada com sucesso',
  REGISTRATION_MODAL_DESC_1:
    'Você pode acessar seus cursos a qualquer momento no seu painel no menu Minhas Compras.',
  REGISTRATION_MODAL_DESC_2:
    'Você ainda pode acessar os botões abaixo para ver o catálogo completo e escolher novos Cursos Online ou iniciar a aula agora mesmo!',
  PLEASE_FILL_IN_THE_STARS: 'Por favor, selecione uma ou mais estrelas.',
  START_CLASSES: 'Iniciar a aula',
  SHOW_MORE_COURSES: 'Ver mais cursos',
  RATE_THE_COURSE_ONLINE: 'Avalie o curso online',
  ERROR_ALERT_PUBLISH_POST: 'É necessário preencher o conteúdo do post',
  VIEW_COURSE: 'Visualizar curso',
  PUBLISH_POST_COURSE: 'Publicar',
  VIEW_ADVERTISING: 'Visualizar anúncio',
  DEACTIVATE_COURSE: 'Desativar curso',
  ENABLE_COURSE: 'Retomar curso',
  COURSE_RATING: 'Avaliações do Curso',
  COURSE_ONLINE: 'Curso online',
  IN_TOTAL: 'no total',
  INSTRUCTOR_RATING: 'Avaliações do Instrutor',
  OF_COURSE: 'do curso',
  GO_TO_COURSE: 'Ir para o curso',
  THE_COURSE_WILL_REMAIN_AVAILABLE_INFO:
    'O curso permanecerá disponível por $TIME$ \napós confirmação do pagamento',
  COURSE_PREVIEW: 'Prévia do curso',
  COMPLETE_EXERCISE: 'Complete o exercício.',
  NO_DESCRIPTION_THIS_CONTENT: 'Essa aula não possui conteúdo cadastrado.',
  READING_AVERAGE_TIME: 'Leitura. Tempo médio',
  READY: 'Pronto',
  SEND_YOUR_QUESTION: 'Enviamos sua pergunta.',
  COUPONS: 'Cupons',
  DISCOUNT_COUPONS: 'CUPONS DE DESCONTO',
  EXERCISE: 'Exercício',
  COURSE_CONTENT: 'Conteúdo do curso',
  COURSE_EVALUATIONS: 'Avaliações do curso',
  STUDENT_EVALUATIONS: 'Avaliações dos alunos',
  ONLY_MORE: 'Só mais',
  FOR_THIS_PRICE: 'por este preço',
  ASSESSMENT: 'Avaliação',
  LEVEL: 'Nível',
  OF_VIDEO: 'de video',
  OF_CLASS: 'de aula',
  CLASS: 'aula',
  CLASSES: 'aulas',
  ACTIVITIES: 'Atividades',
  REMOVE_FROM_FAVORITES: 'Remover dos favoritos',
  ADD_TO_FAVORITES: 'Adicionar a favoritos',
  SHARE: 'Compartilhar',
  ADD_TO_CART: 'Adicionar ao carrinho',
  BUY_NOW: 'Comprar agora',
  BUY: 'Comprar',
  LAST_ACESS: 'Último acesso',
  INSTRUCTOR_EVALUATION: 'Avaliação do instrutor',
  WHAT_YOU_WILL_LEARN: 'O que você aprenderá',
  THERE_ARE_NO_PREREQUISITES: 'Não há pré-requisitos.',
  NO_SELL_COURSES_CONVERTION_BANNER_TITLE:
    'Você ainda não possui cursos vendidos',
  WHO_THIS_COURSE_IS_FOR: 'Para quem é este curso',
  COURSES: 'Cursos',
  COURSE_PRICE: 'Preço do curso',
  VERSION_COURSE: 'VERSÃO',
  CHANGES_IN_PUBLIC_PRODUCT: 'ALTERAÇÕES EM PRODUTO PÚBLICO',
  SEBRAEPLACE__ON_SALE: 'Promoções sebraeplace',
  MANAGE_COUPON: 'Gerenciar cupom de desconto',
  MANAGE_CAMPAIGN: 'Gerenciar campanha de desconto',
  CAMPAING_DESC:
    'Uma Campanha de desconto aplicará automaticamente um desconto sobre os seus cursos online cadastrados. Você pode definir o valor e o período de vigência que irá disponibilizar, além de acompanhar o progresso das vendas. Divulgue essa Campanha de desconto para aumentar a visibilidade e conversão de venda. Não se preocupe pois você pode desativar ou cadastrar novas campanhas a qualquer momento.',
  CUPOM_DESC: 'Um Cupom de desconto é uma série de letras e números',
  CUPOM_DESC_EXEMPLO: '(CUPOM01)',
  CUPOM_DESC_2:
    'que podem ser inseridos no carrinho de compras e permitirá ao comprador aproveitar um desconto. Você pode definir o valor e a quantidade de códigos que irá disponibilizar, além de acompanhar o progresso das vendas.',
  CUPOM_DESC_PART2:
    'Não se preocupe pois você pode desativar ou cadastrar novos cupons a qualquer momento.',
  CUPOM_DESC_BOLD:
    ' O Cupom de desconto não é divulgado pela plataforma Sebraeplace, então não deixe de divulgar para aumentar a visibilidade e conversão de venda.',
  SUCCESSFULLY_GENERATED_DISCOUNT_CAMPAIGN:
    'Campanha de desconto gerada com sucesso',
  SUCCESSFULLY_EDIT_DISCOUNT_CAMPAIGN:
    'Campanha de desconto editada com sucesso',
  DISCOUNT_CAMPAIGNS: 'Campanhas de desconto',
  SUCCESSFULLY_GENERATED_DISCOUNT_CAMPAIGN_INFO:
    'Acompanhe e configure as campanhas de desconto e o progresso das vendas no seu Painel na aba Produtos. Você pode desativar ou cadastrar novas campanhas a qualquer momento.',
  SUCCESSFULLY_GENERATED_DISCOUNT_COUPON:
    'Cupom de desconto gerado com sucesso',
  SUCCESSFULLY_EDIT_DISCOUNT_COUPON: 'Cupom de desconto editado com sucesso',
  SUCCESSFULLY_GENERATED_DISCOUNT_COUPON_INFO:
    'Acompanhe e configure os cupons de desconto e o progresso das vendas no seu Painel na aba Produtos. Você pode desativar ou cadastrar novos cupons a qualquer momento.',
  SUCCESSFULLY_GENERATED_DISCOUNT_COUPON_INFO_2:
    'Quanto mais você divulgar maior será a possibilidade de conversão de venda.',
  SUCCESSFULLY_GENERATED_DISCOUNT_COUPON_INFO_3:
    'Durante a divulgação do seu cupom informe os usuários os limites de datas e quantidades deste cupom.',
  PRICE_AND_ON_SALE: 'Preço e promoções',
  COUPONS_DISCONT: 'Cupons de desconto',
  OF_DISCOUNT: 'de desconto',
  CAMPAING_DISCOUNT: 'Campanha de desconto',
  CREATE_NEW_CAMPAING_DISCOUNT: 'Criar campanha de desconto',
  EDIT_NEW_CAMPAING_DISCOUNT: 'Editar campanha de desconto',
  CREATE_NEW_CUPOM_DISCOUNT: 'Criar cupom de desconto',
  EDIT_NEW_CUPOM_DISCOUNT: 'Editar cupom de desconto',
  OFF_SALE_AND_COUPONS_DISCONT: 'Promoções e Cupons de desconto',
  PROGRESS_BY_MODULE: 'Progresso por módulo',
  PERIOD_OF_VALIDITY_OF_THE_DISCOUNT_COMPAIGN:
    'Período de vigência da campanha de desconto',
  PERIOD_OF_VALIDITY_OF_THE_DISCOUNT_COUPOM:
    'Período de vigência do cupom de desconto',
  PROGRESS_BY_MODULE_DESCRIPTION:
    'O gráfico de progresso por módulo representa a média do percentual de alunos que concluíram as aulas cadastradas no módulo. Acessando Ver mais você pode acompanhar a taxa de progresso por aula.',
  WITHDRAWAL_BY_MODULE: 'Desistência por módulo',
  WITHDRAWAL_BY_MODULE_DESCRIPTION:
    ' O gráfico de desistência por módulo representa a média do percentual de alunos que desistiram do curso. Os cálculos são baseados em um período inicial de 3 meses sem acesso. A última aula acessada é considerada o ponto de desistência. Acessando Ver mais você pode acompanhar a taxa de desistência por aula.',
  SUBTITLE_CHAT_WITH_SELLER_COURSE:
    'Preencha o campo abaixo para enviar uma mensagem ao vendedor do curso, logo após, clique em “Enviar”.',
  PAYMENT_ACCEPT: 'Pagamento aprovado',
  ON_DAY: 'no dia',
  RESPOND_SOON: 'Responderemos em breve',
  CUSTOMER_SERVICE_SEBRAE: 'Customer Service Sebraeplace',
  PROGRESS: 'Progresso',
  SEE_PROGRESS: 'Ver progresso',
  INVOICE: 'Nota fiscal',
  NOT_SEND: 'Não enviada',
  STUDENTS: 'Alunos',
  STUDENT: 'Aluno',
  SEARCH_BY_STUDENT: 'Buscar por aluno',
  BEGINNING_COURSE: 'Início do curso',
  EDIT_COURSE: 'Editar curso',
  EDIT_AD: 'Editar anúncio',
  COMPLETED_LESSONS: 'Aulas concluídas',
  UNDETERMINED_TIME: 'Tempo indeterminado',
  PURCHASE_DATE: 'Data da compra',
  COURSE_AVAILABLE_BY: 'Curso disponível por',
  RATE_COURSE_ONLINE: 'Avalie o curso online',
  START_COURSE: 'Começar o curso',
  VIEW_RECEIPT: 'Ver recibo',
  PURCHASE_HISTORY: 'Histórico da compra',
  SOLD_AT: 'Vendido às',
  ACCESS_EXPIRED: 'Acesso expirado',
  ITEM: 'Item',
  TOOLTIP_TEXT_CANCEL_PURCHASE:
    'O ressarcimento integral é feito se o cancelamento for realizado em até 7 dias corridos da data da compra.',
  WITHOUT_ACCESSING_THE_COURSE: 'sem acessar o curso',
  COURSE_OF: 'Curso de',
  DARK_MODE: 'Tema escuro',
  PREVIOUS_CLASS: 'Aula anterior',
  NEXT_CLASS: 'Próxima aula',
  COMPLETE_COURSE: 'Concluir o Curso',
  NEXT_CLASS_START_IN: 'A próxima aula começa em',
  SECONDS: 'segundos',
  POSTS: 'Posts',
  GRATUITOUS: 'Gratuito',
  NO_DATA_POSTS: 'Não há nenhum post até o momento.',
  NO_DATA_QUESTIONS: 'Não há nenhuma pergunta até o momento.',
  CLASS_CONTENT: 'Conteúdo da aula',
  QUESTIONS_AND_ANSWERS_NORMAL: 'Perguntas e Respostas',
  PRICE_COURSE_DESCRIPTION:
    'Você pode alterar o valor do seu curso ou oferecê-lo gratuitamente. Se você pretende oferecer seu curso gratuitamente, a duração total do conteúdo em vídeo deve ter menos de 2 horas. O preço mínimo deve ser de',
  CAMPANHA_MODAL_P1:
    'Você como fornecedor pode optar ou não por esse serviço a mais. Ele não é obrigatório. Você pode fazer a opção a cada produto. Ao aceitar participar das promoções lançadas no Sebraeplace, o desconto sobre o valor deste curso será calculado e ativado automaticamente, sobrepondo suas campanhas de desconto ativas. O desconto incide sobre o valor que o fornecedor irá receber.',
  CAMPANHA_MODAL_P2:
    'Você poderá optar por contar com esse serviço para escalar suas vendas. Aproveite mais esse benefício!',
  SERVICE_SEBRAEPLACE_CAMPAINGN_FOR:
    'Ao aceitar participar das campanhas lançadas no Sebraeplace, o desconto no valor do seu produto será calculado e ativado automaticamente, estes descontos limitam-se a ',
  PROMOTION_VALUE_DESCRIPTION_OF:
    'Você como fornecedor pode optar ou não por esse serviço a mais. Ele não é obrigatório. Você pode fazer a opção a cada produto. Ao aceitar participar das promoções lançadas no Sebraeplace, o desconto de',
  PROMOTION_VALUE_DESCRIPTION_ABOUT_1:
    'sobre o valor deste curso será calculado e ativado automaticamente, sobrepondo suas campanhas de desconto ativas. Consulte os',
  PROMOTION_VALUE_DESCRIPTION_ABOUT_2: ' e esclareça suas dúvidas.',
  I_WANT_PUBLIC_COURSE: 'Quero disponibilizar esse curso gratuitamente.',
  YOUR_PROGRESS: 'Seu progresso',
  EDIT_POST_COURSE: 'Editar Post',
  COMPLETE_COURSE_GET_CERTIFICATE:
    'Conclua o curso para obter o seu certificado',
  CONGRATULATIONS_COURSE_COMPLETED: 'Parabéns, curso concluído!',
  CONCLUDED: 'concluído',
  SEE_AD: 'Ver anúncio',
  DISABLE_COURSE_ONLINE: 'Desativar o curso online',
  NAME_UNINFORMED: 'Não informado',
  ARE_YOU_SURE_DISABLE_COURSE_ONLINE:
    'Você tem certeza que deseja desativar o curso online?',
  DISABLE_COURSE_ONLINE_DESC:
    'A desativação fará com que você perca permanentemente todas as informações cadastradas até o momento referentes a esse curso online. Os cursos vendidos anteriormente ao cancelamento permanecerão disponíveis para os alunos.',
  ENABLE_COURSE_ONLINE: 'Retomar o curso online',
  ARE_YOU_SURE_ENABLE_COURSE_ONLINE:
    'Você tem certeza que deseja retomar o curso online?',
  ENABLE_COURSE_ONLINE_DESC:
    'A partir do momento que você retomar o curso online, ele voltará a ser comercializados no Sebraeplace. Acompanhe o status do seu curso online no painel Produtos.',
  ALL_QUESTIONS_CLASS: 'Todas as perguntas nesta aula',
  ALL_QUESTIONS_COURSE: 'Todas as perguntas neste curso',
  SEARCH_QUESTIONS: 'Pesquisar em perguntas',
  ENTER_SEARCH_TEXT: 'Favor inserir um texto para busca',
  TO_ASK: 'Perguntar',
  DEACTIVATE_CAMPAIGN: 'Desativar campanha',
  DEACTIVATE_COUPON: 'Desativar cupom',
  DISABLE_DISCOUNT_CAMPAIGN: 'Desativar campanha de desconto',
  DISABLE_DISCOUNT_CAMPAIGN_INFO_TITLE:
    'Tem certeza que deseja desativar permanentemente a campanha de desconto ativa',
  DISABLE_DISCOUNT_CAMPAIGN_INFO_DESCRIPTION:
    'Isso fará com que a campanha de desconto configurada não seja mais divulgada para os clientes Sebraeplace.',
  DISABLE_DISCOUNT_COUPON: 'Desativar cupom de desconto',
  DISABLE_DISCOUNT_COUPON_INFO_TITLE:
    'Tem certeza que seja desativar permanentemente o cupom de desconto ativo',
  DISABLE_DISCOUNT_COUPON_INFO_DESCRIPTION:
    'Isso fará com que o cupom de desconto configurado não possa mais ser aplicado no carrinho de compra dos clientes Sebraeplace.',
  CAMPAING: 'Campanha',
  SCHEDULE_CAMPAIGN: 'Campanha programada',
  SCHEDULE_COUPON: 'Cupom programado',
  CURRENT_CAMPAIGN: 'Campanha vigente',
  CURRENT_COUPON: 'Cupom ativo',
  CAMPAIGN_CLOSED: 'Campanha encerrada',
  COUPON_CLOSED: 'Cupom encerrado',
  CAMPAIGN_START: 'Início da campanha',
  COUPON_START: 'Início do cupom',
  CAMPAIGN_SUCCESSFULLY_DISABLED: 'Campanha desativada com sucesso.',
  COUPON_SUCCESSFULLY_SABLED: 'Cupom desativado com sucesso.',
  COUPON_SUCCESSFULLY: 'Cupom inserido com sucesso.',
  DISABLE_COUPON: 'Desativar cupom',
  DISABLE_COUPON_DISCOUNT: 'Desativar cupom de desconto',
  ARE_YOU_SURE_DISABLE_COUPON:
    'Tem certeza que seja desativar permanentemente o cupom de desconto ativo?',
  THIS_WILL_MAKE_DISABLE_COUPON:
    'Isso fará com que o cupom de desconto configurado não possa mais ser aplicado no carrinho de compra dos clientes Sebraeplace.',
  END_OF_CAMPAIGN: 'Fim da campanha',
  END_OF_COUPON: 'Fim do cupom',
  ORIGINAL_PRICE: 'Preço original',
  COURSES_SOLD: 'Cursos vendidos',
  NAME_FOR_IDENTIFICATION: 'Nome para identificação',
  ENTER_NAME_FOR_CAMPAIGN_IDENTIFICATION:
    'Digite o nome para identificação da campanha',
  COURSE_FEE: 'Valor do curso',
  PREVIEW_CLASS_DESC:
    'Confira atentamente as informações antes de enviar para homologação.',
  BACK_TO_EDITING: 'Voltar para edição',
  DISCOUNT_PERCENTAGE: 'Percentual de desconto',
  CREATE_CAMPAIGN: 'Criar campanha',
  EDIT_CAMPAIGN: 'Editar campanha',
  SEBRAEPLACE_PROMOTIONAL_CAMPAIGNS_FOR_THIS_PRODUCT:
    'Campanhas Promocionais Sebraeplace para este produto',
  I_WANT_TO_ACTIVATE: 'Quero ativar',
  I_WANT_TO_DISABLE: 'Quero desativar',
  ACTIVITY: 'atividade',
  SELECT_OPTION_ANSWER:
    'Selecione a opção que corresponde as respostas respectivamente.',
  CONGRATULATIONS_RIGHT_ANSWER: 'Parabéns, resposta certa!',
  TOO_BAD_INCORRECT_ANSWER: 'Que pena, resposta incorreta!',
  COMMENTED_RESOLUTION: 'Resolução comentada',
  EVERY_CLASS: 'Todas as aulas',
  ACTIVITY_COMPLETED: 'Atividade concluída',
  USE: 'Aproveitamento',
  THE_COURSE_HAS_BEEN_ADDED_TO_THE_CART: 'O curso foi adicionado ao carrinho',
  STUDENTS_ALSO_VIEWED: 'Os alunos também visualizaram',
  YOURE_RIGHT: 'Você acertou',
  QUESTIONS: 'questões',
  REQUEST_CANCEL: 'Solicitar cancelamento',
  REQUEST_CANCEL_PURCHASE: 'Solicitar cancelamento da compra',
  CONFIRM_CANCEL_PURCHASE_DESC_1:
    'O ressarcimento integral é feito se o cancelamento for realizado em até 7 dias corridos da data da compra. O estorno do valor será efetuado no cartão de crédito usado na compra. No caso de boleto bancário será estornado na conta cadastrada no sistema.',
  CONFIRM_CANCEL_PURCHASE_DESC_2:
    'Após esse prazo não será possível solicitar o ressarcimento do valor da compra. O percentual de conteúdo consumido nesse período não deve ser superior a ',
  CONFIRM_CANCEL_PURCHASE_DESC_3: '% do curso completo.',
  CANCEL_SUCCESSFUL: 'O cancelamento foi realizado com sucesso',
  CANCEL_SUCCESSFUL_DESC:
    'Em breve você terá um retorno por e-mail sobre o estorno referente ao valor da compra do Curso online.',
  SUPPLIER_SUPPORT: 'Suporte ao fornecedor',
  YOU_ARE_RIGHT_TRACK: 'Você está no caminho certo!',
  GO_BACK_AND_TEST_AGAIN_DESC:
    'Se quiser melhorar seu desempenho, volte nos conteúdos que você teve mais dificuldade e faça o teste novamente.',
  CONGRATULATIONS_COMPLETED_THE_COURSE: 'Parabéns, você concluiu o curso!',
  COMPLETED_THE_COURSE: 'Você concluiu o curso!',
  DOWNLOAD_CERTIFICATE: 'Baixe o seu certificado',
  AUTOPLAY: 'Reprodução automatica',
  YOU_COMPLETED_CLASS: 'Você concluiu a aula:',
  YOU_COMPLETED_MODULE: 'Você concluiu o módulo:',
  CLICK_HERE: 'Clique aqui',
  VIDEO_NOT_FOUND: 'Vídeo não encontrado.',
  VIDEO_IN_PROCESS:
    'O vídeo está sendo processado, verifique novamente em breve.',
  CLASS_COURSE: 'Aula: ',
  MODULE_COURSE: 'Módulo: ',
  SEE_CLASS_COURSE: 'Visualizar aula',
  EDIT_CLASS_COURSE: 'Editar aula',
  ABOUT_STUDENTS_COURSE: 'Sobre os alunos',
  LAST_REPRODUTION_CLASS: 'Última reprodução em: ',
  NUMBER_STUDENTS_CONCLUSION_CLASS: 'alunos concluíram',
  AVERAGE_STUDENT_CLASS: 'média de: ',
  AVERAGE_CONCLUSION_ACTIVITIES_CLASS: 'atividades concluidas',
  ACTIVITIES_CLASS: 'atividades',
  ABOUT_CLASS_COURSE: 'Sobre a aula',
  LAST_UPDATE_CLASS_COURSE: 'Última atualização em: ',
  CONGRATULATIONS_COMPLETED_THE_COURSE_DESCRIPTION:
    'Você completou todas as atividades.',
  CONGRATULATIONS_COMPLETED_THE_COURSE_DESCRIPTION_1:
    'para obter seu certificado ou acesse o seu painel, seu certificado permanecerá disponível na aba Certificados.',
  TELL_US_YOU_THINK_INSTRUCTOR: 'Diga-nos o que achou sobre o instrutor',
  WRITE_YOUR_QUESTION: 'Escreva sua dúvida',
  REMOVE_COUPON: 'Remover cupom',
  COUPOM: 'Cupom:',
  DE: 'De:',
  CURSO_DE: 'Curso de:',
  COURSE: 'Curso',
  EXPIRA_EM: 'Expira',
  EXPIRADO: 'Expirado',
  COURSE_CARD_IMAGE_ALT: 'Imagem do Curso ',
  YOU_PAY_ONE_PRODUCT: 'Você está pagando (1) produto'
};

const cadastroCurso = {
  NOT_CATEGORYS: 'Não existem categorias cadastradas.',
  NOT_SUBCATEGORYS: 'Não existem subcategorias cadastradas',
  REPROVE_COURSE_MODAL: 'Seu cadastro de curso possui pendências',
  SET_YOUR_COURSE_TITLE: 'Defina o título do seu curso',
  TIP_COURSES: 'Dica',
  TIP_COURSES_DESCRIPTION:
    'Crie um nome que traduza da melhor forma possível a proposta do seu curso. Um bom título gera interesse e instiga os participantes a buscarem mais informações na descrição do curso.',
  TIP_COURSES_DESCRIPTION_2:
    'Se você não consegue pensar em um bom título agora, não tem problema. Você poderá alterá-lo até enviar para homologação.',
  NAME_COURSE: 'Nome do curso',
  EXAMPLE_PLACEHOLDER_TITLE:
    'Exemplo: Como criar um site para o seu negócio com Wordpress',
  SET_CATEGORY_TITLE:
    'Procure pensar a categoria como a "dor" que o seu curso resolve. Por exemplo, se o curso é de Word Press, ele está resolvendo uma dor relacionada a Marketing Digital. Lembre que o participante realiza a busca de cursos a partir da dor/dificuldade que ele tem, para então avaliar quais as soluções disponíveis.',
  DELETE_VIDEO_DEMO: 'Excluir vídeo',
  ABOUT_YOUR_COURSE: 'Sobre o seu curso',
  DEFINE_TITLE_COURSE: 'Defina o título do seu curso',
  SELECT_COURSE_CATEGORY: 'Selecione a categoria do curso',
  CHOOSE_SEGMENT_1: 'Escolha os ',
  CHOOSE_SEGMENT_2: 'segmentos ',
  CHOOSE_SEGMENT_3: 'que seu curso online se destina:',
  DEFINE_COURSE_SEGMENT_CATEGORY: 'Defina o segmento e a categoria',
  SELECT_COURSE_SEGMENT_CATEGORY: 'Selecione o segmento e a categoria do curso',
  PLAN_YOUR_COURSE: 'Planeje seu curso',
  DEFINE_PERSONAS: 'Defina as personas',
  DEFINE_TARGET_STUDENTS: 'Defina seu público-alvo',
  COURSE_STRUCTURE: 'Estrutura do curso',
  VIDEO_CONFIGURATION: 'Configurações do vídeo',
  CREATE_YOUR_CONTENT: 'Crie seu conteúdo',
  NAME_ATTACHMENT_COURSE: 'Nome do arquivo anexo',
  CHOSE_NAME_CONTENT_COURSE:
    'Escolha um nome claro e relacionado ao conteúdo do anexo',
  TYPE_NAME_ATTACHMENT: 'Digite o nome do arquivo anexo',
  CHOOSE_FILE_ATTACHMENT: 'Escolher arquivo',
  REMOVE_QUESTION_ACTIVITIES: 'Remover questão',
  FILMING_AND_EDITING: 'Filmagem e edição',
  VIDEO_DEMO_COURSE: 'Vídeo demo',
  COURSE_CONTENT: 'Conteúdo do curso',
  PUBLISH_YOUR_COURSE: 'Publique seu curso',
  EDIT_AD_COURSE: 'Editar anúncio',
  INITIAL_PAGE_COURSE: 'Página inicial do curso',
  PRICE_COURSE: 'Preço',
  VIDEOLESSONS: 'Vídeo Aula',
  TOTAL_COURSE_TIME: 'Tempo total do curso',
  MINIMUM_TIME_IS: 'O tempo mínimo é de',
  CALCULATING: 'Calculando',
  TOOLTIP_COURSE_VALIDATION:
    'Para pré-visualizar o seu curso é necessário realizar o cadastro de uma aula.',
  READING: 'Leitura',
  COURSE_MESSAGES: 'Mensagens do curso',
  COMPLETE_REGITRATION_SEND:
    'Conclua o cadastro para enviar para homologação Sebraeplace',
  COURSE_UNDER_REVIEW: 'O curso já está em revisão',
  NO_CATEGORY_SELECTED_COURSE: 'Nenhuma categoria selecionada',
  SEND_COURSE_FOR_APPROVAL: 'Enviar para homologação',
  REGISTRATION_PROGRESS_COURSE: 'Progresso do cadastro',
  SAVE_DRAFT_COURSE: 'Salvar Rascunho',
  PREVIEW_SHOWCASE: 'Pré-visualizar vitrine',
  PREVIEW_COURSE: 'Pré-visualizar curso',
  CONFIGURATION_VIDEO_COURSE: 'Configurações do vídeo',
  ERROR_EXCLUDE_CLASS: 'Erro ao excluir a aula',
  NEXT_COURSE: 'Próximo',
  FIELD_DOES_NOT_NEED_APPROVED:
    'A edição desse campo não precisa ser homologada',
  WHAT_DOES_THAT_MEAN: 'O que isso significa?',
  TO_EDIT_CLICK_FIELD_SECTION:
    'Para editar basta clicar no botão abaixo ou acessar a qualquer momento Editar anúncio na tela de Gerenciar Produto a partir do seu Painel e alterar os campos dessa seção. A alteração será atualizada no mesmo momento.',
  CREATE_DESCRIPTION_CATEGORY:
    'Crie um nome criativo e que traduza exatamente a proposta do seu curso. Os alunos decidem se vale a pena ler a descrição do seu curso avaliando o título.',
  WICH_CATEGORY_BEST_FIT:
    'Que categoria melhor se encaixa no conhecimento que você vai compartilhar? Se você não tem certeza da categoria certa, não tem problema, até enviar para homologação você pode alterá-la.',
  COURSE_CATEGORY: 'Categoria do seu curso',
  SUBCATEGORY_COURSE: 'Subcategoria do seu curso',
  CHOOSE_CATEGORY: 'Escolha uma categoria',
  CHOOSE_SUBCATEGORY: 'Escolha uma subcategoria',
  CHOOSE_PERSONAS: 'Defina as personas',
  FEEDBACK: 'Feedback',
  VIEW_FEEDBACK: 'Visualizar feedback',
  APPROVED_DEMO_VIDEO: 'Vídeo demo homologado',
  SEND_ON: 'Enviado em',
  AND_NOW: 'E agora?',
  FEEDBACK_STEPS_ONE:
    'Seu vídeo demo foi aprovado? Então siga com as gravações das aulas e complete os próximos passos.',
  FEEDBACK_STEPS_TWO:
    'O vídeo demo foi reprovado? não se preocupe! Siga o feedback que enviamos para você e nos envie novamente para avaliação.',
  WORKING_WITH_PERSONAS:
    'As personas ajudam a definir e entender melhor quem é o seu cliente. Conhecer a persona para quem o seu curso se destina pode ajudar na definição de estratégias didáticas e abordagens de conteúdo.',
  SELECT_ONE_OR_MORE_PERSONAS_COURSES:
    'Conheça e selecione uma ou mais personas que mais combinem com o seu produto.',
  COURSE_STRUCTURE_TITLE: 'Estrutura do curso',
  TIP_COURSES_DESCRIPTION_3:
    'Planeje seu curso cuidadosamente. Essa reflexão prévia ajuda a organizar os conteúdos e a criar uma trilha clara e que faça sentido para os participantes. Além disso, um bom planejamento irá ajudar na gravação dos vídeos. Procure pensar nos detalhes de cada aula, desde as habilidades que serão trabalhadas, passando pelo roteiro e duração do vídeo, até as atividades que serão inseridas.',
  WACTH_VIDEO_SEE_TIPS:
    'Assista ao vídeo e veja todas as dicas que preparamos para você',
  CREATE_SUMMARY_COURSE: 'Comece definindo os objetivos.',
  CREATE_SUMMARY_COURSE_DESCRIPTION:
    'Definir onde os participantes deverão chegar ao final do curso – ou seja, quais os objetivos de aprendizagem deverão ser atingidos – ajudará a definir qual o percurso que eles deverão percorrer para isso. Ou seja, a partir dos objetivos, devem ser definidos os conteúdos que deverão ser inclusos no curso, bem como as estratégias didáticas a serem utilizadas.',
  CREATE_LOGIC_EXTRUTURE: 'Crie uma estrutura lógica para o curso',
  CREATE_LOGIC_EXTRUTURE_DESCRIPTION:
    'Decida os conteúdos e habilidades que serão trabalhados no curso, e como isso será desenvolvido. Organize o curso em seções, e agrupe aulas relacionadas. Em cada seção, deve haver pelo menos três aulas e uma tarefa ou atividade. (Saiba mais)',
  START_HONOR: 'Entregue valor já no início.',
  START_HONOR_DESCRIPTION:
    'Nessa modalidade, os participantes querem começar a aprender e ter resultados rapidamente. Por isso, nos primeiros 10 minutos do curso, crie uma introdução que já entregue para os participantes algo que os interesse e anime.',
  INTRODUCE_YOURSELF_COURSES: 'Apresente-se e crie ímpeto.',
  INTRODUCE_YOURSELF_COURSES_DESCRIPTION:
    'As pessoas online querem começar a aprender rapidamente. Crie uma seção de introdução que dê aos alunos algo para se animarem nos primeiros 10 minutos.',
  SECTIONS_MUST_HAVE_OBJECTIVE:
    'Defina objetivos claros de aprendizagem em cada seção.',
  SECTIONS_MUST_HAVE_OBJECTIVE_DESCRIPTION:
    'Inicie cada seção com uma descrição de seu objetivo e de sua importância para a construção do conhecimento ao longo do curso. Nas seções e aulas, use títulos que reflitam a estrutura lógica do curso que você definiu no início do planejamento.',
  CLASSES_ADDRESS_COURSE: 'Para cada aula, aborde um conceito ou tema.',
  CLASSES_ADDRESS_COURSE_DESCRIPTION:
    'Estruture o conteúdo de forma que um único tema seja abordado por aula. Dessa forma, os participantes poderão encontrar facilmente o conteúdo para assistir novamente depois. Planeje aulas com duração entre 2 e 7 minutos, pois assim é possível manter o interesse dos participantes, ajudando-os a estudar em intervalos curtos de tempo.',
  COMBINE_TYPE_CLASSES: 'Combine diferentes tipos de aulas.',
  COMBINE_TYPE_CLASSES_DESCRIPTION:
    'Diga não à monotonia! Use diferentes estratégias de filmagem: além de filmar a si mesmo, filme sua tela ou slides e use outros recursos visuais. A conexão com os participantes é importante, então lembre de também mostrar-se no vídeo.',
  PRACTICAL_ACTIVITIES_PRACTICAL_LEARNING:
    'Aprofunde o aprendizado com atividades práticas.',
  PRACTICAL_ACTIVITIES_PRACTICAL_LEARNING_DESCRIPTION:
    'O aprendizado será mais significativo se os participantes conseguirem aplicar, no mundo real, o que você está explicando no vídeo. Por isso, faça uso de projetos, estudos de caso, exercícios de aplicação, planilhas etc.',
  REQUIREMENTS_STRUCTURE_COURSE: 'Requisitos',
  REQUIREMENTS_STRUCTURE_COURSE_1: 'Seu curso deve ter pelo menos ',
  REQUIREMENTS_STRUCTURE_COURSE_2: 'Todas as aulas devem somar, no mínimo,',
  REQUIREMENTS_STRUCTURE_COURSE_2_1: 'minuto(s) de vídeo no total.',
  REQUIREMENTS_STRUCTURE_COURSE_CHECKBOX:
    'Estou ciente que a estrutura do curso deve seguir os requisitos e atender aos padrões de qualidade para ser aprovado.',
  VIDEO_CONFIGURATION_COURSE: 'Configurações do vídeo',
  DELETE_CLASS: 'Excluir Aula',
  ARE_YOU_SURE_DELETE_CLASS: 'Tem certeza que deseja excluir essa aula?',
  REGISTRATION_STEP_NOT_VALID:
    'Isso fará com que essa etapa do cadastro não seja válida. Não é possível uma aula apenas com anexos.',
  TIP_COURSES_DESCRIPTION_VIDEO:
    'Ajuste suas configurações de áudio e vídeo já no início. É muito mais difícil corrigir os áudios depois que eles forem gravados.',
  EQUIPMENT_NOT_COMPLICATED: 'Não se preocupe com equipamentos profissionais.',
  EQUIPMENT_NOT_COMPLICATED_DESCRIPTION:
    'Não é necessário investir em equipamentos profissionais para captação de áudio e vídeo. A maioria dos smartphones hoje grava vídeos em alta definição. Para o áudio, você pode gravar em outro telefone, ou usar um microfone externo ligado ao seu smartphone.',
  STUDENTS_BE_ABLE_HEAR: 'Foco na fala.',
  STUDENTS_BE_ABLE_HEAR_DESCRIPTION:
    'O som da sua voz deve ser claro e limpo, de forma que os participantes consigam ouvir o que você tem a dizer. Por isso, a escolha do microfone é fundamental. Há muitas opções de microfones acessíveis. Certifique-se que o microfone escolhido está ligado e funcionando adequadamente, e posicionado a uma distância adequada de você (entre 15 e 30 cm).',
  CREATE_STUDIO_VIDEO: 'Crie o seu cenário.',
  CREATE_STUDIO_VIDEO_DESCRIPTION:
    'Organize seu cenário – limpe o plano de fundo e organize a decoração. Você pode criar um fundo com papel colorido ou um lençol passado.',
  LIGHT_UP_YOUR_FACE: 'Cuide da iluminação.',
  LIGHT_UP_YOUR_FACE_DESCRIPTION:
    'Ilumine o ambiente e o seu rosto. Se puder, use um ring light e desligue as luzes do teto. Assim, você ilumina o seu rosto e evita sombras. Caso não tenha um ring light, você pode usar 3 lâmpadas, duas na sua frente e uma atrás de você, voltada para o fundo.',
  REDUCE_NOISE_VIDEO: 'Reduza o eco e outros ruídos.',
  REDUCE_NOISE_VIDEO_DESCRIPTION:
    'Grave seus vídeos em um local silencioso, e desligue equipamentos que podem gerar ruído, tais como ventiladores. Busque reduzir o eco colocando tapetes e móveis no ambiente em que estiver realizando a gravação. Se puder, cubra as paredes com cobertores ou faça uso de espumas acústicas.',
  USE_YOUR_CREATIVITY_VIDEO: 'Improvise, se necessário.',
  USE_YOUR_CREATIVITY_VIDEO_DESCRIPTION:
    'Os participantes não verão o que está por trás das câmeras. Então, se você precisar cobrir a parede com colchões para reduzir o eco, ninguém vai saber 😉',
  REQUIREMENTS_COURSE_VIDEO_1:
    'Filme e exporte em alta definição (HD). Se possível, crie vídeos com resolução de 720p ou 1080p.',
  REQUIREMENTS_COURSE_VIDEO_2:
    'O áudio deve estar sincronizado com o vídeo, e sair dos canais esquerdo e direito.',
  REQUIREMENTS_COURSE_VIDEO_3:
    'O áudio deve ser limpo, sem eco e ruídos de fundo que possam distrair os participantes.',
  COURSE_VIDEO_CHECKBOX:
    'Estou ciente que as configurações dos vídeos devam seguir os requisitos e atender aos padrões de qualidade para ser aprovado.',
  FILMING_EDITING_TITLE: 'Filmagem e edição',
  TIP_COURSE_FILMING_EDITING:
    'Agora é a hora! Depois de estruturar o curso e seguir todas as nossas orientações, você estará pronto para a gravação. Tome o tempo que precisar, tenha calma e vá fazendo pequenos ajustes durante o processo de gravação e edição. Assista ao vídeo e veja as dicas que preparamos para você.',
  FILM_ORGANIZATION: 'Organize o seu roteiro de gravação.',
  FILM_ORGANIZATION_DESCRIPTION:
    'Prepare antecipadamente cada aula e decida quais recursos você irá utilizar – se gravará sua imagem falando, se cobrirá sua imagem com algum recurso audiovisual (por exemplo, um gráfico ou foto), se fará a gravação de uma tela... Isso irá ajudar a organizar a gravação e facilitará o processo de edição.',
  TAKE_BREAK_AND_REVISIONS: 'Faça pausas e revise o que você gravou.',
  TAKE_BREAK_AND_REVISIONS_DESCRIPTION:
    'Verifique com frequência os trechos que estão sendo gravados. Fique atento a variações no nível de ruído ambiente e na iluminação (gravar de dia e de noite). Perceba também seu próprio nível de energia: sinais de cansaço ou fadiga costumam ser perceptíveis na tela.',
  CREATE_CONNECTION_FILMING: 'Conecte-se com seu público.',
  CREATE_CONNECTION_FILMING_DESCRIPTION:
    'Crie uma sensação de proximidade com os participantes do seu curso. Eles querem saber quem está por trás do conteúdo. Grave um vídeo se apresentando, ou apresentando as seções do seu curso. Fale diretamente com o participante, estabelecendo uma linguagem dialógica.',
  BEING_FRONT_CAMERAS_FILMING:
    'Estar na frente das câmeras é algo que demanda prática.',
  BEING_FRONT_CAMERAS_FILMING_DESCRIPTION:
    'Estabeleça contato visual com a câmera e fale claramente. Filme quantas vezes forem necessárias até você acertar.',
  PRACTICE_PRACTICE: 'Pratique, pratique, pratique.',
  PRACTICE_PRACTICE_DESCRIPTION:
    'Um bom resultado no vídeo requer prática. Fale sempre olhando diretamente para a câmera e procure ser claro. Filme quantas vezes for necessário, até que o resultado seja satisfatório.',

  GET_READY_EDIT_FILMING: 'Lembra do roteiro? Ele vai te ajudar na edição.',
  GET_READY_EDIT_FILMING_DESCRIPITION:
    'Você poderá editar pausas mais longas e retirar alguns erros e vícios de linguagem – ‘ãhn’, ‘né’, ‘hum’. Caso precise excluir algum trecho, procure cobrir o corte com alguma imagem ou conteúdo extra. Use seu roteiro como guia para manter a coerência entre os diversos trechos que serão unidos na edição final.',
  CREATE_AUDIO_TAGS_FILMING: 'Crie pontos de corte.',
  CREATE_AUDIO_TAGS_FILMING_DESCRIPTION:
    'Faça pausas longas ou bata palmas entre uma tomada e outra. Bater palmas é um ótimo jeito de criar um pico de áudio que poderá ser facilmente identificado no momento da edição. Deixar pontos claros de corte na gravação facilitará a edição posterior. Lembre-se também de dividir o seu conteúdo em trechos menores, para que você não precise regravar tudo caso cometa algum erro.',
  ORGANIZE_THE_ENVIRONMENT:
    'Se for gravar a sua tela, organize a área de trabalho.',
  ORGANIZE_THE_ENVIRONMENT_DESCRIPTION:
    'Para screencasts, organize previamente a área de trabalho. Não deixe visíveis pastas, arquivos ou programas que não estão relacionados ao conteúdo que será abordado. Deixe preparadas e abertas as janelas que serão utilizadas, e atente para a visibilidade dos recursos, especialmente dos textos (idealmente, com fonte de tamanho superior a 24 pt). Para destacar informações, use zoom.',
  FILMING_CHECKBOX:
    'Estou ciente que as configurações dos vídeos devam seguir os requisitos e atender aos padrões de qualidade para ser aprovado.',
  PROMOTIONS_COURSE: 'Promoções',
  PROMOTIONS_COURSE_TIP:
    'Estatísticas apontam que o percentual de venda aumenta até 70% para os cursos que participam das promoções Sebraeplace.',
  PROMOTIONS_COURSE_DESCRIPTION:
    'Você como fornecedor pode optar ou não por esses serviços a mais. Eles não são obrigatórios. Você pode fazer a opção a cada produto, esse serviço pode ser ativado ou desativado a qualquer momento na tela de configurações do produto.',
  PROMOTIONS_COURSE_OPTION_1: 'Quero participar das promoções Sebraeplace.',
  PROMOTIONS_COURSE_OPTION_2: 'Não quero participar das promoções Sebraeplace.',
  MESSAGE_COURSE_TITLE: 'Mensagens do curso',
  MESSAGE_COURSE_TIP_DESCRIPTION:
    'Organize-se, comece com sua paixão e seu conhecimento. Depois, escolha um tema e planeje suas aulas no Google Docs, Microsoft Excel ou no seu bloco de notas favorito.',
  MESSAGE_COURSE_DESCRIPTION:
    'Escreva mensagens para seus alunos (opcional) que serão enviadas automaticamente por e-mail quando eles se inscreverem ou concluírem seu curso, incentivando-os a interagir com o conteúdo. Se você não quiser enviar mensagens de boas-vindas ou parabenização, deixe a caixa de texto em branco.',
  MESSAGE_COURSE_GOOD: 'Mensagem de Boas-vindas',
  MESSAGE_COURSE_CONCLUSION: 'Mensagem de conclusão',
  MESSAGE_COURSE_OPTIONAL: 'Mensagem opcional',
  MESSAGE_COURSE_CERTIFICATE: 'Certificado',
  ENROLLMENT_NOT_INFORMED: 'Matricula não informada.',
  MESSAGE_COURSE_CERTIFICATE_DESCRIPTION_1:
    'O certificado será enviado de forma automática para o aluno que concluir todas as aulas e executas as atividades propostas.',
  MESSAGE_COURSE_CERTIFICATE_DESCRIPTION_2:
    ' Clique aqui e visualize o certificado do seu curso.',
  DEFINE_TARGET_STUDENT: 'Defina seu público-alvo',
  TIP_TARGET_STUDENTS:
    'As descrições que você inserir nessa página ajudarão os participantes a decidir se o seu curso é o mais adequado para eles. Lembre sempre de inserir informações relacionadas às dores que o seu curso resolve.',
  WHAT_STUDENTS_WILL_LEARN_COURSE: 'O que os alunos aprenderão em seu curso?',
  ADD_FIELD_COURSE: 'Adicionar campo',
  ARE_THERE_PREREQUISITIES_COURSE:
    ' Há algum requisito ou pré-requisito para o curso?',
  WHO_ARE_TARGET_STUDENTS: 'Qual é o seu público-alvo?',
  VIDEO_DEMO_COURSE_TITLE: 'Vídeo demo',
  TIP_COURSE_VIDEO_DEMO:
    'Este é o seu momento! Use todas as dicas dadas pela equipe do Sebraeplace e envie seu vídeo demo para a gente te ajudar a fazer o melhor material.',
  VIDEO_DEMO_DESCRIPTION:
    'Estar seguro da qualidade do seu vídeo é muito importante. Por isso oferecemos a possibilidade de você enviar um vídeo demo das aulas que você está preparando para que possamos avaliar a técnica do seu vídeo e te dar feedbacks. Isso é importante para que problemas técnicos não impactem a aprovação do seu curso depois de todo ele gravado.',
  THIS_STEP_IS_OPTIONAL: 'Esta etapa é opcional.',
  RECORD_DEMO_VIDEO:
    'Grave um vídeo demonstrativo de 3 a 5 minutos da sua aula introdução e nos envie antes de gravar todo o conteúdo que você planejou e organizou. Depois de enviado, aguarde nossos comentários antes de seguir gravando suas aulas.',
  ADD_VIDEO_COURSE: 'Adicionar vídeo',
  ADD_DEMOS_COURSE: 'Enviar demo',
  VIDEO_MUST_QUALITY_STANDART:
    'O vídeo deve atender aos nossos padrões de qualidade para ser aceito:',
  QUALITY_VIDEO_COURSE: 'Vídeos de 720p, ou 1080p;',
  FORMAT_COURSE_FORMAT: 'Estar no formato .mp4, .mov, .wmv ou .avi;',
  AUDIO_NOT_NOISY: 'O áudio não deve ter eco nem ruídos;',
  VIDEO_NGB_ALLOWED: 'Tamanho máximo do arquivo 4GB.',
  FILE_SIZE_IS_GREATER_THAN: 'Tamanho de arquivo excede o limite de {{value}}.',
  FILE_SIZE_GREATER_THAN_NGB: 'Tamanho de arquivo excedido. ',
  VIDEO_SIZE_GREATER_THAN_NGB: 'Os vídeos das aulas possuem uma limitação de ',
  VIDEO_SIZE_GREATER_THAN_NGB_1: '4GB por vídeo/aula',
  VIDEO_SIZE_GREATER_THAN_NGB_2:
    '. Caso seu arquivo ultrapasse este limite, recomendamos revisar a duração e/ou bitrate de compressão dos seus vídeos.',
  I_WANT_COURSE_FREE: 'Quero disponibilizar esse curso gratuitamente.',
  COURSE_PRICE_DESCRIPTION:
    'Organize-se, comece com sua paixão e seu conhecimento. Depois, escolha um tema e planeje suas aulas no Google Docs, Microsoft Excel ou no seu bloco de notas favorito.',
  COURSE_PRICE_DESCRIPTION_2:
    'Defina o preço do seu curso abaixo. Não se preocupe pois você poderá alterar esse valor a qualquer momento, mesmo após a publicação deste curso, além disso, você poderá deixar a divulgação ainda mais atrativa criando cupons de desconto, acessando seu Painel na aba de Produtos.',
  COURSE_PRICE_DESCRIPTION_3:
    'Se você pretende oferecer seu curso gratuitamente, a duração total do conteúdo em vídeo deve ter menos de',
  COURSE_PRICE_DESCRIPTION_3_1: 'horas.',
  PRICE_LABEL_COURSE: 'Preço',
  EXAMPLE_PLACEHOLDER_PRICE_TITLE: 'Digite o preço',
  INITIAL_PAGE_COURSE_TITLE: 'Página inicial do curso',
  TIP_DESCRIPTION_INITIAL_PAGE_COURSE:
    'Organize-se, comece com sua paixão e seu conhecimento. Depois, escolha um tema e planeje suas aulas no Google Docs, Microsoft Excel ou no seu bloco de notas favorito.',
  ABOUT_THE_COURSE_TITLE: 'Sobre o curso',
  ABOUT_THE_COURSE_TITLE_COURSE: 'Título do curso',
  BIO_PLACEHOLDER_INITIAL_PAGE_COURSE: 'Insira um resumo da sua biografia.',
  LEVEL_INITIAL_PAGE_COURSE: 'Nível',
  SUBCATEGORY_INITIAL_PAGE_COURSE: 'Subcategoria',
  DESCRIPTION_COURSE_INITIAL_PAGE: 'Descrição do curso',
  IMAGE_COURSE_INITIAL_PAGE: 'Imagem do curso',
  BIO_INITIAL_PAGE_COURSE: 'Biografia',
  PROFESSION_TITLE_INITIAL_PAGE: 'Profissão ou título',
  ABOUT_INSTRUCTOR_INITIAL_PAGE: 'Sobre o instrutor',
  NAME_LASTNAME_INITIAL_PAGE: 'Nome e sobrenome',
  ADD_VIDEO_INITIAL_PAGE: 'Adicionar vídeo',
  CHANGE_VIDEO_INITIAL_PAGE: 'Alterar vídeo',
  ADD_IMAGE_INITIAL_PAGE: 'Adicionar Imagem',
  CHANGE_IMAGE_INITIAL_PAGE: 'Alterar Imagem',
  DISCLOSURE_VIDEO_INITIAL_PAGE: 'Vídeo de divulgação',
  UNDERSTAND_VIDEO_COURSE: 'Entendi',
  VIDEO_SENT_SUCCESFULL_VIDEO_COURSE: 'Vídeo demo enviado com sucesso',
  VIDEO_DEMO_ANALYZED_SPECIALIZED_TEAM:
    'O vídeo demo será analisado por uma equipe especializada.',
  YOU_WILL_BE_NOTIFIED_COURSE:
    'Em breve você será notificado e receberá um retorno por e-mail sobre a qualidade da sua gravação.',
  WHAT_TO_DO_VIDEO_APPROVED: 'O que fazer após meu vídeo ser aprovado?',
  FOLLOW_RECORDING_REGITERS_VIDEO_COURSE:
    'Siga com as gravações das aulas e complete os próximos passos do cadastro.',
  WHAT_TO_DO_VIDEO_REPROVED: 'O que fazer se meu vídeo for reprovado?',
  DONT_WORRY_FEEDBACK_VIDEO_COURSE:
    'Não se preocupe! Enviaremos um feedback com instruções e dicas de como gravar um vídeo mais assertivo e atender aos requisitos de qualidade. Você poderá gravar um novo vídeo e nos envie novamente.',
  IMAGE_QUALITY_STANDART_INITIAL_PAGE:
    'A imagem deve atender aos nossos padrões de qualidade para ser aceita:',
  MINIMUN_IMAGE_INITIAL_PAGE: 'Ter no mínimo 750 x 422 pixels;',
  FORMAT_IMAGE_INITIAL_PAGE: 'Estar no formato .jpg, .jpeg, .gif ou .png;',
  NO_TEXT_IMAGE_INITIAL_PAGE: 'Não ter nenhum texto na imagem.',
  MINIMUM_IMAGE_PROFILE_INITIAL_PAGE: 'Ter no mínimo 200 x 200 pixels;',
  CLASS_TITLE_MODAL_COURSE: 'Aula',
  CLASS_VIDEO_TITLE_CLASS: 'Vídeo aula',
  CLASS_WRITE_TITLE_CLASS: 'Aula escrita',
  ATTACHMENT_TITLE_COURSE_CLASS: 'Anexo',
  ATTACHMENT_TITLE_COURSE_CLASS_MANY: 'Anexo(s)',
  ATTACHMENT_SUBTITLE_COURSE_CLASS:
    'Você pode anexar arquivos para completar a aula',
  ATTACHMENT_NAME_COURSE_CLASS: 'Nome do anexo',
  ADD_ATTACHMENT_COURSE_CLASS: 'Adicionar anexo',
  ACTIVITY_CLASS_COURSE: 'Atividade',
  CLASS_MENU_COURSE: 'Aula',
  ATTACHMENT_MENU_COURSE: 'Anexo',
  ACTIVITIES_MENU_COURSE: 'Atividades',
  CONTENT_COURSE_MENU_COURSE: 'Conteúdo do curso',
  TIP_COURSE_CONTENT_COURSES:
    'Essa é hora de aplicar todas as dicas que teve até agora,  organize a sequência de aulas conforme a evolução do seu conteúdo.',
  DESCRIPTION_COURSE_1:
    'Comece a montar seu curso criando seções, aulas e atividades práticas. Se você pretende oferecer seu curso gratuitamente, a duração total do conteúdo em vídeo deve ter menos de 2 horas. Ficou com dúvida? Separamos alguns modelos para te inspirar, ',
  DESCRIPTION_COURSE_2: 'clique aqui para ver os exemplos.',
  ADD_CLASS_COURSE: 'Adicionar Aula',
  ADD_ATTACHMENT: 'Anexar arquivo',
  ADD_CONTENT_COURSE: 'Adicionar Conteúdo',
  ADD_SECTION_COURSE: 'Adicionar seção',
  VIDEO_DESCRIPTION_COURSE: 'Descrição do vídeo',
  QUESTION_CONTENT_COURSE: 'Questão',
  OPTIONS_QUESTIONS_CONTENT_COURSE: 'Opções de resposta',
  COMMENT_ABOUT_RIGHT_QUESTION: 'Comentário sobre a alternativa certa',
  REGISTER_NEW_COURSE_ONLINE: 'Cadastrar novo produto',
  SOON_REGISTER_COURSE_ONLINE_MODAL:
    'Em breve você poderá divulgar e vender seu curso online. O Sebraeplace enviará um e-mail informando que seu produto está aprovado e disponível para venda.',
  SOON_REGISTER_COURSE_ONLINE_MODAL_TITLE:
    'Curso online enviado para homologação com sucesso',
  ONLINE_COURSES_TITLE: 'Cursos online',
  ACTIVITIES_MODEL: 'Modelos de atividade',
  USE_CREATIVITY_ACTIVIES_MODEL:
    'Use a criatividade! Alterne entre os modelos de atividade, isso fará com que os seus alunos mantenham o interesse no conteúdo.',
  AFIRMATION_INCOMPLETE_ACTIVITIES_MODAL: 'Afirmação incompleta',
  SUB_TERMS_MODAL: 'Lacuna ou Substituição de Termos',
  MULTIPLE_CHOICE_COMPLEX: 'Múltipla Escolha Complexa',
  MULTIPLE_CHOICE_SIMPLE: 'Múltipla Escolha Simples',
  SERIALIZATION_EXAMPLE_MODAL: 'Seriação',
  PICTURE_INSTRUCTOR_COURSE: 'Foto do perfil',
  STEP_1_EXAMPLE_MODAL:
    'O professor compõe um enunciado comum a frase incompleta e essa será finalizada pela alternativa assinalada.',
  STEP_2_EXAMPLE_MODAL:
    'Questões que implicam o preenchimento de lacunas com uma ou mais palavras chaves que completam corretamente o sentido da afirmação de acordo com uma sequência proposta nas alternativas.',
  STEP_3_EXAMPLE_MODAL:
    'Cada alternativa traz uma ou mais informações que devem ser avaliadas. O elaborador deve redigir de três a cinco afirmações a serem avaliadas pelo aluno.',
  STEP_4_EXAMPLE_MODAL:
    'Elaborar o enunciado como uma frase completa a ser finalizada pela alternativa ou elaborar uma pergunta cuja resposta completa está em uma alternativa',
  STEP_5_EXAMPLE_MODAL:
    'A habilidade de organizar em série exige do aluno habilidade de criar relações sequenciais entre os elementos, de estabelecer organização lógica de eventos e objetivos.',
  TOOLTIP_ACTIVITIES_MODAL:
    'Será exibido ao final do exercício concluído, portanto, explique e justifique a alternativa correta.',
  EXAMPLE_PLACEHOLDER_STUDENT_TARGET_1:
    'Exemplo: Conhecimentos básicos de informática',
  EXAMPLE_PLACEHOLDER_STUDENT_TARGET_2:
    'Exemplo: Empreendedores que desejam criar um site para o seu negócio',
  EXAMPLE_PLACEHOLDER_STUDENT_TARGET_3:
    'Exemplo: Publicar seu site na internet',
  MESSAGE_ERROR_INPUT_FORM: 'O campo deve ter ao menos 3 caracteres.',
  MIN_PRICE_MUST_BE: 'O preço mínimo deve ser de R$ ',
  VIDEO_SENT_DEMO: 'Vídeo enviado em: ',
  ADD_QUESTION_COURSE: 'Adicionar Pergunta',
  SERVICE_PRODUCT_MARKETING:
    'Serviço de Marketing de Afiliados Sebraeplace para este produto:',
  PROGRESS_BY_CLASS: 'PROGRESSO POR AULA',
  WITHDRAWAL_BY_CLASS: 'DESISTÊNCIA POR AULA'
};

const orcamentosSebraetec = {
  SEBRAETEC_ESTIMATE: 'Orçamento Sebraetec',
  WAITING_PROPOSALS: 'Aguardando propostas',
  PROPOSALS_EXPIRED:
    'Suas propostas expiraram. <0>Solicitar nova proposta.</0>',
  NO_PROPOSALS_SENT:
    'Nenhuma proposta recebida. <0>Solicitar nova proposta.</0>',
  CANCELED_PROPOSALS: 'Solicitação cancelada. <0>Solicitar nova proposta.</0>',
  ACTIVE_PROPOSALS: '{{count}} proposta(s) ativa(s)',
  READ_THE_PROPOSALS_WITH_ATTENTION:
    'Leia com atenção as propostas e selecione a que melhor atende as suas necessidades.',
  ON_SELECTING_YOU_WILL_BE_ABLE_TO_CHAT_WITH_THE_SUPPLIER:
    'Após selecionar <0>uma proposta</0>, você poderá prosseguir com o atendimento e conversar com o fornecedor através de um chat.',
  YOU_NEED_TO_WAIT_ALL_PROPOSALS:
    'A escolha será liberada após o limite de propostas ser atingido ou após o prazo para envio de propostas expirar.',
  START_IN_X_BUSINESS_DAYS:
    'O início será em até <0>{{days}}</0> dias úteis após o pagamento.',
  PAYMENT_DEADLINE:
    'O prazo de pagamento após o recebimento da proposta será de até <0>{{days}}</0> dias úteis.',
  PROPOSAL_RECEIPT: 'Sua proposta será recebida em até <0>{{hours}}h</0>.',
  PROPOSAL_ACCEPTANCE: 'Aceite da Proposta',
  REQUEST_NEW_PROPOSALS: 'Solicitar novas propostas',
  REQUEST_NEW_PROPOSALS_WITH_LINK:
    'Se não estiver satisfeito com as propostas acima, você pode <0>solicitar novas propostas</0>. Ao realizar a solicitação, as propostas atuais serão invalidadas e você precisará aguardar que novas propostas sejam enviadas antes de poder aceitar novamente',
  ON_ACCEPTING_THIS_PROPOSAL:
    'Ao aceitar está proposta, você será direcionado para o seu carrinho de compras para realizar o pagamento.',
  ON_ACCEPTING_THIS_PRE_PROPOSAL:
    'Após confirmação do pagamento você poderá conversar com o fornecedor através de um chat para combinar os detalhes que possam ter ficado pendentes.',
  ON_REQUESTING_NEW_PROPOSALS:
    'Ao realizar a solicitação, as propostas atuais serão invalidadas e você precisará aguardar que novas propostas sejam enviadas antes de poder aceitar novamente',
  ON_REQUESTING_NEW_PROPOSALS_AFTER_EXPIRATION:
    'Deseja solicitar novas propostas?',
  OTHER_SUPPLIERS_WILL_BE_NOTIFIED:
    'Os demais fornecedores serão notificados da sua recusa.',
  YOU_DONT_HAVE_ESTIMATES: 'Você ainda não possui solicitações de orçamento',
  ERROR_NOT_FOUND_ESTIMATE: 'Orçamento não encontrado'
};

const solucaoSebraetec = {
  ESTIMATE_SOLICITATION: 'Solicitação de Orçamento',
  REQUEST_ESTIMATE: 'Solicitar orçamento',
  FILL_THE_FIELDS_BELOW_TO_SEND_SOLICITATION:
    'Preencha os campos abaixo para concluir a solicitação.',
  CHOOSE_ESTIMATE_MODE: 'Escolha como deseja ser atendido:',
  REMOTE_ONLINE: 'A distância - online',
  HYBRID_MODE: 'Híbrido (uma parte a distância e uma parte presencial)',
  MINIMUM_QUANTITY_CHARACTERS: 'Quant. min. de {{min}} caractes não atingida.',
  CHOOSE_THE_SOCIAL_NETWORK_TO_SHARE_SEBRAETEC:
    'Escolha a rede social para compartilhar a solução Sebraetec',
  SEBRAETEC_SOLUTION: 'Solução Sebraetec',
  THEME: 'Tema',
  SUBTHEME: 'Subtema',
  OCCUPATION_AREA: 'Área de Atuação',
  LOCATION_REMOTE_OR_IN_PERSON: 'Curitiba, PR e a distância',
  LOCATION_REMOTE: 'A distância',
  LOCATION_IN_PERSON: 'Curitiba, PR',
  BENEFITS_AND_RESULTS: 'Benefícios e resultados esperados',
  TO_BE_DELIVERED: 'Entregas',
  SOLUTION_RATINGS: 'Avaliações da solução',
  MORE_DETAILS_ABOUT_THE_SERVICE:
    'Para obter mais detalhes sobre o serviço disponivel, acesse o descritivo abaixo',
  DOWNLOAD_THE_FULL_DESCRIPTION: 'Baixar descritivo completo',
  SERVICE_CHANNELS: 'Canais de Atendimento',
  SERVICE_CHANNELS_DESC:
    'Fale diretamente com a nossa Central de Atendimento e redes sociais ou entre em contato com a unidade do Sebrae mais próxima de você.',
  WHATSAPP: 'WhatsApp',
  SERVICE_CENTRAL: 'Central de Atendimento',
  IN_PERSON_SERVICE: 'Atendimento presencial',
  AVAILABLE_24_7: 'Disponível 24 horas por dia, 7 dias por semana',
  ACCESS_NOW: 'Acessar agora',
  ACCESS_FIND_SEBRAE: 'Acessar Encontre o Sebrae',
  CALL_0800: 'Ligue 0800 570 0800',
  FIND_THE_CLOSEST_TO_YOU: 'Encontro o ponto mais próximo de você',
  MEET_OUR_PROFESSIONALS: 'Conheça nossos profissionais',
  WAITING_FOR_ESTIMATE: 'Aguardando Orçamento',
  ESTIMATE_REQUESTED_WITH_SUCCESS: 'Orçamento solicitado com sucesso',
  YOU_MUST_BE_LOGGED_IN_AS_CLIENT:
    'É preciso estar logado como cliente para solicitar um orçamento',
  THIS_TECHNICAL_CANNOT_CONTRACTED:
    'Está ficha técnica não pode ser contratada.',
  UNTIL: 'Até',
  PAY_UP_TO: 'Pague até',
  TOTAL_VALUE_WILL_VARY:
    'O valor total do produto será calculado com base nas suas necessidades e preferências solicitadas.',
  SOLUTIONS_ARE_MADE_FOR_COMPANIES:
    'As soluções oferecidas pelo Sebraetec são especialmente desenvolvidas para atender às necessidades das empresas. Forneça ou confirme os dados abaixo para continuar:',
  SELECT_THE_PROFILE: 'Selecione o perfil com que deseja solicitar o orçamento',
  CONFIRM_INFO_BEFORE_SENDING: 'Confirma dos dados antes de continuar',
  THERE_ARE_SEBRAEPAY_PENDENCIES:
    'Existem pendências vinculadas a este cadastro, por favor, entre em contato com o Sebrae para verificar.',
  THIS_COMPANY_REACHED_THE_LIMIT:
    'Essa empresa atingiu o limite de solicitações no período de 365 dias.'
};

const solucoesSebraetec = {
  SEBRAETEC: 'Sebraetec',
  SEBRAETEC_SOLUTIONS: 'Soluções Sebraetec',
  SEBRAETEC_LINKED_SOLUTIONS: 'Soluções vinculadas Sebraetec',
  PENDING_SOLUTIONS: 'Solução pendente',
  LINKED_SOLUTIONS: 'Solução vinculada',
  CONSULT_BY: 'Consultar por',
  ESTIMATE_SOLICITATIONS: 'Solicitações de orçamento',
  FIX_PENDENCIES: 'Corrigir pendências',
  PENDING_REVIEW: 'Aguardando homologação',
  CANCEL_LINK: 'Cancelar vínculo',
  TYPE_WHAT_YOU_ARE_SEARCHING_FOR: 'Digite o que está buscando',
  FILTER_BY_SOLUTION: 'Filtrar por solução',
  NO_SOLUTIONS_LINKED: 'Nenhuma solução vinculada',
  ARE_YOU_SURE_CANCEL_LINK:
    'Tem certeza que deseja cancelar o vínculo desta solução?',
  ARE_YOU_SURE_CANCEL_LINK_DESC:
    'O cancelamento fará com que a solução seja excluída do seu catálogo de produtos. Após o cancelamento, você não receberá mais pedidos de orçamentos relacionados a esta solução',
  ERROR_CANCEL_LINK: 'Erro ao cancelar vínculo, tente novamente',
  READ_WITH_ATTENTION:
    'Leia com atenção as informações enviadas para ter certeza que atende os critérios solicitados.',
  SEND_A_PROPOSITION_AND_WAIT:
    'Envie uma proposta e aguarde a validação do solicitante.',
  IF_YOUR_PROPOSITION_IS_SELECTED:
    'Se a sua proposta for selecionada poderá prosseguir com o atendimento e conversar com o cliente através de um chat.',
  SEE_ADDITIONAL_INFORMATION: 'Ver informações adicionais',
  REQUEST_DETAILS: 'Detalhes da Solicitação',
  ADDITIONAL_INFORMATION: 'Informações adicionais',
  EXPIRY_IN: 'Expira em ',
  IN_DAYS: '{{days}} dia(s)',
  IN_HOURS: '{{hours}} hora(s)',
  IN_MINUTES: '{{minutes}} minuto(s)',
  IN_SECONDS: '{{seconds}} segundo(s)',
  PROPOSITION_REFUSED: 'Proposta recusada',
  ESTIMATE_PROPOSITION: 'Proposta de Orçamento',
  DELIVERY_DEADLINE: 'Prazo de entrega',
  SENT_AT_DATE: 'Data de envio',
  DELIVERY_DEADLINE_WORKING_DAYS: 'Prazo de entrega (dias úteis)',
  WORKING_DAYS: 'dias úteis',
  SEND_PROPOSITION: 'Enviar proposta',
  ADD_RELEVANT_INFORMATION: 'Adicionar informações relevantes se necessário',
  DESCRIPTION: 'Descrição',
  DESCRIPTION_PLACEHOLDER: 'Descreva aqui o objetivo e entregáveis da proposta',
  DELIVERABLES: 'Entregáveis',
  DELIVERABLES_LABEL:
    'Anexe o plano de ação (formato PDF), contendo os entregáveis da proposta de forma detalhada, assegurando que o cliente tenha entendimento e informação sobre o trabalho que receberá',
  UPLOAD_DELIVERABLES: 'Upload dos entregáveis',
  PRICE_MUST_BE_GREATER_THAN: 'O preço deve ser maior que R$ {{price}}',
  PRICE_MUST_BE_LESS_THAN_MAXIMUM:
    'Valor não deve exceder o teto da Solução Sebraetec de {{price}}',
  SEE_INFO_BELOW_BEFORE_SENDING:
    'Confira as informações abaixo antes de enviar a proposta.',
  PROPOSITION_SENT_SUCCESSFULLY: 'Proposta enviada com sucesso!',
  YOUR_PROPOSITION_HAS_BEEN_SENT:
    'Sua proposta para fornecimento da solicitação foi enviada.',
  YOU_WILL_BE_NOTIFIED_BY_EMAIL:
    'Você será notificado por email e através da plataforma sobre a escolha do cliente. Se a sua proposta for selecionada poderá prosseguir com o atendimento e conversar com o cliente através de um chat.',
  BEING_ANSWERED: 'Em atendimento',
  RETURN_COMPLETED: 'Devolução Concluída',
  RETURN_IN_ANALYSIS: 'Devolução em análise',
  WAITING_CHOICE: 'Aguardando seleção do cliente',
  SEND_THE_INVOICE: 'Envie a nota fiscal',
  WAITING_INVOICE_REVIEW: 'Nota fiscal em análise',
  INVOICE_REJECTED: 'Nota Fiscal reprovada',
  REVIEW_INVOICE: 'Revisar nota fiscal',
  DONE: 'Concluído',
  EXPIRED_BY_DATE:
    'A solicitação de orçamento expirou pois o prazo limite de {{days}} dias para enviar uma proposta foi excedido.',
  EXPIRED_BY_LIMIT_OF_PROPOSITIONS:
    'A solicitação de orçamento expirou pois o limite de propostas enviadas por fornecedores foi atingido.',
  EXPIRED_BY_SEND_PROPOSITION_OTHER_COMPANY:
    'Já existe uma proposta enviada por este CPF com outra empresa. Não é possível enviar novas propostas.',
  USER_DIDNT_SELECT_PROPOSITION:
    'O cliente perdeu o prazo para escolher uma proposta.',
  YOU_REACHED_MAXIMUM_OF_PROPOSALS:
    'Você atingiu o limite de orçamentos em andamento',
  WAITING_CLIENT_CONFIRMATION: 'Aguardando confirmação do cliente',
  CONFIRM_CONCLUSION: 'Confirmar conclusão',
  ANSWER_SEBRAETEC: 'Atender',
  DISPUTE_CANCEL: 'Contestar',
  DISPUTE_RETURN_REQUEST: 'Contestar Devolução',
  CONFIRM_RETURN_REQUEST: 'Confirmar Devolução',
  LOOK_AT_THE_DETAILS_BEFORE_CONFIRMING_RETURN:
    'Confira as informações abaixo antes de confirmar a devolução',
  JUSTIFICATION_OF_THE_DISPUTE: 'Justificativa da contestação',
  JUSTIFICATION_OF_THE_DISPUTE_ALT: 'Justificativa de contestação',
  JUSTIFICATION_OF_THE_DISPUTE_DESC_1:
    'Sua justificativa de Contestação da devolução foi enviada.',
  JUSTIFICATION_OF_THE_DISPUTE_DESC_2:
    'Em breve será notificado por email e através da plataforma sobre o andamento da análise realizada por nossa equipe de suporte em relação à sua solicitação.',
  LOOK_AT_THE_DETAILS_BEFORE_CONFIRMING_DISPUTE:
    'Confira as informações abaixo antes de enviar a contestação',
  INVOICE_STATUS_APPROVED: 'Aprovada',
  INVOICE_STATUS_REJECTED: 'Reprovada',
  INVOICE_STATUS_PENDING: 'Aguardando Aprovação',
  SEE_MESSAGE: 'Ver mensagem'
};

const cadastroSebraetec = {
  SEBRAETEC_REGISTRATION: 'Cadastro Sebraetec',
  REGISTRATION_WITH_PENDENCIES: 'Seu cadastro possui pendências',
  REASONS_FOR_REPROVING: 'Motivos da reprovação',
  ASTRONAUT_ALT: 'Astronauta',
  MAN_IN_A_MEETING: 'Homem em uma reunião',
  ACCEPT_TERMS_USE_SEBRAETEC:
    'Aceito os <0>termos de uso</0> para fornecedor Sebraetec da plataforma.',
  BUDGET_RETURNS: 'Devolutivas de orçamentos',
  BUDGET_RETURNS_DESC:
    'Dedique um tempo para responder os clientes que solicitarem orçamento. Os clientes receberão apenas os {{qtd}} orçamentos de menor valor, então fique de olho nas suas notificações e email.',
  SELECT_THE_SEBRAETEC_SOLUTION:
    'Selecione a Solução Sebraetec que deseja atender',
  SELECT_THE_SEBRAETEC_SOLUTION_DESCRIPTION:
    '<0>Consulte o descritivo completo para confirmar sua área de atuação.</0><1>Você poderá se credenciar a mais de um serviço, lembrando que para cada um deles é exigido as devidas comprovações.</1>A equipe de curadoria, fará a análise, considerações se houver e a validação para que sua empresa fique habilitada para prestar serviços.',
  SEBRAETEC_DOWNLOAD_SHEET: 'Baixar Descritivo',
  COMPANIES_DOCUMENTS_AND_CERTIFICATES:
    '<0>Documentos e Certidões</0>da Empresa',
  COMPANIES_DOCUMENTS_AND_CERTIFICATES_DESCRIPTION:
    'Agora preencha os dados e anexe os documentos solicitados.',
  ATTACH_FGTS: 'Anexar Certidão de FGTS',
  ATTACH_INSS: 'Anexar Certidão de INSS',
  ATTACH_NEGATIVE: 'Anexar Certidão Negativa',
  SEBRAETEC_UPLOAD: 'Upload',
  EXPIRY_DATE: 'Data de vencimento',
  RECENT_PROJECTS_AND_EXPERIENCE:
    '<0>Projetos Recentes e</0>Demonstrativo de Experiência',
  AREA_SELECTED: 'Área de atuação selecionada',
  ATTACH_BELOW_EVIDENCES_OF_THE_LAST_TWO_PROJECTS:
    'Anexe no campo abaixo evidências dos dois últimos projetos realizados pela empresa mostrando a sua experiência na área de atuação que selecionou.',
  PROJECT: 'Projeto',
  EVIDENCE: 'Evidência',
  CUSTOMER_MESSAGE: 'Mensagem do cliente',
  SEND_EVIDENCES: 'Envie suas evidências',
  EVIDENCE_UPLOAD: 'Upload da evidência',
  ATTACH_ADDITIONAL_PROPOSAL_CERTIFICATIONS:
    'Anexe as certificações adicionais relacionadas à execução da proposta',
  PROJECT_DESCRIPTION: 'Descrição do projeto',
  CLIENT_DATA: 'Dados do cliente',
  LEGAL_REPRESENTATIVE: 'Representante legal',
  CONCLUSION_DESCRIPTION:
    'Você cumpriu as etapas para solicitação de vinculo a uma Solução Sebraetec e encontra-se em status de análise, <0>aguarde a homologação Sebraeplace.</0> Fique de olho no seu e-mail e nas notificações do seu painel. <1>Enquanto aguarda escolha umas das opções abaixo:</1>',
  ERROR_ON_REGISTRATION: 'Erro ao fazer cadastro, tente novamente',
  ERROR_ON_EVIDENCE_UPLOAD: 'Erro ao fazer upload da evidência ',
  TYPES_AND_MAX_SIZE: '*PDF, max. 100mb',
  FINALIZE_REGISTRATION: 'Finalizar cadastro',
  SEBRAETEC_UPDATES_WILL_BE_SENT:
    'As atualizações do Sebraetec serão enviadas para os seguintes contatos:',
  YOU_CAN_CHANGE_THIS_INFORMATION_ON_REGISTRATION_INFO_PAGE:
    'Se for necessário alterar essas informações, você podera fazer isso na página de dados cadastrais da sua empresa, após finalizar o cadastro.'
};

const notasFiscais = {
  HISTORY_OF_SENT_INVOICES: 'Histórico de notas fiscais enviadas.',
  INVOICES_PLURAL: 'Notas fiscais',
  ATTACH_INVOICE: 'Anexar nota fiscal',
  INVOICE_UPLOAD: 'Upload da Nota Fiscal',
  MAKE_INVOICE_UPLOAD: 'Faça upload da nota fiscal',
  MAKE_UPLOAD_SIMPLES_NATIONAL_DECLARATION:
    'Faça upload da declaração do simples nacional',
  ERROR_ON_NF_UPLOAD: 'Erro ao fazer upload da nota fiscal, tente novamente',
  DESCRIPTION_COMISSIONED_SERVICE: 'Descrição do serviço comissionado',
  DATA_ABOUT_DELIVERY: 'Dados sobre a entrega',
  LIMIT_OF_HOURS_WARNING:
    'O limite total de horas de consultoria é de {{total_limit}} horas, com um limite {{daily_limit}} horas por dia.',
  TAX_INFORMATION: 'Informações fiscais',
  COMPLETION_DATE: 'Data da Conclusão',
  NUMBER_SERVICE_HOURS: 'Quantidade de Horas do Serviço',
  NUMBER_HOURS_PER_DAY: 'Quantidade de Horas por Dia',
  NAME_CORPORATE_NAME: 'Nome/Razão social:',
  CITY_REGISTRATION: 'Inscrição municipal',
  CPF_CNPJ_INVOICE: 'CPF/ CNPJ:',
  REPRESENTATIVE_NAME: 'Nome representante:',
  STATE_SUBSCRIPTION: 'Inscrição estadual:',
  FISCAL_ADDRESS: 'Endereço fiscal',
  SIMPLES_DECLARATION: 'Declaração de Simples Nacional',
  OPTING_IN_SIMPLES:
    'Informe se é optante pelo Simples Nacional. <0>Clique aqui</0> para saber mais.',
  APPENDIX_4: 'Anexo IV',
  SIMPLES_INFO:
    'Da Instrução Normativa SRF nº 480, de 15 de dezembro de 2004<0>DECLARAÇÃO A SER APRESENTADA PELA PESSOA JURÍDICA CONSTANTE NO INCISO XI DO ART 3º</0><0>Ao.</0>Serviço de Apoio às Micro e Pequenas Empresas do Paraná - SEBRAE<0>{{razaoSocial}} ME, com sede {{endereco}}, inscrita no CNPJ sob o nº {{cnpj}} DECLARA á {{entidadePagadora}}, para fins de não incidência na fonte do Imposto sobre a Renda da Pessoa Jurídica (IRPJ), da Contribuição Social sobre o Lucro Líquido (CSLL), da Contribuição para o Financiamento da Seguridade Social (Cofins), e da Contribuição para o PIS/Pasep, a que se refere o art. 64 da Lei nº 9.430, de 27 de dezembro de 1996, que é regularmente inscrita no Regime Especial Unificado de Arrecadação de Tributos e Contribuições devidos pelas Microempresas e Empresas de Pequeno Porte - Simples Nacional, de que trata o art. 12 da Lei Complementar nº 123, de 14 de dezembro de 2006.</0><0>Para esse efeito, a declarante informa que:</0><0>I - Preenche os seguintes requisitos:</0><0>a) conversa em boa ordem, pelo prazo de cinco anos, contado da data da emissão, os documentos que comprovam a origem de suas receitas e efetivação de suas despesas, bem assim a realização de quaisquer outros atos ou operações que venham a modificar sua situação patrimonial;</0><0>b) cumpre as obrigações acessórias a que está sujeita, em conformidade com a legislação pertinente;</0><0>II - O signatário é representante legal da empresa, assumindo o compromisso de informar à Secretaria da Receita Federal do Brasil e à entidade pagadora, imediatamente, eventual desenquadramento da presente situação e está ciente de que a falsidade na prestação destas informações, sem prejuízo do disposto no art. 32 da Lei nº 9.430, de 1996, o sujeitará, juntamente com as demais pessoas que para ela concorrem, às penalidades previstas na legislação criminal e tributária, relativas à falsidade ideológica (art. 299 do Código Penal) e ao crime contra a ordem tributária )art. 1ª da Lei nº 8.137, de 27 de dezembro de 1990.</0>',
  I_AM_OPTING_IN_SIMPLES: 'Sou optante pelo Simples Nacional',
  I_AM_NOT_OPTING_IN_SIMPLES: 'Não sou optante pelo Simples Nacional',
  INVOICE_XML_PDF: 'A nota fiscal deve ser enviada em formato PDF.',
  INVOICE_PDF_XML_REQUIRED: 'A nota fiscal deve ser enviada em formato XML.',
  INVOICE_XML_REQUIRED:
    'A nota fiscal deve ser obrigatoriamente enviada em formato XML.',
  INVOICE_PDF_REQUIRED:
    'A nota fiscal deve ser obrigatoriamente enviada em formato PDF.',
  SEBRAETEC_CANT_UPLOAD_IN_THE_LAST_DAYS_OF_THE_MONTH:
    'O Sebraetec não aceita o envio de notas fiscais nos últimos {{dias}} dias úteis do mês.',
  NF_MODAL_TITLE: 'Importante',
  NF_MODAL_REQUIRED_INFO_TITLE: 'Informações indispensáveis na Nota Fiscal',
  NF_REQUIRED_1:
    'A nota fiscal deve ser emitida tendo o Sebrae como tomador do serviço',
  NF_REQUIRED_2: 'Descrição detalhada e natureza dos serviços prestados',
  NF_REQUIRED_3: 'Número da proposta correspondente',
  NF_REQUIRED_4: 'Total de horas realizadas',
  NF_REQUIRED_5: 'Cidade onde o serviço foi prestado',
  NF_REQUIRED_6: 'Valor total bruto da nota fiscal',
  NF_REQUIRED_7:
    'Destaque das retenções de impostos e contribuições conforme legislação vigente',
  NF_MODAL_PAYMENT_PROCESS_TITLE: 'Processo de Pagamento',
  NF_MODAL_PAYMENT_TRANSFERS:
    'Os <0>repasses</0> ocorrem às terças e quintas-feiras, com exceção da primeira terça-feira e da última quinta-feira de cada mês.',
  NF_MODAL_PAYMENT_REJECTION:
    'Em caso de <0>reprovação</0> você receberá uma notificação via sistema ou e-mail detalhando o motivo. A correção e o reenvio devem ser feitos imediatamente.',
  NF_MODAL_CONFIRM_READ:
    'Li e compreendo todos os critérios e prazos informados.',
  INVOICE_HAS_PENDENCIES: 'A nota fiscal enviada foi reprovada',
  CHECK_THE_REASON_AND_SEND_AGAIN: 'Confira a justificativa e anexe novamente.',
  JUSTIFICATION: 'Justificativa',
  INVALID_CERTIFICATES:
    'As certidões de FGTS ou INSS estão vencidas ou não foram enviadas. Por favor, atualize as certidões pendentes para que seja possível realizar o upload da nota fiscal.',
  UPDATE_CERTIFICATES: 'Atualizar Certidões'
};

const cupons = {
  AFFILIATE_MARKETING_AND_SEBRAEPLACE_DISCOUNT_COUPONS:
    'Marketing de Afiliados e Cupons de desconto Sebraeplace',
  AFFILIATE_MARKETING_CAMPAIGNS_AND_SEBRAEPLACE_DISCOUNT_COUPONS:
    'Marketing de Afiliados, Campanhas e Cupons de desconto Sebraeplace',
  MARKETING_CAMPAIGNS_AND_SEBRAEPLACE_DISCOUNT_COUPONS:
    'Campanhas e Cupons de desconto Sebraeplace',
  AFFILIATE_MARKETING_AND_SEBRAEPLACE_DISCOUNT_COUPONS_DESCRIPTION:
    'Você como fornecedor pode optar ou não por esses serviços a mais. Eles não são obrigatórios. Você pode fazer a opção a cada produto, esse serviço pode ser ativado ou desativado a qualquer momento na tela de configurações do produto.',
  SEBRAEPLACE_DISCOUNT_COUPONS: 'Cupons de desconto Sebraeplace',
  SEBRAEPLACE_DISCOUNT_COUPONS_ACCEPT:
    'Ao aceitar participar dos cupons lançados no Sebraeplace, o desconto no valor do seu produto será calculado e ativado automaticamente, estes descontos limitam-se a',
  SELECT_A_DISCOUNT_TYPE: 'Selecione um tipo de desconto',
  TYPE_OF_DISCOUNT: 'Tipo de desconto',
  LINKED_PLAN: 'Plano vinculado',
  SELECT_THE_PLAN: 'Selecione o plano',
  COUPON_VALUE_MUST_BE_LESS_THAN: 'O valor do cupom deve ser menor que ',
  THE_DISCOUNT_PERCENTAGE_MUST_BE_BETWEEN:
    'O percentual de desconto deve ser entre',
  I_WANT_TO_PARTICIPATE_IN_CAMPAIGNS_AND_DISCOUNT_COUPONS:
    'Quero participar das Campanhas e Cupons de desconto',
  I_DO_NOT_WANT_TO_PARTICIPATE_IN_CAMPAIGNS_AND_DISCOUNT_COUPONS:
    'Não quero participar das Campanhas e Cupons de desconto'
};

const camera_upload_photo = {
  OPEN_CAMERA: 'Abrir Câmera',
  UPLOAD_THE_PHOTO: 'Faça o Upload',
  CAPTURE_PHOTO: 'Capturar foto',
  CAPTURE_PHOTO_AGAIN: 'Tirar Novamente',
  CONFIRM_PHOTO: 'Confirmar foto',
  SELECT_IMAGE: 'Selecionar imagem',
  PERMISSION_TO_ACCESS_CAMERA_DENIED:
    'Permissão para acessar a câmera foi negada.',
  CAMERA_ACCESS_ERROR: 'Erro ao acessar a câmera:'
};

export const pt_BR = {
  ...home,
  ...painel,
  ...shared,
  ...alertas,
  ...carteira,
  ...dados_cadastrais,
  ...checkout,
  ...checkoutSebraepay,
  ...carrinho,
  ...catalogo,
  ...planos,
  ...consultor,
  ...evento,
  ...negociacao,
  ...produto,
  ...produtos,
  ...consultoria,
  ...cadastro,
  ...extrato,
  ...meuPlano,
  ...perfil,
  ...footer,
  ...faq,
  ...cardPayment,
  ...cardPlan,
  ...carrinhoComponent,
  ...comentarios,
  ...facaParteSaas,
  ...header,
  ...homeAfiliado,
  ...homeSebraetec,
  ...homeCursos,
  ...inscricao,
  ...inscricaoDois,
  ...listAvatar,
  ...listPlans,
  ...redesSociais,
  ...favoritos,
  ...satisfacao,
  ...cadastroEvento,
  ...minhasCompras,
  ...minhasVendas,
  ...favoritos,
  ...ingresso,
  ...dadosIngressos,
  ...profissionais,
  ...participantes,
  ...perguntasRespostas,
  ...saasLanding,
  ...cadastroSaas,
  ...saas,
  ...cupom,
  ...afiliados,
  ...cursos,
  ...cadastroCurso,
  ...orcamentosSebraetec,
  ...solucaoSebraetec,
  ...solucoesSebraetec,
  ...cadastroSebraetec,
  ...notasFiscais,
  ...cupons,
  ...camera_upload_photo
};
